const Library_mobile_uk = {
  "processor": [
    {
      "contentType": "OTHER_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Оснащено процесором [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_PROCESSORS_A",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Оснащено процесором [cpuDisplay]"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "FALLBACK_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "Як і мозок, процесор контролює роботу вашого ПК. Це означає, що відео, які ви переглядаєте, ігри, в які граєте, вебсайти, які ви відвідуєте — все починається з процесора.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Процесор — наче мозок вашого ПК"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHER_OLD_PROCESSORS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_title": "Швидкодія і ціна.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процесор Intel® Pentium® Silver",
                    "tr_subtitle": "Залишайтеся на вершині цифрового світу завдяки можливості швидкого доступу до файлів із мережі. Проста робота в режимі багатозадачності завдяки легкому перемиканню між програмами й швидшому виконанню завдань.",
                    "tr_gen_core_title": "Процесор Intel® Pentium® Silver"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процесор Intel® Pentium® Gold",
                    "tr_subtitle": "Підвищена продуктивність&nbsp;— ще краща швидкодія, яка допомагає вам легко виконувати завдання в найзавантаженіші дні. Спрощений перегляд вебсайтів&nbsp;— швидке завантаження насичених мультимедіа вебсторінок, щоб ви могли більше дізнатися за коротший час.",
                    "tr_gen_core_title": "Процесор Intel® Pentium® Gold"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процесор Intel® Celeron®",
                    "tr_subtitle": "Продуктивність, що створює більше можливостей для роботи й розваг. Переглядайте фільми й онлайн-відео з дивовижною деталізацією. Очікуйте менше, займайтеся справою більше.",
                    "tr_gen_core_title": "Процесор Intel® Celeron®"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Процесор Intel® Pentium®",
                    "tr_subtitle": "Створено для розваг, перегляду відео в інтернеті й ефективної роботи. Переглядайте фільми й онлайн-відео з дивовижною деталізацією. Очікуйте менше, займайтеся справою більше.",
                    "tr_gen_core_title": "Процесор Intel® Pentium®"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CELERON_2.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_PENTIUM_2.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_INSIDE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/intel_inside/intel_inside_processor_badge.svg",
                "tileBG": "assets/images/intel_inside/intel_inside_home_tile.svg",
                "detailBGUrl": "assets/images/intel_inside/panel1_bg.svg",
                "tr_subtitle": "Продуктивність, яка вам потрібна. Доступність, якої ви бажаєте.",
                "tr_title": "Процесор Intel®",
                "panelType1": "header-IconTop",
                "panelType2": "intel-inside-image-panel",
                "titleArray": [
                  {
                    "tr_title": "",
                    "tr_pretitle": "Особлива категорія цінностей",
                    "tr_subtitle": "Процесор Intel® може впоратися практично з будь-яким потрібним вам завданням за доступною для вас ціною. Легко переходьте від однієї програми до іншої або насолоджуйтеся високоякісною графікою зі стабільною продуктивністю.",
                    "imageUrl": "assets/images/intel_inside/panel2_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Встановіть надійніший зв’язок ",
                    "tr_subtitle": "Більш яскраве і якісне відео, чіткіший звук та майже втричі швидше підключення до Інтернету забезпечують можливість впевнено працювати будь-де та будь-коли<sup>26</sup>.",
                    "imageUrl": "assets/images/intel_inside/panel3_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "tr_pretitle": "Різниця як між днем і ніччю",
                    "tr_subtitle": "Ранковий кіномарафон або ретушування в останню хвилину? Чим би ви не займалися, процесор Intel® подовжує ресурс акумулятора пристрою, даруючи чудові враження.",
                    "imageUrl": "assets/images/intel_inside/panel4_bg.svg"
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "Будь-яке оточення підходить для навчання",
                    "tr_subtitle": "Працюйте з різними інструментами для онлайн-навчання з будь-якого куточка свого дому."
                  },
                  {
                    "tr_title": "",
                    "imageUrl": "assets/images/intel_inside/panel5_bg.svg",
                    "tr_pretitle": "Навчайтеся там, де забажаєте",
                    "tr_subtitle": "Отримуйте знання, коли потрібно, навіть запустивши декілька навчальних платформ одночасно."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CELERON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Отримайте потужність для розваг і продуктивність відповідно до вашого бюджету та стилю життя.",
                "tr_title": "Продуктивність Intel на будь-який гаманець.",
                "tr_gen_core_title": "Процесор Intel® Celeron®",
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПОТРІБНИЙ РІВЕНЬ ШВИДКОДІЇ ТА ЦІНИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CELERON_3.svg",
                      "tr_imgCaption": "Процесор Intel® Celeron®"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процесор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Швидкий перегляд вебсторінок з численними файлами мультимедіа",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Легке перемикання між програмами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Казуальні ігри",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція відео з роздільною здатністю 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Просте редагування фото та відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Висока швидкодія та інтелектуальна продуктивність",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "7GEN_BELOW_PROCESSOR",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/[cup_badge].svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "genType": "7Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 7-го&nbsp;покоління"
                  },
                  {
                    "genType": "6Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 6-го&nbsp;покоління"
                  },
                  {
                    "genType": "5Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 5-го&nbsp;покоління"
                  },
                  {
                    "genType": "4Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 4-го&nbsp;покоління"
                  },
                  {
                    "genType": "3Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 3-го&nbsp;покоління"
                  },
                  {
                    "genType": "2Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 2-го&nbsp;покоління"
                  },
                  {
                    "genType": "1Gen",
                    "tr_title": "На базі процесора Intel® Core™ [cpu_fam] 1-го&nbsp;покоління"
                  }
                ],
                "processorCompare": {
                  "tr_title": "",
                  "background": "",
                  "tr_tableHead": [
                    "Рекомендоване застосування:",
                    "<span><img src=></span>",
                    "<span><img src=></span>"
                  ],
                  "tabletr": [
                    {
                      "tr_row": "",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базі процесора Intel® Core™ i3 8-го покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 8&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесори Intel® Core™ 9-го покоління було створено з урахуванням актуальних потреб цифрового світу. Їхнє оптимальне поєднання швидкості та продуктивності дасть вам змогу ефективніше використовувати можливості свого ПК без будь-яких розчарувань.",
                "tr_title": "На базі процесора Intel® Core™ i3 9-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 9&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Універсальність, продуктивність і збільшений ресурс акумулятора забезпечують чудову роботу, де б ви не були.",
                "tr_title": "Енергія на весь день",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 10&#8209;го покоління",
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ РІВЕНЬ ПРОДУКТИВНОСТІ ПРОЦЕСОРА 10-ГО ПОКОЛІННЯ, ЩО ПІДІЙДЕ САМЕ ВАМ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Перегляд фільмів онлайн у форматі 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Швидке й надійне підключення",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Робота з масками зображень і застосування відеофільтрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Можливість грати з роздільною здатністю 1080p з високою частотою кадрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Оптимальний вибір для роботи з великими файлами й програмами для творчості",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Перемикайтеся між переглядом фільмів онлайн та створенням презентацій ще швидше без шкоди для ефективності.",
                "tr_title": "Енергія на весь день",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 10&#8209;го покоління"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук розроблено спеціально для тих, хто завжди в дорозі.",
                "tr_title": "Зустрічайте новий клас ноутбуків",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 10&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процесор Intel® Core™ i3 11-го покоління, призначений для портативних ПК, дасть вам змогу виконувати більше завдань будь-де.",
                "tr_title": "Досягайте більшого з новим ноутбуком",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i3 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Якщо ви шукаєте один настільний ПК для всієї родини, вам потрібен потужний та універсальний процесор Intel® Core™ i3 11-го покоління.",
                "tr_title": "Будьте готові до будь-яких завдань завдяки революційній продуктивності.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i3 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_6.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базі процесора Intel® Core™ i5 8-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 8&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесори Intel® Core™ 9-го покоління було створено з урахуванням актуальних потреб цифрового світу. Їхнє оптимальне поєднання швидкості та продуктивності дасть вам змогу ефективніше використовувати можливості свого ПК без будь-яких розчарувань.",
                "tr_title": "На базі процесора Intel® Core™ i5 9-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 9&#8209;го покоління"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ПЛАВНИЙ ІГРОВИЙ ПРОЦЕС І ВІРТУАЛЬНА РЕАЛЬНІСТЬ У НАЙВИМОГЛИВІШИХ ІГРАХ",
                "tr_title": "Серйозні ігри починаються тут",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 9&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Легко працюйте в режимі багатозадачності протягом усього дня.",
                "tr_title": "Багатозадачність у дорозі",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління",
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ РІВЕНЬ ПРОДУКТИВНОСТІ ПРОЦЕСОРА 10-ГО ПОКОЛІННЯ, ЩО ПІДІЙДЕ САМЕ ВАМ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Перегляд фільмів онлайн у форматі 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Швидке й надійне підключення",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Робота з масками зображень і застосування відеофільтрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Можливість грати з роздільною здатністю 1080p з високою частотою кадрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Оптимальний вибір для роботи з великими файлами й програмами для творчості",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Оптимізуйте всі розваги, ресурсоємні завдання та створення контенту.",
                "tr_title": "Переходьте на потужніший ПК",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук розроблено спеціально для тих, хто завжди в дорозі.",
                "tr_title": "Зустрічайте новий клас ноутбуків",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Розроблений для безперервної трансляції та ігор класу ААА",
                "tr_title": "Грайте за власними правилами",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Розроблений для безперервної трансляції та ігор класу ААА",
                "tr_title": "Грайте за власними правилами",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоків: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Легко працюйте в режимі багатозадачності протягом усього дня.",
                "tr_title": "Багатозадачність у дорозі",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 10&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 10‑ГО&nbsp;ПОКОЛІННЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процесор Intel® Core™ i5 11-го покоління забезпечує вражаюче відтворення відео й швидке виконання різноманітних завдань на найтонших і найлегших ПК.",
                "tr_title": "Виняткова потужність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Якщо ви шукаєте один настільний ПК для всієї родини, вам потрібен потужний та універсальний процесор Intel® Core™ i5 11-го покоління.",
                "tr_title": "Будьте готові до будь-яких завдань завдяки революційній продуктивності.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i5_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесор Intel® Core™ i5 11-го покоління забезпечує найкращі враження від графіки й швидке виконання різноманітних завдань на тонких і легких ноутбуках.",
                "tr_title": "Виняткова потужність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5 11-ГО ПОКОЛІННЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_6.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "tr_title": "На базі процесора Intel® Core™ i7 8-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 8&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Процесори Intel® Core™ 9-го покоління було створено з урахуванням актуальних потреб цифрового світу. Їхнє оптимальне поєднання швидкості та продуктивності дасть вам змогу ефективніше використовувати можливості свого ПК без будь-яких розчарувань.",
                "tr_title": "На базі процесора Intel® Core™ i7 9-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 9‑го&nbsp;покоління"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 32% БІЛЬША ЧАСТОТА КАДРІВ під час ігор, трансляції та запису в порівнянні з ТРИРІЧНИМ ПК<sup>3</sup>",
                "tr_title": "Потужність, яка дає змогу поділитися своїми найбільш вражаючими ігровими моментами",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 9‑го&nbsp;покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_7.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_8",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Цей тонкий потужний пристрій змусить вас по-новому поглянути на творчі можливості, швидкість трансляції та з’єднання.",
                "tr_title": "Максимальна продуктивність будь-де",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління",
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ РІВЕНЬ ПРОДУКТИВНОСТІ ПРОЦЕСОРА 10-ГО ПОКОЛІННЯ, ЩО ПІДІЙДЕ САМЕ ВАМ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Перегляд фільмів онлайн у форматі 4K",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Швидке й надійне підключення",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Робота з масками зображень і застосування відеофільтрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Можливість грати з роздільною здатністю 1080p з високою частотою кадрів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Оптимальний вибір для роботи з великими файлами й програмами для творчості",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Максимальна продуктивність, яка допоможе вам вивести будь-яку діяльність на наступний рівень.",
                "tr_title": "Ви можете робити все",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління"
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук розроблено спеціально для тих, хто завжди в дорозі.",
                "tr_title": "Зустрічайте новий клас ноутбуків",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Відчуйте конкурентну якість ігор, трансляцій та запису",
                "tr_title": "Виведіть ігри на новий рівень",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Відчуйте конкурентну якість ігор, трансляцій та запису",
                "tr_title": "Виведіть ігри на новий рівень",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоків: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Розроблений для ефективності, цей вишуканий пристрій може суттєво вплинути на процес вашої творчості, підключення та трансляції.",
                "tr_title": "Чудова продуктивність за будь-яких умов",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 10‑ГО&nbsp;ПОКОЛІННЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процесор Intel® Core™ i7&nbsp;11-го покоління дає змогу створювати професійний контент, без проблем грати в ігри, а також виводить розваги на ультрапортативних ПК на новий рівень.",
                "tr_title": "Безмежна продуктивність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_laptop_11gen.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Ваш настільний ПК стане універсальним домашнім інструментом завдяки революційній продуктивності процесора Intel® Core™ i7 11-го покоління.",
                "tr_title": "Працюйте. Навчайтеся. Грайте. Без меж.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i7_uwp_tile_badge_desktop_11gen.png"
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесор Intel® Core™ i7 11-го покоління дає змогу створювати професійний контент, без проблем грати в ігри, а також виводить на новий рівень розваги на тонких і легких ноутбуках.",
                "tr_title": "Безмежна продуктивність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ваш настільний ПК стане універсальним домашнім інструментом завдяки революційній продуктивності процесора Intel® Core™ i7 11-го покоління.",
                "tr_title": "Творіть без обмежень",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_1195G7",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Цей процесор Intel® Core™ i7 11-го покоління став ще кращим завдяки можливостям створення професійного контенту, ігор без проблем і розвагам нового рівня на тонких і легких ноутбуках.",
                "tr_title": "Безмежна продуктивність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "На базі процесора Intel® Core™ i9 8-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 8&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_7.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесори Intel® Core™ 9-го покоління було створено з урахуванням актуальних потреб цифрового світу. Їхнє оптимальне поєднання швидкості та продуктивності дасть вам змогу ефективніше використовувати можливості свого ПК без будь-яких розчарувань.",
                "tr_title": "На базі процесора Intel® Core™ i9 9-го&nbsp;покоління",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 9‑го&nbsp;покоління"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 41% БІЛЬША ЧАСТОТА КАДРІВ під час ігор, трансляції та запису в порівнянні з ТРИРІЧНИМ ПК<sup>4</sup>",
                "tr_title": "Геймери прагнуть. Intel® Core™ i9 дає можливість.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 9‑го&nbsp;покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_7.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_8",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Вийдіть за рамки й досягніть максимального задоволення від гри",
                "tr_title": "Змагайтеся на найвищому рівні",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Вийдіть за рамки й досягніть максимального задоволення від гри",
                "tr_title": "Змагайтеся на найвищому рівні",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоків: 20</span>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_8.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Вийдіть за рамки й досягніть максимального задоволення від творчості",
                "tr_title": "Творіть на найвищому рівні",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i9 10‑ГО&nbsp;ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I5_5.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбуки Intel® Evo™ на базі процесора Intel® Core™ i5 11-го покоління і графіки Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> дають вам неймовірну швидкість та потужність, і все це в тонкому й легкому корпусі.",
                "tr_title": "Підвищена потужність для ноутбуків нового рівня",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I7.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i7-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбуки Intel® Evo™ з процесором Intel® Core™ i7 11-го покоління і графікою Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> дають змогу отримати найкращі враження від роботи на мобільних пристроях завдяки вищій швидкості та продуктивності.",
                "tr_title": "Покращена потужність для вдосконаленого ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/11gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_SILVER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Насолоджуйтесь чудовим балансом продуктивності, відтворенням мультимедійних файлів і підключенням до Інтернету за привабливою ціною.",
                "tr_title": "Швидкодія та можливості підключення за неймовірною ціною.",
                "tr_gen_core_title": "Процесор Intel® Pentium® Silver",
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПОТРІБНИЙ РІВЕНЬ ШВИДКОДІЇ ТА ЦІНИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "Процесор Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процесор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Швидкий перегляд вебсторінок з численними файлами мультимедіа",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Легке перемикання між програмами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Казуальні ігри",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція відео з роздільною здатністю 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Просте редагування фото та відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Висока швидкодія та інтелектуальна продуктивність",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "PENTIUM_GOLD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Бездоганна робота в режимі багатозадачності, просте редагування фото та відео, трансляція 4K відео та яскрава графіка за неймовірно вигідною ціною.",
                "tr_title": "Вражаюча продуктивність для роботи та розваг.",
                "tr_gen_core_title": "Процесор Intel® Pentium® Gold",
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПОТРІБНИЙ РІВЕНЬ ШВИДКОДІЇ ТА ЦІНИ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_SILVER_2.svg",
                      "tr_imgCaption": "Процесор Intel® Pentium® Silver"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_PENTIUM_GOLD_2.svg",
                      "tr_imgCaption": "Процесор Intel® Pentium® Gold"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i3"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Швидкий перегляд вебсторінок з численними файлами мультимедіа",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Легке перемикання між програмами",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Казуальні ігри",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція відео з роздільною здатністю 4K",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Просте редагування фото та відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Висока швидкодія та інтелектуальна продуктивність",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Ігри класу AAA та тривалий ресурс батареї в ультрапортативному ПК. Грайте без компромісів.",
                "tr_title": "Жодних компромісів.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПРОЦЕСОР ДЛЯ ІГРОВОГО УЛЬТРАПОРТАТИВНОГО ПК З ПРОЦЕСОРОМ INTEL® CORE™.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i5&#8209;11300H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11370H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11375H Special Edition 11&#8209;го покоління"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td2_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td3_title": "4&nbsp;ядра / 8&nbsp;потоків"
                    },
                    {
                      "tr_td1_title": "Технологія Intel® Turbo Boost",
                      "tr_td2_title": "Технологія Intel® Turbo Boost",
                      "tr_td3_title": "Технологія Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8&nbsp;МБ Intel® Smart Cache",
                      "tr_td2_title": "12&nbsp;МБ Intel® Smart Cache",
                      "tr_td3_title": "12&nbsp;МБ Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "На цьому ультрапортативному ПК можна грати в ігри найвищого класу з роздільною здатністю 1080p, високою частотою кадрів на максимальних налаштуваннях та відмінною продуктивністю під час роботи від акумулятора.",
                "tr_title": "Сміливіше. Отримайте всі переваги одразу.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": true
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": false
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПРОЦЕСОР ДЛЯ ІГРОВОГО УЛЬТРАПОРТАТИВНОГО ПК З ПРОЦЕСОРОМ INTEL® CORE™.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i5&#8209;11300H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11370H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11375H Special Edition 11&#8209;го покоління"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Макси&shy;мальна  тактова частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td2_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td3_title": "4&nbsp;ядра / 8&nbsp;потоків"
                    },
                    {
                      "tr_td1_title": "Технологія Intel® Turbo Boost",
                      "tr_td2_title": "Технологія Intel® Turbo Boost",
                      "tr_td3_title": "Технологія Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8&nbsp;МБ Intel® Smart Cache",
                      "tr_td2_title": "12&nbsp;МБ Intel® Smart Cache",
                      "tr_td3_title": "12&nbsp;МБ Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_SPECIAL_EDITION_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/INTEL_CORE_I5_H35.png",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat2",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Максимальна тактова частота 5,0&nbsp;ГГц виводить ігровий процес на якісно новий рівень. А ультрапортативність цього ПК дасть змогу вам грати в ігри там, де забажаєте.",
                "tr_title": "Ще вища потужність.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                },
                "processorCompare": {
                  "tr_title": "ПІДБЕРІТЬ ПРОЦЕСОР ДЛЯ ІГРОВОГО УЛЬТРАПОРТАТИВНОГО ПК З ПРОЦЕСОРОМ INTEL® CORE™.",
                  "background": "",
                  "table_head": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i5&#8209;11300H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11370H 11&#8209;го покоління"
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™ i7&#8209;11375H Special Edition 11&#8209;го покоління"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_td1_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,4&nbsp;ГГц</span>",
                      "tr_td2_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>4,8&nbsp;ГГц</span>",
                      "tr_td3_title": "Макси&shy;мальна тактова частота до <span class='style_badge'>5,0&nbsp;ГГц</span>"
                    },
                    {
                      "tr_td1_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td2_title": "4&nbsp;ядра / 8&nbsp;потоків",
                      "tr_td3_title": "4&nbsp;ядра / 8&nbsp;потоків"
                    },
                    {
                      "tr_td1_title": "Технологія Intel® Turbo Boost",
                      "tr_td2_title": "Технологія Intel® Turbo Boost",
                      "tr_td3_title": "Технологія Intel® Turbo Boost Max 3.0"
                    },
                    {
                      "tr_td1_title": "8&nbsp;МБ Intel® Smart Cache",
                      "tr_td2_title": "12&nbsp;МБ Intel® Smart Cache",
                      "tr_td3_title": "12&nbsp;МБ Intel® Smart Cache"
                    },
                    {
                      "tr_td1_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td2_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                      "tr_td3_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Процесор Intel® Core™ i7 Special Edition 11-го покоління дає змогу створювати професійний контент, без проблем грати в ігри, а також виводить на новий рівень розваги на ультрапортативних ПК.",
                "tr_title": "Безмежна продуктивність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 SPECIAL EDITION 11-ГО ПОКОЛІННЯ"
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Процесор Intel® Core™ i7 Special Edition 11-го покоління дає змогу створювати професійний контент, без проблем грати в ігри, а також виводить на новий рівень розваги на ультрапортативних ПК.",
                "tr_title": "Безмежна продуктивність ноутбука",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 Special&nbsp;Edition 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 SPECIAL EDITION 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H35_i7_spcl_edition_gaming_tile.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_SPECIAL_EDITION_H35.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i7 Special Edition",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H35",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "gamingPanleType2": "gaming-panelType1",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер як надає кіберспортивні можливості, так і дозволяє створення складного вмісту.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": "",
                      "active": false
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": "",
                      "active": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tileBG": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Ідеальний баланс тактової частоти та продуктивності ядра дає можливість отримати від гри максимум — високу частоту кадрів в динамічних іграх та ефект повного занурення в іграх найвищого класу.",
                "tr_title": "Потужність для досягнення мети.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Грайте у найсучасніші ігри, записуйте та транслюйте ігровий процес з високою частотою кадрів та без зусиль перемикайтеся на роботу в режимі багатозадачності.",
                "tr_title": "Потужність, яка стирає межі.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_RKL",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер як надає кіберспортивні можливості, так і дозволяє створення складного вмісту.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/RKL_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Перемикайтеся між переглядом фільмів онлайн та створенням презентацій ще швидше без шкоди для ефективності.",
                "tr_title": "Енергія на весь день",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 з&nbsp;технологією Intel® Hybrid",
                "tr_subTitle2": "Процесор Intel®&nbsp;Core™&nbsp;i3 з&nbsp;технологією Intel® Hybrid"
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Універсальність, продуктивність і збільшений ресурс акумулятора забезпечують чудову роботу, де б ви не були.",
                "tr_title": "Енергія на весь день",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 з&nbsp;технологією Intel® Hybrid",
                "tr_subTitle2": "Процесор Intel®&nbsp;Core™&nbsp;i3 з&nbsp;технологією Intel® Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_HYBRID",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Легко працюйте в режимі багатозадачності протягом усього дня.",
                "tr_title": "Багатозадачність у дорозі",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 із&nbsp;технологією Intel® Hybrid",
                "tr_subTitle2": "Процесор Intel®&nbsp;Core™&nbsp;i5 із&nbsp;технологією Intel® Hybrid"
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "tableFormat",
                "tr_subtitle": "Оптимізуйте всі розваги, ресурсоємні завдання та створення контенту.",
                "tr_title": "Переходьте на потужніший ПК",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 із&nbsp;технологією Intel® Hybrid",
                "tr_subTitle2": "Процесор Intel®&nbsp;Core™&nbsp;i5 із&nbsp;технологією Intel® Hybrid"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Продуктивність рівня настільних ПК під час гри у поєднанні з мобільністю, що підходить як для динамічної гри з високою частотою кадрів, так і для повного занурення в ігри класу ААА.",
                "tr_title": "Потужність для досягнення мети.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Продуктивність рівня настільних ПК під час гри у поєднанні з мобільністю, що підходить як для динамічної гри з високою частотою кадрів, так і для повного занурення в ігри класу ААА.",
                "tr_title": "Потужність для досягнення мети.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i5_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_H45",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Ноутбук для одночасної гри, запису та трансляції з високою частотою кадрів і простого перемикання між ресурсоємними завданнями в режимі багатозадачності.",
                "tr_title": "Потужність, яка стирає межі.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Ноутбук для одночасної гри, запису та трансляції з високою частотою кадрів і простого перемикання між ресурсоємними завданнями в режимі багатозадачності.",
                "tr_title": "Потужність, яка стирає межі.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i7_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_PERFORMANCE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти й великої кількості ядер надає кіберспортивні можливості, а також дає змогу створювати складний вміст на ПК на ходу.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти й великої кількості ядер надає кіберспортивні можливості, а також дає змогу створювати складний вміст на ПК на ходу.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_H45_ENTHUSIAST",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти, великої кількості ядер і розблокованого множника надає кіберспортивні можливості, а також дає змогу створювати складний вміст на ПК на ходу.",
                "tr_title": "Потужність без обмежень. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти, великої кількості ядер і розблокованого множника надає кіберспортивні можливості, а також дає змогу створювати складний вміст на ПК на ходу.",
                "tr_title": "Потужність без обмежень. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/gaming/H45_i9_gaming_tile.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер як надає кіберспортивні можливості, так і дозволяє створення складного вмісту.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти й великої кількості ядер, що дає змогу створювати складний контент в будь-яких умовах.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер дозволяє створювати складний вміст.",
                "tr_title": "Неймовірна потужність. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_10",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Вийдіть за рамки й досягніть максимального задоволення від гри",
                "tr_title": "Змагайтеся на найвищому рівні",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Вийдіть за рамки й досягніть максимального задоволення від гри",
                "tr_title": "Змагайтеся на найвищому рівні",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock_blue.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ЗНАЙДІТЬ ПРОЦЕСОР INTEL® CORE™ 10-ГО ПОКОЛІННЯ ДЛЯ ІГОР.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_8.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу ААА без проблем",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Трансляція та запис відео",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Створення професійного контенту",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Пікова продуктивність під час ігор",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    },
                    {
                      "tr_row": "З розблокованим множником та можливістю розгону<sup>2</sup>",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,8&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,1&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 10<br/>Потоків: 20</span>"
                    }
                  ]
                }
              }
            },
            {
              "deviceType": "Athena",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_10.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Ноутбук розроблено спеціально для тих, хто завжди в дорозі.",
                "tr_title": "Зустрічайте новий клас ноутбуків",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 10&#8209;го покоління"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_11_UNLOCKED",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер як надає кіберспортивні можливості, так і дозволяє створення складного вмісту.",
                "tr_title": "Потужність без обмежень. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge_laptop_11gen.svg",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти, великої кількості ядер та розблокованої потужності, які дають вашому ПК змогу створювати складний вміст в будь-яких умовах.",
                "tr_title": "Потужність без обмежень. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            },
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_11.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "",
                "tr_subtitle": "Чудове поєднання високої тактової частоти та великої кількості ядер дозволяє створювати складний вміст.",
                "tr_title": "Потужність без обмежень. Ідеальний баланс.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 11&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9 11-ГО ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX] МБ <br/></span><span class='subtitle_font'>Intel® Smart Cache</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "Плавний ігровий процес і віртуальна реальність в найвимогливіших іграх",
                "tr_title": "Серйозні ігри починаються тут",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 9&#8209;го покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 32% БІЛЬША ЧАСТОТА КАДРІВ <br/><span class='tr_subtitle_font'>під час гри, трансляції та запису в порівнянні з трирічним ПК<sup>3</sup></span>",
                "tr_title": "Потужність, яка дає змогу поділитися своїми найбільш вражаючими ігровими моментами",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 9‑го&nbsp;покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_9_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "gaming-processorType2",
                "panelType2": "tableFormat",
                "tr_subtitle": "ДО 41% БІЛЬША ЧАСТОТА КАДРІВ <br/><span class='tr_subtitle_font'>під час гри, трансляції та запису в порівнянні з трирічним ПК<sup>4</sup></span>",
                "tr_title": "Геймери прагнуть. Intel® Core™ i9 дає можливість.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 9‑го&nbsp;покоління",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Потоків: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>Ядер: </span><br/><span class='badgetitle_font'>[XX]</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle_font'>До <br/></span><span class='badgetitle_font'>[XX] <br/></span><span class='subtitle_font'>ГГц</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='badgetitle_font'>[XX]&nbsp;МБ <br/></span><span class='subtitle_font'>кеш-пам’яті</span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "badgeTitle": "",
                    "tr_badgeSubTitle": "З розблокованим множником",
                    "badgePreTitle": "",
                    "imgUrl": "assets/images/tocheck/unlock.svg"
                  }
                ],
                "processorCompare": {
                  "tr_title": "ОБЕРІТЬ ПРОЦЕСОР INTEL® CORE™ ДЛЯ СВОГО СТИЛЮ ГРИ.",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i5"
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel®&nbsp;Core™&nbsp;i7"
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9_GAMING.svg",
                      "tr_imgCaption": "Процесор Intel® Core™ i9"
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Ігри класу AAA",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Кіберспорт",
                      "td1": true,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Грайте, транслюйте й записуйте без компромісів",
                      "td1": false,
                      "td2": true,
                      "td3": true
                    },
                    {
                      "tr_row": "Найкращий ігровий процесор Intel® Core™ 9-го покоління",
                      "td1": false,
                      "td2": false,
                      "td3": true
                    }
                  ],
                  "table_footer": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,3&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 4<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 12</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ],
                  "table_footer_desktop": [
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,6&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 6<br/>Потоків: 6</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 4,9&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 8</span>"
                    },
                    {
                      "tr_title": "<span class='small_font'>Тактова частота<sup>2</sup>: до 5&nbsp;ГГц</span>",
                      "tr_subTitle": "<span class='small_font'>Ядер: 8<br/>Потоків: 16</span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_K_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Створено для ігор наступного покоління",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 12-ГО&nbsp;ПОКОЛІННЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 12-ГО&nbsp;ПОКОЛІННЯ"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_HX_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Поєднання ігрової та робочої станцій",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "processorTileBadgeUrl": "assets/images/standard/i9_uwp_tile_badge.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 12-ГО&nbsp;ПОКОЛІННЯ"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Надійна продуктивність, коли вона потрібна найбільше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i3 12-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/i3_uwp_tile_badge.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Підвищення продуктивності там, де це потрібно найбільше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 12-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Підвищення продуктивності там, де це потрібно найбільше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 12-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Підвищена продуктивність, де вона потрібна найбільше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Підвищена продуктивність, де вона потрібна найбільше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/12th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5-processor-image.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Завдяки ноутбукам Intel® Evo™ можна отримати швидкодію, інтелектуальні можливості для відеочатів без перешкод, швидший інтернет, тривалий час роботи від акумулятора й багато інших переваг.",
                "tr_title": "Підвищення продуктивності там, де це потрібно найбільше.",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i7_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Завдяки ноутбукам Intel® Evo™ можна отримати швидкодію, інтелектуальні можливості для відеочатів без перешкод, швидший інтернет, тривалий час роботи від акумулятора й багато інших переваг.",
                "tr_title": "Підвищена продуктивність, де вона потрібна найбільше",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_12GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/evo_processor_i9_gen12.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Завдяки ноутбукам Intel® Evo™ можна отримати швидкодію, інтелектуальні можливості для відеочатів без перешкод, швидший інтернет, тривалий час роботи від акумулятора й багато інших переваг.",
                "tr_title": "Надзвичайна продуктивність ноутбука преміумкласу",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "З технологією Intel® Turbo Boost 2.0 до [max_turbo_frequency]&nbsp;ГГц",
                "tr_title": "Створено для бізнесу",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Можливості віддаленого керування пристроєм",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматична оптимізація продуктивності Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Ефективна робота програм на основі даних",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимальна продуктивність із покращеною швидкодією",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "З технологією Intel® Turbo Boost 2.0 до [max_turbo_frequency]&nbsp;ГГц",
                "tr_title": "Інтенсивно працює, тому ви можете зосередитися на важливих справах",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 12&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Можливості віддаленого керування пристроєм",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматична оптимізація продуктивності Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Ефективна робота програм на основі даних",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимальна продуктивність із покращеною швидкодією",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_12GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-12thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "З технологією Intel® Turbo Boost 2.0 до [max_turbo_frequency]&nbsp;ГГц",
                "tr_title": "Прискорте розвиток свого бізнесу",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 12&#8209;го&nbsp;покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 12-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Можливості віддаленого керування пристроєм",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Автоматична оптимізація продуктивності Wi-Fi<sup>20</sup>",
                      "td1": false,
                      "td2": true,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Ефективна робота програм на основі даних",
                      "td1": false,
                      "td2": false,
                      "td3": true,
                      "td4": true
                    },
                    {
                      "tr_row": "Максимальна продуктивність із покращеною швидкодією",
                      "td1": false,
                      "td2": false,
                      "td3": false,
                      "td4": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Надійна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 13&#8209;го покоління",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Реальна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 13-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Реальна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 13-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/creator/13thgeni5processor.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Потужна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 13-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Потужна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 13-ГО&nbsp;ПОКОЛІННЯ",
                "bannerImgUrl": "assets/images/creator/13thgeni7processor.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_CREATOR",
      "iposTypes": [
        {
          "iposType": "Creator",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Більше ніж продуктивність",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 13-ГО&nbsp;ПОКОЛІННЯ",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I5_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I5_12GEN.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Безперешкодне підключення до наявного телефону<sup>24</sup>, розумний вибір найкращого каналу Wi&#8209;Fi й швидке заряджання зі значним ресурсом акумулятора.",
                "tr_title": "Надзвичайна продуктивність для більших досягнень будь-де",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i5-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I7_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I7_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Безперешкодне підключення до наявного телефону<sup>24</sup>, розумний вибір найкращого каналу Wi&#8209;Fi й швидке заряджання зі значним ресурсом акумулятора.",
                "tr_title": "Надзвичайна продуктивність, щоб ПК міг одночасно робити ще більше",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i7-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_I9_13GEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/EVO_I9_GEN12.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/evo/i5_13gen_processor_img.svg",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Безперешкодне підключення до наявного телефону<sup>24</sup>, розумний вибір найкращого каналу Wi&#8209;Fi й швидке заряджання зі значним ресурсом акумулятора.",
                "tr_title": "Надзвичайна продуктивність для прискореного виконання найвибагливіших завдань",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/evo/12gen-evo-i9-tile.svg"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Більше ніж продуктивність",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 13-ГО&nbsp;ПОКОЛІННЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 13-ГО&nbsp;ПОКОЛІННЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го покоління",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 13-ГО&nbsp;ПОКОЛІННЯ",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_ABOVE13TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Більше ніж продуктивність",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Надійна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/13th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Реальна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Потужна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_14TH_GEN_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Більше ніж продуктивність",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i5",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i5_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i5_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i7",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i7_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i7_hx_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ i9",
                    "processorTileBadgeUrl": "assets/images/gaming/13th_gen_i9_k_tile_badge.png",
                    "processorTileBadgeUrl1": "assets/images/gaming/13th_gen_i9_hx_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;i7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ i9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I3_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Надійна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;3",
                "bannerImgUrl": "assets/images/13th_gen_std_i3_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/14th_gen_i3_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Реальна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;5",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ 5",
                "bannerImgUrl": "assets/images/13th_gen_std_i5_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Потужна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;7",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ 7",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I3_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;3",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_14_1",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Потужна продуктивність, що покликана робити більше",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                "tr_gen_core_title": "Процесор Intel® Core™ 9",
                "bannerImgUrl": "assets/images/13th_gen_std_i7_processor_banner.svg",
                "processorTileBadgeUrl": "assets/images/standard/intel_core_9_std_tile_badge.png",
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I5_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I7_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™&nbsp;7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_I9_14_1.svg",
                      "tr_badgeIconTile": "Процесор Intel® Core™ 9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_1ST_GEN_ULTRA_GAMING",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Грай без компромісів",
                "panelType1": "gaming-processorType12",
                "gamingPanleType2": "gaming-panelType1",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_5_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_7_h_tile_badge.png"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/1st_gen_ultra_9_h_tile_badge.png",
                    "processorTileBadgeUrl2": "assets/images/standard/13th_gen_i9_std_tile_badge.png"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "[l_core] ядер LPE-core"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "[l_thread] на ядра LPE-core"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7",
                      "tr_badgeSubTitle": ""
                    },
                    {
                      "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                      "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;9",
                      "tr_badgeSubTitle": ""
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_MTL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tr_title": "Грай без компромісів",
                "panelType1": "evo-mtl-video-panel",
                "gamingPanleType2": "gaming-panelType1",
                "videoUrl": "assets/lang/[XX]/redesign/evo_std_mtl_processor.mp4"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I5_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I5_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малий бізнес заслуговує на великі бізнес-рішення",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i5 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Допомагають захистити пристрої та дані від фізичного втручання",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I7_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I7_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малий бізнес заслуговує на великі бізнес-рішення",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i7 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL®&nbsp;CORE™&nbsp;i7 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Допомагають захистити пристрої та дані від фізичного втручання",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_I9_13GEN_VPRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_I9_12GEN_VPRO.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/vpro-13thGen-processor-banner.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "tableFormat",
                "tr_subtitle": "",
                "tr_title": "Малий бізнес заслуговує на великі бізнес-рішення",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i9 13&#8209;го покоління",
                "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™&nbsp;i9 13-ГО&nbsp;ПОКОЛІННЯ",
                "processorTileBadgeUrl": "assets/images/standard/VPRO12_i9.svg",
                "processorCompare": {
                  "tr_title": "ПРОЦЕСОР У ПОРІВНЯННІ",
                  "background": "",
                  "table_head": [
                    {
                      "tr_table_heading": "",
                      "imgUrl": "assets/images/INTEL_CORE_I5_I7_DUEL_BADGE.svg",
                      "tr_imgCaption": ""
                    },
                    {
                      "tr_table_heading": "Поточний пристрій",
                      "imgUrl": "assets/images/processor/INTEL_CORE_13GEN_VPRO_BADGES.svg",
                      "tr_imgCaption": ""
                    }
                  ],
                  "tabletr": [
                    {
                      "tr_row": "Блокування шуму та розмиття фону",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Автоматичне адаптування продуктивності для пріоритизації ваших основних завдань",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Здійснюйте високоякісні вебдзвінки без жодних перешкод",
                      "td1": true,
                      "td2": true
                    },
                    {
                      "tr_row": "Готові до використання апаратні рішення для безпеки",
                      "td1": false,
                      "td2": true
                    },
                    {
                      "tr_row": "Допомагають захистити пристрої та дані від фізичного втручання",
                      "td1": false,
                      "td2": true
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_RPL_MTL_vPro",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/vPro_ultra_badge.png",
                "tileBG": "",
                "bannerImgUrl": "assets/images/INTEL_VPRO_ULTRA.png",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_subtitle": "Відкрийте нові можливості ШІ для бізнесу",
                "tr_title": "Будьте готові до майбутнього з процесорами Intel®&nbsp;Core™&nbsp;Ultra&nbsp;[XX] та Intel&nbsp;vPro®",
                "tr_gen_core_title": "Процесор Intel® Core™ Ultra [XX]",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_1.png",
                    "tr_badgeTitle": "НАДАЙТЕ СВОЄМУ БІЗНЕСУ НОВИЙ ІМПУЛЬС ЗАВДЯКИ ПК ЗІ ШТУЧНИМ ІНТЕЛЕКТОМ ВІД INTEL",
                    "tr_badgeSubTitle": "Потужний ПК, який надає неперевершені можливості, — основа продуктивності бізнесу. Intel vPro® допомагає підвищити ефективність і продуктивність співробітників під час виконання робочих навантажень та під час роботи в застосунках завдяки новій архітектурі, яка забезпечує потужну й енергоефективну продуктивність при вирішенні різних складних бізнес-завдань, відправляючи відповідне завдання відповідному механізму в потрібний момент.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_2.png",
                    "tr_badgeTitle": "ГОТОВІ ДО ВИКОРИСТАННЯ ФУНКЦІЇ БАГАТОШАРОВОЇ БЕЗПЕКИ",
                    "tr_badgeSubTitle": "Нові загрози вимагають комплексного підходу до безпеки. Intel vPro® забезпечує захист на апаратному рівні та в масштабах усієї системи, щоб ваш бізнес був краще захищений. Ці унікальні готові до використання засоби безпеки, зокрема можливості виявлення загроз на базі ШІ, допомагають захистити ваших користувачів, ваші дані та ваш бізнес.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/vPro_ultra_panel_3.png",
                    "tr_badgeTitle": "ВБУДОВАНІ ІНСТРУМЕНТИ, ЩО ДАЮТЬ ЗМОГУ ПРОДУКТИВНО ПРАЦЮВАТИ МАЙЖЕ ЗВІДУСІЛЬ",
                    "tr_badgeSubTitle": "Офіси є скрізь, як і ПК. Intel vPro® надає сучасні можливості керування на базі апаратного забезпечення, які допомагають компаніям полегшити керування парком ПК, спростити підтримку й покращити якість обслуговування кінцевих користувачів, одночасно забезпечуючи стійкі методи роботи з ПК.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Креативніші</span> з інструментами на основі ШІ, щоб творити швидше"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Продуктивніші</span> дякуючи ШІ-асистентам, що заощадять ваш час"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Безпечніші</span> завдяки вбудованому захисту даних"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Креативніші</span> з інструментами на основі ШІ, щоб творити швидше"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Продуктивніші</span> дякуючи ШІ-асистентам, що заощадять ваш час"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Безпечніші</span> завдяки вбудованому захисту даних"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STD_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel® Core™ Ultra 9 (Серія 2)",
                "titleArray": [
                  {
                    "tr_title": "<span class='spec-heading'>Креативніші</span> з інструментами на основі ШІ, щоб творити швидше"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Продуктивніші</span> дякуючи ШІ-асистентам, що заощадять ваш час"
                  },
                  {
                    "tr_title": "<span class='spec-heading'>Безпечніші</span> завдяки вбудованому захисту даних"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_5.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_7.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO_LNL_ULTRA_9",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                "tileBG": "",
                "bannerImgUrl": "assets/images/evo_lunar_lake_banner_9.svg",
                "panelType1": "gaming-processorType12",
                "panelType2": "",
                "tr_pretitle": "ПК зі штучним інтелектом — більше ніж відмінний ПК",
                "tr_subtitle1": "НА БАЗІ ПРОЦЕСОРІВ INTEL®&nbsp;CORE™ ULTRA (СЕРІЯ&nbsp;2)",
                "tr_subtitle2": "Це можливо на ПК Intel зі штучним інтелектом",
                "tr_subtitle": "Найефективніший, найбезпечніший і найвисокопродуктивніший процесор Intel для мобільних ПК<sup>39</sup>",
                "tr_gen_core_title": "Процесор Intel® Core™ Ultra 9 (Серія 2)"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Створені для гри. Готові до будь-чого.",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "[l_core] ядер LPE-core"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "[l_thread] на ядра LPE-core"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1.png",
                    "tr_title": "ВІДКРИЙТЕ ДЛЯ СЕБЕ УЛЬТРАПРОДУКТИВНІСТЬ В ІГРАХ",
                    "tr_subtitle": "Отримайте легендарну ігрову продуктивність завдяки новим ядрам, які забезпечують надзвичайно плавний ігровий процес з високою швидкістю відгуку. <br/><br/>Отримайте до <span class ='expandable_highlight'>[XX]ГГц</span> за допомогою Intel® Thermal Velocity Boost.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel2.png",
                    "tr_title": "ЗРОСТАННЯ ЕФЕКТИВНОСТІ Й ПРОДУКТИВНОСТІ",
                    "tr_subtitle": "Отримайте максимальну ефективність із процесорами Intel® Core™ Ultra для настільних ПК, які покращують продуктивність і ефективність, щоб ПК працював тихіше, швидше і при цьому менше нагрівався. <br><br/> <span class ='expandable_highlight'>На понад 10%</span> вища багатопотокова продуктивність <br><br/>До <span class ='expandable_highlight'>30%</span> менше споживання енергії",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "БУДЬТЕ ГОТОВІ ДО МАЙБУТНЬОГО ЗАВДЯКИ ПЕРЕНЕСЕННЮ НАВАНТАЖЕНЬ З ІГОР І ТРАНСЛЯЦІЙ",
                    "tr_subtitle": "Відкрийте для себе кращу продуктивність трансляції та ігор за допомогою ПК зі штучним інтелектом на базі процесора Intel® Core™ Ultra.<br><br/><strong>Передавайте завдання ШІ на нейронний процесор:</strong><br><br/><span class ='expandable_highlight'>Видалення фону</span><br><br/><span class ='expandable_highlight'>Оптимізація звуку</span><br><br/><span class ='expandable_highlight'>Автокадрування</span><br><br/><strong>Три прискорювачі штучного інтелекту: центральний, графічний та нейронний процесори</strong> Завдяки вбудованим у процесор прискорювачам ШІ — центральному, графічному та нейронному процесорам, — процесори Intel® Core™ Ultra швидко справляються з робочими навантаженнями штучного інтелекту.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "ПІДКЛЮЧЕННЯ СТАЄ ПРОСТІШИМ",
                    "tr_subtitle": "Завдяки більшій кількості ліній PCIe 5.0, наявності технології Thunderbolt™ 5.0 і Wi-Fi 7, процесори Intel® Core™ Ultra для настільних ПК спрощують підключення, як ніколи раніше. <br><br/><strong>Підтримка технології Thunderbolt™ 5 </strong>​ <br><br/>Передавайте до <span class ='expandable_highlight'>120 Гбіт/с</span> для запису, редагування та обміну файлами<br><br/><span class ='expandable_highlight'>Вдвічі</span> вища пропускна здатність ніж у Thunderbolt™​",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Desktop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Креативніший.<br>Продуктивніший.<br>Безпечніший.",
                "tr_subtitle": "Більше часу на те, що ви любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner_desktop.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (CЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel® Core™ Ultra 9 (Серія 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРІЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1_desktop.png",
                    "tr_title": "ВИКОНУЙТЕ ТРУДОМІСТКІ СПРАВИ. ШВИДКО.",
                    "tr_subtitle": "Отримайте більше вільного часу завдяки штучному інтелекту. Організовуйте свій календар, плануйте поїздки, миттєво отримуйте підсумки зустрічей, легко створюйте презентації та багато іншого.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2_desktop.png",
                    "tr_title": "ГРАЙТЕ В УЛЮБЛЕНІ ІГРИ. БЕЗ ЖОДНИХ ТУРБОТ.",
                    "tr_subtitle": "Забудьте про проблеми з сумісністю чи продуктивністю під час гри. У популярні ігри класу AAA можна без проблем грати та одночасно вести трансляцію.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3_desktop.png",
                    "tr_title": "СТВОРЮЙТЕ ТЕ, ЩО ЛЮБИТЕ. БЕЗ ЗУСИЛЬ.",
                    "tr_subtitle": "Що б ви не робили, робіть це швидше та простіше за допомогою творчих інструментів зі штучним інтелектом.<br><br>Миттєво обрізайте фотографії, змінюйте фони та додавайте ефекти. Покращуйте відео кількома кліками. Навіть створюйте власні витвори мистецтва всього кількома словами.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4_desktop.png",
                    "tr_title": "НЕ ХВИЛЮЙТЕСЯ. НІКОЛИ.",
                    "tr_subtitle": "Зберігайте спокій, знаючи, що вбудовані засоби захисту допоможуть зберегти ваші дані в безпеці та конфіденційності.<br><br>Крім того, програми безпеки на основі штучного інтелекту допомагають миттєво виявляти підроблений звук у відео та захищати конфіденційні дані, що зберігаються на вашому ПК.",
                    "align": "left"
                  }
                ]
              }
            },
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Креативніший.<br>Продуктивніший.<br>Безпечніший.",
                "tr_subtitle": "Більше часу на те, що ви любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (CЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel® Core™ Ultra 9 (Серія 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРІЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ВИКОНУЙТЕ ТРУДОМІСТКІ СПРАВИ. ШВИДКО.",
                    "tr_subtitle": "Отримайте більше вільного часу завдяки штучному інтелекту. Організовуйте свій календар, плануйте поїздки, миттєво отримуйте підсумки зустрічей, легко створюйте презентації та багато іншого.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "СТВОРЮЙТЕ ТЕ, ЩО ЛЮБИТЕ. БЕЗ ЗУСИЛЬ.",
                    "tr_subtitle": "Що б ви не робили, робіть це швидше та простіше за допомогою творчих інструментів зі штучним інтелектом.<br><br>Миттєво обрізайте фотографії, змінюйте фони та додавайте ефекти. Покращуйте відео кількома кліками. Навіть створюйте власні витвори мистецтва всього кількома словами.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "ГРАЙТЕ В УЛЮБЛЕНІ ІГРИ. БЕЗ ЖОДНИХ ТУРБОТ.",
                    "tr_subtitle": "Забудьте про проблеми з сумісністю чи продуктивністю під час гри. У популярні ігри класу AAA можна без проблем грати та одночасно вести трансляцію.<br><br>Ви також відчуєте плавніший ігровий процес в дорозі та довший час гри без підключення до електромережі завдяки вбудованій графіці Intel® Arc™ <sup>57</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel4.png",
                    "tr_title": "Забудьте про зарядний пристрій. На весь день<sup>55</sup>.",
                    "tr_subtitle": "Займайтеся в дорозі улюбленими справами, адже ресурс акумулятора складає до <strong>20 годин<sup>55,56</sup></strong>.",
                    "align": "centre"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "НЕ ХВИЛЮЙТЕСЯ. НІКОЛИ.",
                    "tr_subtitle": "Зберігайте спокій, знаючи, що вбудовані засоби захисту допоможуть зберегти ваші дані в безпеці та конфіденційності.<br><br>Крім того, програми безпеки на основі штучного інтелекту допомагають миттєво виявляти підроблений звук у відео та захищати конфіденційні дані, що зберігаються на вашому ПК.",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Креативніший.<br>Продуктивніший.<br>Безпечніший.",
                "tr_subtitle": "Більше часу на те, що ви любите.",
                "bannerImgUrl": "assets/images/processor/arl_std_banner.svg",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "evo-content-tile-panel",
                "gamingPanleType2": "gaming-processorType12",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;5 (CЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;7 (СЕРІЯ&nbsp;2)"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_badgeSubTitle": "Процесор Intel® Core™ Ultra 9 (Серія 2)",
                    "tr_badgeSubTitle1": "ПРОЦЕСОР INTEL®&nbsp;CORE™ ULTRA&nbsp;9 (СЕРІЯ&nbsp;2)"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel1.png",
                    "tr_title": "ВИКОНУЙТЕ ТРУДОМІСТКІ СПРАВИ. ШВИДКО.",
                    "tr_subtitle": "Отримайте більше вільного часу завдяки штучному інтелекту. Організовуйте свій календар, плануйте поїздки, миттєво отримуйте підсумки зустрічей, легко створюйте презентації та багато іншого.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel2.png",
                    "tr_title": "СТВОРЮЙТЕ ТЕ, ЩО ЛЮБИТЕ. БЕЗ ЗУСИЛЬ.",
                    "tr_subtitle": "Що б ви не робили, робіть це швидше та простіше за допомогою творчих інструментів зі штучним інтелектом.<br><br>Миттєво обрізайте фотографії, змінюйте фони та додавайте ефекти. Покращуйте відео кількома кліками. Навіть створюйте власні витвори мистецтва всього кількома словами.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel3.png",
                    "tr_title": "ГРАЙТЕ В УЛЮБЛЕНІ ІГРИ. БЕЗ ЖОДНИХ ТУРБОТ.",
                    "tr_subtitle": "Забудьте про проблеми з сумісністю чи продуктивністю під час гри. У популярні ігри класу AAA можна без проблем грати та одночасно вести трансляцію.<br><br>Ви також відчуєте плавніший ігровий процес в дорозі та довший час гри без підключення до електромережі завдяки вбудованій графіці Intel® Arc™ <sup>57</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_std_panel5.png",
                    "tr_title": "НЕ ХВИЛЮЙТЕСЯ. НІКОЛИ.",
                    "tr_subtitle": "Зберігайте спокій, знаючи, що вбудовані засоби захисту допоможуть зберегти ваші дані в безпеці та конфіденційності.<br><br>Крім того, програми безпеки на основі штучного інтелекту допомагають миттєво виявляти підроблений звук у відео та захищати конфіденційні дані, що зберігаються на вашому ПК.",
                    "align": "left"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "ПК зі штучним інтелектом Intel® Evo™",
                    "tr_subtitle": "Отримайте максимум від процесорів Intel®&nbsp;Core™ Ultra"
                  },
                  {
                    "tr_title": "Створено для роботи зі штучним інтелектом сьогодні та завтра",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Великий вибір кольорів, розмірів та дизайнів із сенсорним екраном або 2 в 1",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Окремий механізм штучного інтелекту прискорює все, що ви робите",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Уникніть довгого процесу навчання, використовуючи вже знайоме обладнання та програмне забезпечення",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Працює без нагріву та шуму, а ресурсу акумулятора вистачає на весь день",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Вбудовані засоби захисту захищають дані",
                    "tr_subtitle": ""
                  },
                  {
                    "tr_title": "Синхронізація з будь-яким телефоном чи планшетом<sup>54</sup>",
                    "tr_subtitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE_LAPTOP",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Laptop",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Створено для ігор наступного покоління",
                "panelType1": "header-BadgeIconTop-arc",
                "gamingPanleType2": "gaming-processorType12",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 5",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_5_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 7",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_7_tile_badge_laptop.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;9",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 9",
                    "processorTileBadgeUrl": "",
                    "processorTileBadgeUrl1": "assets/images/gaming/2nd_gen_ultra_9_tile_badge_laptop.svg"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Ядер: </span>[XX]</span>",
                    "tr_badgePreTitle": "Ядер Performance-core: [p_core]",
                    "tr_badgeSubTitle": "Ядер Efficient-core: [e_core]",
                    "tr_badgeSubTitle1": "[l_core] ядер LPE-core"
                  },
                  {
                    "tr_badgeTitle": "<span class='core-value'><span class='core-text'>Потоків: </span>[XX]</span>",
                    "tr_badgePreTitle": "Потоків на Performance-core: [p_thread]",
                    "tr_badgeSubTitle": "Потоків на Efficient-core: [e_thread]",
                    "tr_badgeSubTitle1": "[l_thread] на ядра LPE-core"
                  }
                ],
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/processor/arl_panel1_laptop.png",
                    "tr_title": "ВІДКРИЙТЕ ДЛЯ СЕБЕ УЛЬТРАПРОДУКТИВНІСТЬ В ІГРАХ",
                    "tr_subtitle": "Отримайте легендарну ігрову продуктивність завдяки новим ядрам, які забезпечують надзвичайно плавний ігровий процес з високою швидкістю відгуку. <br/><br/> Покращена ігрова продуктивність у класичних іграх — це лише один клік завдяки постійним оновленням Intel® Application Optimization.<sup>48</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4.png",
                    "tr_title": "МАКСИМІЗУЙТЕ ЕНЕРГОЕФЕКТИВНІСТЬ",
                    "tr_subtitle": "Робіть більше з меншими зусиллями — отримуйте кращу ігрову продуктивність та довший час гри без підключення до електромережі. <br><br/>Отримайте максимальну ефективність із процесорами Intel® Core™ Ultra, які покращують продуктивність і ефективність, щоб ваш ноутбук працював тихіше, швидше і при цьому менше нагрівався.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel3.png",
                    "tr_title": "БУДЬТЕ ГОТОВІ ДО МАЙБУТНЬОГО ЗІ ШТУЧНИМ ІНТЕЛЕКТОМ",
                    "tr_subtitle": "Прискорюйте завдання штучного інтелекту на пристрої за допомогою ПК з ШІ на базі процесора <span class ='expandable_highlight'>Intel® Core™ Ultra</span>. Від перенесення ігрових та трансляційних завдань до створення зображень та аудіо — отримуйте максимум від свого ПК зі штучним інтелектом. Три прискорювачі штучного інтелекту, вбудовані в процесор, допомагають зберігати ваші дані конфіденційними та завжди під рукою<sup>41</sup>.",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel4_laptop.png",
                    "tr_title": "БАГАТОПОТОКОВІСТЬ ДЛЯ БАГАТОЗАДАЧНОСТІ",
                    "tr_subtitle": "Досягніть нових рівнів продуктивності з оновленими ядрами, що спеціалізуються на іграх, трансляції та створенні контенту, щоб підняти їх на нові висоти. <br><br/>Більша багатопотокова продуктивність дозволяє вам бути багатозадачним — або навіть мегазадачним — з мінімальними затримками.",
                    "align": "right"
                  },
                  {
                    "imgUrl": "assets/images/processor/arl_panel5_laptop.png",
                    "tr_title": "ПІДКЛЮЧЕННЯ СТАЄ ПРОСТІШИМ",
                    "tr_subtitle": "Уникайте розчарувань від затримок завдяки підтримці Intel® Wi-Fi 7 та інтегрованому Intel® Wi-Fi 6E<sup>49</sup>. <br><br/>Спростіть роботу з кабелями за допомогою технології Thunderbolt™ останнього покоління, найшвидшим портом<sup>50</sup> для ноутбуків для підключення всіх периферійних пристроїв, зокрема камер, моніторів та накопичувачів<sup>51</sup>.",
                    "align": "left"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_2ND_GEN_ARL_LAKE_HX",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Процесор",
                "tr_title": "Найкращі мобільні ігрові пристрої",
                "panelType1": "arl-hx-proc-panel",
                "gamingPanleType2": "gaming-arl-hx-proc-panel",
                "detailBGUrl": "assets/images/gaming/arl_hx_title_bg.png",
                "titleArray": [
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "tr_gen_core_title": "Процесор Intel® Core™ Ultra 7 270HX Plus",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 7 270HX PLUS",
                    "processorTileBadgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
                    "processorTileBadgeUrl1": "assets/images/gaming/arl_hx_ultra_7_9_proc_homeTile.svg"
                  },
                  {
                    "badgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "tr_gen_core_title": "Процесор Intel® Core™ Ultra 9 290HX Plus",
                    "tr_gen_core_title_uppercase": "ПРОЦЕСОР INTEL® CORE™ ULTRA 9 290HX PLUS",
                    "processorTileBadgeUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
                    "processorTileBadgeUrl1": "assets/images/gaming/arl_hx_ultra_7_9_proc_homeTile.svg"
                  }
                ],
                "titleArray1": [
                  {
                    "title": "tile1",
                    "imgUrl": "assets/images/gaming/arl_hx_tiles_bg.png",
                    "tileVideoUrl": "assets/videos/gaming/arl_hx_tile1.mp4",
                    "tr_title": "Продуктивність рівня настільного ПК на ходу",
                    "tr_subtitle": "Грайте, транслюйте, редагуйте та працюйте — усе одночасно. Завдяки вищій ігровій продуктивності в тонкому портативному корпусі та графіці Intel® на базі архітектури X<sup>e</sup>3 нового покоління, ви отримуєте плавніший ігровий процес, чіткіше відтворення медіафайлів та комфортнішу роботу під час виконання творчих завдань.<br/>До 4 ядер Xe, підтримка сучасних кодеків, зокрема AV1 та VVC, та висока пропускна здатність PCIe дозволяють легко працювати в режимі багатозадачності, забезпечуючи приголомшливе редагування відео у форматі 1080p та швидшу обробку високоякісного контенту 4K, навіть коли дискретна відеокарта не використовується для економії заряду акумулятора."
                  },
                  {
                    "title": "tile2",
                    "imgUrl": "assets/images/gaming/arl_hx_tiles_bg.png",
                    "tileVideoUrl": "assets/videos/gaming/arl_hx_tile2.mp4",
                    "tr_title": "Точно налаштовані технології для захоплюючого ігрового процесу",
                    "tr_subtitle": "Вражаюча графіка та менше шуму, щоб ви могли зосередитися на грі.<br/><br/>Пориньте в ігровий процес із максимальною частотою кадрів, контролюйте рівень шуму завдяки зниженій тепловій передачі та підвищуйте швидкість відгуку завдяки ексклюзивним застосункам Intel®.<br/><br/>Intel® Binary Optimization Tool<br/>Intel® Application Optimization "
                  },
                  {
                    "title": "tile3",
                    "imgUrl": "assets/images/gaming/arl_hx_tiles_bg.png",
                    "tileVideoUrl": "assets/images/gaming/arl_hx_tile3.png",
                    "tr_title": "ШІ, який дійсно допомагає",
                    "tr_subtitle": "Запускайте інструменти ШІ локально у фоновому режимі, як-от ігрові тренажери, засоби налаштування системи та оптимізації графіки, без додаткового навантаження на графічний або центральний процесор. Процесори Intel® Core™ Ultra 200HX Plus оснащені спеціальним енергоефективним механізмом ШІ для оптимізації вашого ігрового досвіду. "
                  }
                ],
                "badgeIcons": [
                  {
                    "imgUrl": "assets/images/gaming/arl_hx_footer_img.png",
                    "tr_badgeSubTitle": "Intel® Binary Optimization Tool — це додаткова функція, яка активується в розширеному режимі Intel® Application Optimization. Вона використовує політики Intel® Dynamic Tuning Technology та оптимізує продуктивність окремих ігор за умови їх запуску на відповідних конфігураціях із використанням деяких процесорів Intel® Core™. Докладніше можна дізнатися на сторінці <span class='ptl-gaming-https-url'>https://www.intel.com/content/www/us/en/support/articles/000095419/processors.html</span>, а відомості про продукти можна знайти на сайті ark.intel.com.<br/>Продуктивність залежить від способів використання, конфігурації та інших факторів. Дізнайтеся докладніше за посиланням intel.com/performanceindex.<br/>Результати продуктивності базуються на тестуванні станом на дати, зазначені в конфігураціях, і можуть не враховувати всі загальнодоступні оновлення. Інформацію про конфігурацію можна знайти в резервних файлах. Жоден продукт або компонент неможливо захистити повністю.<br/>Ваші витрати й результати можуть різнитися.<br/><br/>Технології Intel можуть вимагати наявності відповідного обладнання, програмного забезпечення або активації послуг.<br/> © Intel Corporation. Intel, логотип Intel та інші марки Intel є товарними знаками корпорації Intel або її дочірніх компаній. Інші назви та товарні знаки можуть бути власністю інших сторін."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Відкрийте в собі швидкість <span class='ddp-std-title-and-color'>і</span> потужність",
                  "tr_pretitle": "Intel® Core™ Ultra Серії&nbsp;3",
                  "tr_subtitle": "Це потужність Intel Inside®.",
                  "detailBGUrl": "assets/images/proc_ddp_ptl_bg.svg",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                  "titleArray": [
                    {
                      "title": "performance",
                      "imgUrl": "assets/images/proc_ddp_ptl_performance_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_ptl_performance_badge.svg",
                      "tr_title": "ПРОДУКТИВНІСТЬ",
                      "tr_subtitle": "Продуктивність, що працює у вашому темпі",
                      "SubSpecs": [
                        {
                          "tr_title": "Продуктивність, створена <span class='ddp-std-performance-popup-title'>для вашого ритму.</span>",
                          "tr_subtitle": "47 відкритих вкладок, рендеринг у трьох застосунках та нарада за 30 секунд.<br/>У такі моменти вам потрібен потужний ноутбук, що менше гріється, швидше працює та повністю під вашим контролем.",
                          "bgVideoUrl": "assets/videos/standard/redesign/std_performance.mp4"
                        }
                      ]
                    },
                    {
                      "title": "battery",
                      "imgUrl": "assets/images/proc_ddp_ptl_battery_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_ptl_battery_badge.svg",
                      "tr_title": "АКУМУЛЯТОР",
                      "tr_subtitle": "Акумулятор, що не відстає від вашої енергії",
                      "SubSpecs": [
                        {
                          "tr_title": "Створюйте,<span class='ddp-std-battery-popup-title'></span> грайте,<span class='ddp-std-battery-popup-title'></span> доводьте справу до кінця на одному заряді<sup><small>1</small></sup>",
                          "tr_subtitle": "Скільки б справ у вас не було — ваш ПК працює скільки треба. Продовжуйте роботу без підключення до розетки, уповільнень або пошуку джерела живлення.",
                          "bgVideoUrl": "assets/videos/standard/redesign/std_battery.mp4"
                        }
                      ]
                    },
                    {
                      "title": "gaming",
                      "imgUrl": "assets/images/proc_ddp_ptl_gaming_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_ptl_gaming_badge.svg",
                      "tr_title": "ІГРИ",
                      "tr_subtitle": "Чіткий геймплей. Максимальна продуктивність.",
                      "SubSpecs": [
                        {
                          "tr_title": "Чітка гра <span class='ddp-std-gaming-popup-title-and-color'>та</span> максимальна продуктивність​",
                          "tr_subtitle": "Грайте в тисячі інді-ігор та ігор класу AAA на ноутбуці: швидкому, ефективному і створеному для вашого стилю гри. Жодних затримок, «гальмувань» чи компромісів.",
                          "bgVideoUrl": "assets/videos/standard/redesign/std_gaming.mp4"
                        }
                      ]
                    },
                    {
                      "title": "ai_experiences",
                      "imgUrl": "assets/images/proc_ddp_ptl_ai_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_ptl_ai_badge.svg",
                      "tr_title": "НОВІ ВРАЖЕННЯ ВІД ШІ",
                      "tr_subtitle": "ШІ, що працює разом із вами",
                      "SubSpecs": [
                        {
                          "tr_title": "ШІ, що працює разом із вами",
                          "tr_subtitle": "Від узагальнення документів і впорядкування розкладу до покращення відеодзвінків у режимі реального часу — до ваших послуг більше інструментів штучного інтелекту, які полегшують виконання складних завдань та заощаджують час.",
                          "bgVideoUrl": "assets/videos/standard/redesign/std_ai_experiences.mp4"
                        }
                      ]
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Не просто ще один ПК.<br/>Це ваш ПК.",
                  "tr_subtitle": "Ваш світ — у вашому ноутбуці. Саме тому ноутбуки на базі процесорів <span class='processor_bold'>Intel® Core™ Ultra Серії 3</span> мають усе, що потрібно для будь-якої роботи:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "Творіть і грайте і доводьте справи до кінця на одному заряді",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "Продуктивність, що працює у вашому темпі",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "Чіткий геймплей. Максимальна продуктивність.",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ШІ, що працює разом із вами",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "Графіка, яка втілює ваше бачення в життя",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "Запускайте застосунки й ігри, які іншим не під силу",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "Дизайн, що відображає ваш стиль",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Усе найкраще,<br/>на що здатен ноутбук<sup>1</sup>.",
                  "tr_subtitle": "Усі тонкі та легкі ноутбуки версії Intel® Evo™ проходять ретельну перевірку, щоб забезпечити враження преміумкласу — завжди напоготові, швидкі й створені для будь-яких нових викликів.",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel3.svg",
                  "badgeUrl": "assets/images/badges/evo_ultra_ptl.svg",
                  "titleArray": [
                    {
                      "tr_title": "Продуктивність на ходу."
                    },
                    {
                      "tr_title": "Тривалий ресурс акумулятора в реальних умовах."
                    },
                    {
                      "tr_title": "Швидке заряджання."
                    },
                    {
                      "tr_title": "Миттєве пробудження."
                    },
                    {
                      "tr_title": "І не тільки."
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "Результати роботи окремих систем можуть значно різнитися залежно від конфігурації, способу використання та інших факторів. Докладніше на www.Intel.com/PerformanceIndex.<br/><br/>Функції штучного інтелекту можуть вимагати придбання програмного забезпечення, підписки або активації постачальником програмного забезпечення чи платформи, а також мати специфічні вимоги до конфігурації чи сумісності. Переваги конфіденційності даних стосуються нехмарних застосунків штучного інтелекту. Докладніше за посиланням: intel.com/AIPC.<br/><br/>Жоден продукт чи компонент неможливо захистити повністю.<br/><br/>Ваші витрати та результати можуть різнитися.<br/><br/>Технології Intel можуть вимагати наявності відповідного обладнання, програмного забезпечення або підключення послуг.<br/><br/>© Корпорація Intel. Intel, логотип Intel та інші марки Intel є товарними знаками корпорації Intel або її дочірніх компаній. Інші назви та товарні знаки можуть бути власністю інших сторін."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL_12XE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_pretitle": "Процесор Intel® Core™ Ultra [XX] із вбудованою графікою Intel® Arc™",
                  "tr_title": "Тонкі ПК, які стоять за вашими найвидатнішими ідеями.",
                  "tr_subtitle": "",
                  "detailBGUrl": "assets/images/proc_ddp_12xe_bg.svg",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                  "badgeUrl1": "assets/images/arc-badge.svg",
                  "titleArray": [
                    {
                      "title": "battery",
                      "imgUrl": "assets/images/proc_ddp_12xe_battery_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_12xe_battery_badge.svg",
                      "tr_title": "АКУМУЛЯТОР",
                      "tr_subtitle": "Видатні ідеї більше не потребують великих ПК",
                      "SubSpecs": [
                        {
                          "tr_title": "Нарешті – батарея, що не стримує вашу креативність",
                          "bgVideoUrl": "assets/videos/standard/redesign/12xe_battery.mp4",
                          "detailsArray": [
                            {
                              "tr_title": "Графіка студійного рівня, що завжди з вами."
                            },
                            {
                              "tr_title": "Створено для творчості та ігор протягом усього дня."
                            },
                            {
                              "tr_title": "Тонкий та легкий дизайн без жодних компромісів."
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "title": "gaming",
                      "imgUrl": "assets/images/proc_ddp_12xe_gaming_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_12xe_gaming_badge.svg",
                      "tr_title": "ІГРИ",
                      "tr_subtitle": "Творіть удень, грайте вночі",
                      "SubSpecs": [
                        {
                          "tr_title": "Творіть удень, <span class='ddp-12xe-gaming-popup-title-and-color'></span>грайте вночі",
                          "bgVideoUrl": "assets/videos/standard/redesign/12xe_gaming.mp4",
                          "detailsArray": [
                            {
                              "tr_title": "Графіка, готова до ігор, в ультратонкому дизайні."
                            },
                            {
                              "tr_title": "Запускайте улюблені застосунки та ігри."
                            },
                            {
                              "tr_title": "Грайте там, де вам зручно."
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "title": "graphics",
                      "imgUrl": "assets/images/proc_ddp_12xe_graphics_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_12xe_graphics_badge.svg",
                      "tr_title": "ГРАФІКА",
                      "tr_subtitle": "Вбудована графіка, що перевершує очікування",
                      "SubSpecs": [
                        {
                          "tr_title": "Вбудована графіка, що перевершує очікування",
                          "tr_subtitle": "Не варто недооцінювати інтегровану графіку. Завдяки більшій на 50% кількості ядер Intel® Arc™ X<sup>e</sup> ви отримуєте високу швидкість для ігор, редагування, рендерингу та трансляції — без додаткових витрат, збільшеної ваги або розряду акумулятора, характерних для дискретного графічного процесора. Для багатьох контент-мейкерів та геймерів це достатня потужність графіки, і вона вже вбудована у пристрій.",
                          "bgVideoUrl": "assets/videos/standard/redesign/12xe_graphics.mp4"
                        }
                      ]
                    },
                    {
                      "title": "ai_experiences",
                      "imgUrl": "assets/images/proc_ddp_12xe_ai_tile.png",
                      "tileBadgeUrl": "assets/images/badges/proc_ddp_12xe_ai_badge.svg",
                      "tr_title": "НОВІ ВРАЖЕННЯ ВІД ШІ",
                      "tr_subtitle": "ШІ, що працює разом із вами",
                      "SubSpecs": [
                        {
                          "tr_title": "ШІ, що працює разом із вами",
                          "tr_subtitle": "Від узагальнення документів і впорядкування розкладу до покращення відеодзвінків у режимі реального часу — до ваших послуг більше інструментів штучного інтелекту, які полегшують виконання складних завдань та заощаджують час.",
                          "bgVideoUrl": "assets/videos/standard/redesign/12xe_ai_experiences.mp4",
                          "detailsArray": [
                            {
                              "tr_title": "Система, на яку можна розраховувати."
                            },
                            {
                              "tr_title": "Усе працює одразу — без налаштувань."
                            },
                            {
                              "tr_title": "Захист, про який не потрібно думати."
                            },
                            {
                              "tr_title": "Безпека, що випереджає загрози."
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "tr_subtitle2": "Результати окремих систем можуть значно різнитися залежно від конфігурації, способу використання та інших факторів. Докладніше на www.Intel.com/PerformanceIndex. © Корпорація Intel"
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "panelType2": "",
                  "tr_title": "Не просто ще один ПК.<br/>Це ваш ПК",
                  "tr_subtitle": "Ваш світ — у вашому ноутбуці. Саме тому ноутбуки на базі процесорів <span class='processor_bold'>Intel® Core™ Ultra Серії 3</span> мають усе, що потрібно для будь-якої роботи:",
                  "detailBGUrl": "assets/images/processor_ptl12Xe_bg_panel2.png",
                  "titleArray": [
                    {
                      "tr_title": "Творіть і грайте і доводьте справи до кінця на одному заряді"
                    },
                    {
                      "tr_title": "Продуктивність, така ж мобільна, як і ви"
                    },
                    {
                      "tr_title": "Ваші улюблені ігри та застосунки просто працюють"
                    }
                  ],
                  "badgeIcons": [
                    {
                      "tr_badgeTitle": "Творіть і грайте і доводьте справи до кінця на одному заряді",
                      "imgUrl": "assets/images/proc_ptl_battery.svg"
                    },
                    {
                      "tr_badgeTitle": "Нарешті – батарея, що не стримує вашу креативність",
                      "imgUrl": "assets/images/proc_ptl_performance.svg"
                    },
                    {
                      "tr_badgeTitle": "Творіть удень,<br/>грайте вночі",
                      "imgUrl": "assets/images/proc_ptl_gaming.svg"
                    },
                    {
                      "tr_badgeTitle": "ШІ, що працює разом із вами",
                      "imgUrl": "assets/images/proc_ptl_aiExperience.svg"
                    },
                    {
                      "tr_badgeTitle": "Вбудована графіка, що перевершує очікування",
                      "imgUrl": "assets/images/proc_ptl_graphics.svg"
                    },
                    {
                      "tr_badgeTitle": "Запускайте застосунки й ігри, які іншим не під силу",
                      "imgUrl": "assets/images/proc_ptl_compatibility.svg"
                    },
                    {
                      "tr_badgeTitle": "Дизайн, що відображає ваш стиль",
                      "imgUrl": "assets/images/proc_ptl_design.svg"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-tile-panel",
                  "detailBGUrl": "assets/images/processor_ptl_bg_panel4.svg",
                  "tr_subtitle": "Результати роботи окремих систем можуть значно різнитися залежно від конфігурації, способу використання та інших факторів. Докладніше на www.Intel.com/PerformanceIndex.<br/><br/>Функції штучного інтелекту можуть вимагати придбання програмного забезпечення, підписки або активації постачальником програмного забезпечення чи платформи, а також мати специфічні вимоги до конфігурації чи сумісності. Переваги конфіденційності даних стосуються нехмарних застосунків штучного інтелекту. Докладніше за посиланням: intel.com/AIPC.<br/><br/>Жоден продукт чи компонент неможливо захистити повністю.<br/><br/>Ваші витрати та результати можуть різнитися.<br/><br/>Технології Intel можуть вимагати наявності відповідного обладнання, програмного забезпечення або підключення послуг.<br/><br/>© Корпорація Intel. Intel, логотип Intel та інші марки Intel є товарними знаками корпорації Intel або її дочірніх компаній. Інші назви та товарні знаки можуть бути власністю інших сторін."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_PTL_GAMING",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "panelType1": "ptl-gaming-tile-panel1",
                  "tr_title": "Відкрийте для себе ідеальний ігровий досвід.",
                  "tr_pretitle": "Intel® Core™ Ultra [XX] Серія 3",
                  "detailBGUrl": "assets/images/gaming/ptl-gaming-panel1-poster.png",
                  "videoUrl": "assets/videos/gaming/ptl_gaming_panel1_bg.mp4",
                  "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg"
                },
                {
                  "panelType1": "ptl-gaming-tile-panel2",
                  "tr_title": "Безпрецедентна продуктивність",
                  "tr_pretitle": "Підніміться в рейтингах завдяки оптимізованому ігровому процесу. ",
                  "detailBGUrl": "assets/images/gaming/ptl-gaming-panel2-poster.png",
                  "videoUrl": "assets/videos/gaming/ptl_gaming_panel2_bg.mp4"
                },
                {
                  "panelType1": "ptl-gaming-tile-panel3",
                  "tr_title": "та вишуканий дизайн",
                  "tr_pretitle": "Отримайте потужність стаціонарного ПК в портативному корпусі.",
                  "detailBGUrl": "assets/images/gaming/ptl-gaming-panel3-poster.png",
                  "videoUrl": "assets/videos/gaming/ptl_gaming_panel3_bg.mp4"
                },
                {
                  "panelType1": "ptl-gaming-tile-panel4",
                  "detailBGUrl": "",
                  "badgeIcons": [
                    {
                      "tr_badgeSubTitle": "Грайте у найвибагливіші ігри, які існують сьогодні — і які вийдуть у майбутньому.",
                      "tr_badgeTitle": "і підтримка AAA-хітів",
                      "imgUrl": "assets/images/gaming/ptl-gaming-carousel1-bg.png"
                    },
                    {
                      "tr_badgeSubTitle": "Забезпечує тривалий ресурс акумулятора для найактуальніших завдань.",
                      "tr_badgeTitle": "більшийресурс акумулятора",
                      "tr_badgeSubTitle1": "та надійне<br/>підключення",
                      "tr_badgeSubTitle2": "Залишайтеся в грі — навіть в найбільш завантажених мережах — завдяки підключенню Wi-Fi 7.",
                      "imgUrl": "assets/images/gaming/ptl-gaming-carousel2-bg.png"
                    },
                    {
                      "tr_badgeSubTitle": "Сучасний ШІ — ваш новий персональний помічник.",
                      "tr_badgeTitle": "та<br/>винятковий штучний інтелект",
                      "imgUrl": "assets/images/gaming/ptl-gaming-carousel3-bg.png"
                    }
                  ]
                },
                {
                  "panelType1": "ptl-gaming-tile-panel5",
                  "detailBGUrl": "",
                  "tr_title": "Юридична інформація та застереження",
                  "tr_subtitle": "Може потребувати активації обладнання, програмного забезпечення або сервісів.<br/><br/> Індивідуальні результати системи можуть суттєво відрізнятися залежно від сценарію використання, ємності батареї та інших чинників; детальніше — на <span class='ptl-gaming-http-url'>http://intel.com/PerformanceIndex</span>.<br/><br/> Хоча Wi-Fi 7 є зворотно сумісним із попередніми поколіннями, нові можливості Wi-Fi 7 потребують ПК, оснащених рішеннями Intel® Wi-Fi 7, активації з боку виробника ПК (OEM), підтримки операційної системи та використання з відповідними маршрутизаторами/точками доступу/шлюзами Wi-Fi 7. Діапазон 6 ГГц для Wi-Fi 7 може бути недоступним у деяких регіонах. Продуктивність залежить від сценарію використання, конфігурації та інших чинників. Детальніше щодо заявлених показників продуктивності — на <span class='ptl-gaming-https-url'>https://edc.intel.com/content/www/us/en/products/performance/benchmarks/connectivity/</span>.<br/><br/> Функції штучного інтелекту можуть потребувати придбання програмного забезпечення, оформлення підписки або активації постачальником ПЗ чи платформи, а також можуть мати окремі вимоги до конфігурації або сумісності. Переваги щодо затримки передачі даних, вартості та конфіденційності стосуються застосунків ШІ, що працюють без використання хмарних сервісів. Дізнайтесь більше на <span class='ptl-gaming-http-url'>http://intel.com/AIPC</span>.<br/><br/> ©Intel Corporation."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_CORE_3RD_GEN_WCL_STANDARD",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "tileDetails": [
                {
                  "tr_title": "Intel® Core серії 3 для",
                  "tr_subtitle": "",
                  "detailBGUrl": "",
                  "tr_pretitle": "Intel® Core™ [XX] Серія 3",
                  "badgeUrl": "assets/images/badges/intel_core_[XX]_wcl.svg",
                  "tileBG": "assets/lang/[XX]/wcl/everyday.png",
                  "badgeIcons": [
                    {
                      "badgeUrl": "assets/images/wcl/Windows_icon.svg",
                      "tr_badgeTitle": "Windows* 11"
                    },
                    {
                      "badgeUrl": "assets/images/wcl/sparkles_icon.svg",
                      "tr_badgeTitle": "вбудована допомога ШІ"
                    },
                    {
                      "badgeUrl": "assets/images/wcl/cursor_icon.svg",
                      "tr_badgeTitle": "працює з вашими застосунками"
                    },
                    {
                      "badgeUrl": "assets/images/wcl/crips_icon.svg",
                      "tr_badgeTitle": "чітке та різке зображення"
                    },
                    {
                      "badgeUrl": "assets/images/wcl/norton_icon.svg",
                      "tr_badgeTitle": "Norton"
                    },
                    {
                      "badgeUrl": "assets/images/wcl/unplugged_icon.svg",
                      "tr_badgeTitle": "працюйте без підзаряджання довше"
                    }
                  ],
                  "titleArray": [
                    {
                      "imgUrl": "assets/images/wcl/laptop_panel1.png",
                      "tr_title": "Запускайте <span class='wcl-panel1'>всі свої улюбленізастосунки</span><br/>.",
                      "tr_subtitle": "Від Zoom* до Adobe* та Norton* — усе працює одразу після запуску. Торкайтеся, вводьте текст, говоріть — взаємодійте так, як вам зручно. Зарядний пристрій не обовʼязковий.",
                      "SubSpecs": [
                        {
                          "imgUrl": "",
                          "tr_title": "швидко, стабільно, готово"
                        },
                        {
                          "imgUrl": "assets/images/wcl/crips_icon.svg",
                          "tr_title": "чітке та різке зображення"
                        },
                        {
                          "imgUrl": "assets/images/wcl/adobe_icon.svg",
                          "tr_title": ""
                        },
                        {
                          "imgUrl": "",
                          "tr_title": "ідеально для запійного перегляду"
                        }
                      ]
                    },
                    {
                      "imgUrl": "assets/images/wcl/laptop_panel2.png",
                      "tr_title": "Навчайтеся та грайте <br/><span class='wcl-panel2'>більше.</span> Заряджайте рідше.",
                      "tr_subtitle": "Від інтенсивного навчання зранку до легких ігор увечері — цей акумулятор створений для тривалої роботи. Пишіть, редагуйте та створюйте підсумки під час навчання за допомогою вбудованого ШІ, а також годинами насолоджуйтеся улюбленими серіалами завдяки чіткій та якісній графіці.",
                      "SubSpecs": [
                        {
                          "imgUrl": "assets/images/wcl/unplugged_icon.svg",
                          "tr_title": "працюйте без підзаряджання довше"
                        },
                        {
                          "imgUrl": "",
                          "tr_title": "застосунки для навчання"
                        },
                        {
                          "imgUrl": "",
                          "tr_title": "транслюйте годинами"
                        }
                      ]
                    },
                    {
                      "imgUrl": "assets/images/wcl/laptop_panel3.png",
                      "tr_title": "Нехай ваша<br/>інвестиція <span class='wcl-panel3'>служить довше.</span>",
                      "tr_subtitle": "Створено для продуктивної роботи із вбудованими засобами безпеки — надійно працює з бізнес-застосунками, якими ви користуєтеся найчастіше. Усе працює без зайвих труднощів, а ресурс акумулятора вас приємно здивує.",
                      "SubSpecs": [
                        {
                          "tr_title": "працює з вашими застосунками",
                          "imgUrl": ""
                        },
                        {
                          "tr_title": "",
                          "imgUrl": "assets/images/wcl/invest_icon.svg"
                        },
                        {
                          "tr_title": "Windows* 11",
                          "imgUrl": "assets/images/wcl/Windows_icon.svg"
                        },
                        {
                          "imgUrl": "assets/images/wcl/sparkles_icon.svg",
                          "tr_title": "вбудована допомога ШІ"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "graphics": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_tileTitle1": "Виділена графіка",
                "tr_title": "ЩО ТАКЕ ГРАФІЧНИЙ ПРОЦЕСОР?",
                "tr_pretitle": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Графічний процесор, або скорочено ГП, створює зображення, які ви бачите на екрані вашого пристрою.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "Вбудований графічний процесор",
                    "tr_badgeSubTitle": "Вбудований графічний процесор використовує ту ж оперативну пам'ять, що й інші елементи комп’ютера, що робить його енергоефективнішим.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "Дискретний графічний процесор",
                    "tr_badgeSubTitle": "Цей тип графічних процесорів є найпотужнішим, оскільки для створення високоякісної графіки вони залучають власну оперативну пам’ять та інші ресурси.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-hybrid-GPU-badge.png",
                    "tr_badgeTitle": "Гібридний графічний процесор",
                    "tr_badgeSubTitle": "Цей тип графічних процесорів є найпотужнішим, оскільки для створення високоякісної графіки вони залучають власну оперативну пам’ять та інші ресурси.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/video-editing.png",
                    "tr_badgeTitle": "Просте редагування фото й відео",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/binge-4k.svg",
                    "tr_badgeTitle": "Створення відеоконтенту з роздільною здатністю 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/games.svg",
                    "tr_badgeTitle": "Популярні ігри з неймовірною деталізацією",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics_dual_gpus.svg",
                    "tr_badgeTitle": "Подвійні графічні процесори",
                    "tr_badgeSubTitle": "У деяких системах, наприклад, обладнаних графікою Intel® Iris® X<sup class='small_text_sup_xe'>e</sup>, можна використовувати переваги як вбудованого процесора, так і дискретного графічного процесора для розподілу графічного навантаження.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphic-integrated-GPU-badge.png",
                    "tr_badgeTitle": "Вбудований графічний процесор",
                    "tr_badgeSubTitle": "Такий графічний процесор вбудовується в мікросхему основного або центрального процесора. Він використовує ту ж оперативну пам’ять і ресурси, що й інші компоненти комп’ютера. Процесори цього типу є енергоефективнішими та дозволяють створювати більш легкі й тонкі пристрої.",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/graphics-discrete-GPU-badge.svg",
                    "tr_badgeTitle": "Виділений графічний процесор",
                    "tr_badgeSubTitle": "Цей тип графічних процесорів є найпотужнішим, оскільки для створення високоякісної графіки вони залучають власну оперативну пам’ять та інші ресурси.",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "",
                "panelType2": "gaming-graphics",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Звичайна",
                    "tr_badgeSubTitle": "Відео-пам’ять до 4&nbsp;ГБ",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Конкурентна",
                    "tr_badgeSubTitle": "Відео-пам’ять до 8&nbsp;ГБ",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Ультра",
                    "tr_badgeSubTitle": "Відео-пам’ять понад 8&nbsp;ГБ",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Потужна відеокарта",
                "tr_pretitle": "[graphic_display]",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PLUS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Вбудований графічний процесор для насиченого та яскравого зображення",
                "tr_pretitle": "Графіка Intel® Iris® Plus",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Графіка Intel® Iris® Plus дає вам змогу насолоджуватися відео високої чіткості у форматі 4K HDR та іграми з роздільною здатністю Full HD&nbsp;— для цього більше не потрібна додаткова відеокарта.",
                "badgeUrl": "assets/images/badges/intel-IRIS-plus.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Приголомшливі візуальні ефекти, продуктивність без зайвих зусиль",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Графіка Intel® забезпечує якісно нову продуктивність інтегрованої графіки для безпроблемної творчої роботи контент-мейкерами і чудових ігрових можливостей.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_PRO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Графіка Intel®&nbsp;Iris®&nbsp;Pro",
                "tr_pretitle": "",
                "tr_subtitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "UHD_FEATURING_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "UHD-графіка Intel® з архітектурою X<sup class='small_text_sup_xe'>e</sup>",
                "tr_pretitle": "Візуальні ефекти з повним зануренням",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_text1": "Відкрийте для себе полегшене редагування фото й відео, створюйте відеовміст преміумкласу з роздільною здатністю 4K або грайте в популярні ігри з неймовірною деталізацією.",
                "tr_photo_text": "Просте редагування фото й відео",
                "tr_video_text": "Створення відеоконтенту з роздільною здатністю 4K",
                "tr_game_text": "Популярні ігри з неймовірною деталізацією",
                "badgeUrl": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "НАБАГАТО БІЛЬШЕ НІЖ ГАРНА КАРТИНКА",
                "tr_subtitle": "Працюючи сумісно з процесором (або ЦП), відеокарта (або ГП) допомагає визначити, як працюють ваші ігри та як вони виглядають. Інформація про оперативну відеопам’ять, яка відповідає лише за графіку — швидкий спосіб дізнатися рівень вашої відеокарти.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_630",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ НАСИЧЕНОЇ КОМП’ЮТЕРНОЇ ГРАФІКИ В ІГРАХ",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна окрема відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "Intel_UHD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ НАСИЧЕНОЇ КОМП’ЮТЕРНОЇ ГРАФІКИ В ІГРАХ",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна окрема відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "[graphic_display]",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_pretitle": "НАБАГАТО БІЛЬШЕ НІЖ ГАРНА КАРТИНКА",
                "tr_subtitle": "Працюючи сумісно з процесором (або ЦП), відеокарта (або ГП) допомагає визначити, як працюють ваші ігри та як вони виглядають. Інформація про оперативну відеопам’ять, яка відповідає лише за графіку — швидкий спосіб дізнатися рівень вашої відеокарти.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Потужна відеокарта",
                "tr_pretitle": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "ДЛЯ НАСИЧЕНОЇ КОМП’ЮТЕРНОЇ ГРАФІКИ В ІГРАХ",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації.",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "detailPageName": "LESS_THAN_0",
                    "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна окрема відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "0_TO_4",
                    "tr_subtitle": "Забезпечує достатньо потужності, щоб задовольнити мінімальні вимоги до гри.",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "4_TO_8",
                    "tr_subtitle": "Для гравців вищого рівня, яким потрібна максимальна продуктивність в іграх",
                    "tr_title": ""
                  },
                  {
                    "detailPageName": "GREATER_THAN_8",
                    "tr_subtitle": "Для геймерів-професіоналів, які використовують свій ПК ще й для інтенсивного створення вмісту",
                    "tr_title": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_HD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Виняткова якість відео та ігри з ефектом занурення",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "Отримайте максимум переваг від екрана з високою роздільною здатністю завдяки HD-графіці Intel®, насолоджуючись розкішною якістю мультимедійного контенту та можливостями вбудованого графічного процесора.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_UHD_620",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Яскраві відео та зображення немов оживають",
                "tr_pretitle": "[graphic_display]",
                "tr_subtitle": "Більше деталей та чудових кольорів у ваших трансляціях та фото.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Виняткове створення контенту й ігри",
                "tr_pretitle": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Від розваг з ефектом занурення та створення професійного контенту до звичайних ігор&nbsp;— графічний процесор Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup> забезпечує неймовірну продуктивність графіки тонких і легких ПК.",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_pretitle": "ДЛЯ НАСИЧЕНОЇ КОМП’ЮТЕРНОЇ ГРАФІКИ В ІГРАХ",
                "tr_title": "Графіка Intel®&nbsp;Iris®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe.svg",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна окрема відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[x] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_IRIS_XE_MAX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Розкрийте свій творчий потенціал",
                "tr_pretitle": "Графічний процесор Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Виконуйте творчі проєкти та пориньте у світ найрізноманітніших ігор завдяки поєднаній графічній потужності вбудованого процесора та першого механізму дискретної графіки Intel®.",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg"
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "tr_title": "Графічний процесор Intel® Iris® X<sup class='small_text_sup_xe'>e</sup> MAX",
                "tr_pretitle": "ДЛЯ НАСИЧЕНОЇ КОМП’ЮТЕРНОЇ ГРАФІКИ В ІГРАХ",
                "panelType1": "header-BadgeIconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/badges/intel-iris-xe-max.svg",
                "tr_subtitle": "Для максимально ефективної обробки графічних даних потрібна окрема відеокарта, призначена спеціально для створення дивовижних реалістичних зображень і плавної анімації",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[x] ГБ<br/></span><span class='subtitle-value'>ВІДЕОПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_tileTitle": "Графіка",
                "tr_title": "Неймовірна вбудована графіка",
                "tr_subtitle": "Насолоджуйтесь високою чіткістю та якістю ігор, фільмів та онлайн-відео.",
                "badgeUrl": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "ARC_GRAPHICS",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Графіка",
                "badgeUrl": "assets/images/arc-badge.svg",
                "tileBG": "",
                "detailBGUrl": "assets/images/arc_graphics/fallback_arc_graphics.svg",
                "tr_subtitle": "",
                "panelType1": "header-BadgeIconTop-arc",
                "panelType2": "",
                "tr_title": ""
              }
            }
          ],
          "factTagTypes": [
            {
              "factTagType": "Arc_Graphics_Panel_Content",
              "navText": [
                {
                  "specName": "Arc_Graphics_Badge_Icon",
                  "specDetails": {
                    "targetURL": "badgeIconUrl",
                    "tr_specTitle": "",
                    "tr_specText": ""
                  }
                },
                {
                  "specName": "Graphics_Boost_Workflow",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Прискорте свої робочі процеси"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Додайте потужності своїм іграм"
                  }
                },
                {
                  "specName": "Graphics_Supercharge_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Додайте потужності своїм іграм"
                  }
                },
                {
                  "specName": "Graphics_Level_Up_Your_Game",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Виведіть гру на новий рівень"
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel2.png",
                    "tr_specTitle": "РОЗКРИЙТЕ СВІЙ ТВОРЧИЙ ПОТЕНЦІАЛ",
                    "tr_specText": "Підвищуйте свою продуктивність, де б ви не були, за допомогою найширших можливостей для роботи з мультимедіа, таких як <strong>апаратне кодування AV1</strong> та створення контенту з ШІ-прискоренням<sup>22</sup>."
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel2.png",
                    "tr_specTitle": "РОЗКРИЙТЕ СВІЙ ТВОРЧИЙ ПОТЕНЦІАЛ",
                    "tr_specText": "Підвищуйте свою продуктивність за допомогою найширших можливостей для роботи з мультимедіа, таких як <strong>перше в галузі апаратне кодування AV1</strong> та створення контенту зі спеціальним прискоренням на базі ШІ<sup>22</sup>."
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel3.png",
                    "tr_specTitle": "РОЗКРИЙТЕ СВІЙ ТВОРЧИЙ ПОТЕНЦІАЛ",
                    "tr_specText": "Створюйте сучасний контент  за допомогою <strong>першого в галузі апаратного кодування AV1</strong> та вдосконаленого механізму <strong>X<sup>e</sup> Media Engine</strong> зі спеціальним прискоренням на базі ШІ<sup>22</sup>."
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "РОЗКРИЙТЕ СВІЙ ТВОРЧИЙ ПОТЕНЦІАЛ",
                    "tr_specText": "Створюйте сучасний контент  за допомогою <strong>першого в галузі апаратного кодування AV1</strong> та вдосконаленого механізму <strong>X<sup>e</sup> Media Engine</strong> зі спеціальним прискоренням на базі ШІ<sup>22</sup>."
                  }
                },
                {
                  "specName": "Unleash_Your_Creativity_With_Intel_X_Engine_12",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel3.png",
                    "tr_specTitle": "РОЗКРИЙТЕ СВІЙ ТВОРЧИЙ ПОТЕНЦІАЛ",
                    "tr_specText": "Створюйте сучасний контент  за допомогою <strong>першого в галузі апаратного кодування AV1</strong> та вдосконаленого механізму <strong>X<sup>e</sup> Media Engine</strong> зі спеціальним прискоренням на базі ШІ<sup>22</sup>."
                  }
                },
                {
                  "specName": "Portability_Meets_Performance",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel3.png",
                    "tr_specTitle": "ПОРТАТИВНІСТЬ І ПРОДУКТИВНІСТЬ",
                    "tr_specText": "Передові ігрові можливості забезпечують високий рівень продуктивності у найсучасніших іграх, де б ви не були. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate: </strong> неймовірна реалістичність ігор завдяки новітнім графічним технологіям, таким як трасування променів і оптимізація шейдингу."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_panel4.png",
                    "tr_specTitle": "ПОВНИЙ КОНТРОЛЬ НАД ГРОЮ",
                    "tr_specText": "<strong>Центр керування Intel® Arc™</strong> забезпечує легке налаштування безперебійного оновлення драйверів, оптимізацію ігор та багато іншого завдяки інтуїтивно зрозумілому та сучасному інтерфейсу."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_panel4.png",
                    "tr_specTitle": "ПОВНИЙ КОНТРОЛЬ НАД ГРОЮ",
                    "tr_specText": "<strong>Центр керування Intel® Arc™</strong> забезпечує легке налаштування безперебійного оновлення драйверів, оптимізацію ігор та багато іншого завдяки інтуїтивно зрозумілому та сучасному інтерфейсу."
                  }
                },
                {
                  "specName": "Take_Control_Of_Your_Games_1",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A730M_panel4.png",
                    "tr_specTitle": "ПОВНИЙ КОНТРОЛЬ НАД ГРОЮ",
                    "tr_specText": "Отримуйте безперебійне оновлення драйверів та оптимізуйте свої улюблені ігри за допомогою програмного забезпечення <strong>Центр керування Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop2",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A310_newPanel5.png",
                    "tr_specTitle": "ВИКОРИСТОВУЙТЕ МАКСИМУМ МОЖЛИВОСТЕЙ ПЛАТФОРМИ INTEL®",
                    "tr_specText": "Відкрийте переваги технології Intel® Deep Link, поєднавши можливості <strong>технології Intel® Deep Link</strong> та сумісного процесора Intel® Core™ для покращення вражень від створення контенту, ігор і трансляцій."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_A580",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_newPanel5.png",
                    "tr_specTitle": "ВИКОРИСТОВУЙТЕ СИСТЕМУ INTEL® НА МАКСИМУМ",
                    "tr_specText": "Відкрийте переваги технології Intel® Deep Link, поєднавши можливості <strong>технології Intel® Deep Link</strong> та сумісного процесора Intel® Core™ для покращення вражень від створення контенту, ігор і трансляцій."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel5.png",
                    "tr_specTitle": "ВИКОРИСТОВУЙТЕ МАКСИМУМ МОЖЛИВОСТЕЙ ПЛАТФОРМИ INTEL®",
                    "tr_specText": "Відкрийте переваги технології Intel® Deep Link, поєднавши можливості <strong>технології Intel® Deep Link</strong> та сумісного процесора Intel® Core™ для покращення вражень від створення контенту, ігор і трансляцій."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_Platform",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "ВИКОРИСТОВУЙТЕ МАКСИМУМ МОЖЛИВОСТЕЙ ПЛАТФОРМИ INTEL®",
                    "tr_specText": "Відкрийте переваги технології Intel® Deep Link, поєднавши можливості <strong>технології Intel® Deep Link</strong> та сумісного процесора Intel® Core™ для покращення вражень від створення контенту, ігор і трансляцій."
                  }
                },
                {
                  "specName": "Maximize_Your_Intel_System",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A350M_newPanel5.png",
                    "tr_specTitle": "ВИКОРИСТОВУЙТЕ СИСТЕМУ INTEL® НА МАКСИМУМ",
                    "tr_specText": "Відкрийте переваги технології Intel® Deep Link, поєднавши можливості <strong>технології Intel® Deep Link</strong> та сумісного процесора Intel® Core™ для покращення вражень від створення контенту, ігор і трансляцій."
                  }
                },
                {
                  "specName": "Take_Center_Stage",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel4.png",
                    "tr_specTitle": "БУДЬТЕ В ЦЕНТРІ УВАГИ",
                    "tr_specText": "Проводьте бездоганні трансляції завдяки новітнім технологіям потокового передавання, реалізованим у програмному забезпеченні <strong>Центр керування Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Take_Center_Stage_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel4.png",
                    "tr_specTitle": "БУДЬТЕ В ЦЕНТРІ УВАГИ",
                    "tr_specText": "Проводьте бездоганні трансляції завдяки новітнім технологіям потокового передавання, реалізованим у програмному забезпеченні <strong>Центр керування Intel® Arc™</strong>."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "ГРАЙТЕ З ВИСОКОЮ ПРОДУКТИВНІСТЮ ТА ПОВНИМ ЗАНУРЕННЯМ",
                    "tr_specText": "Поставте продуктивність на перше місце у найновіших іграх класу AAA з високою роздільною здатністю та швидкістю оновлення. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate: </strong> неймовірна реалістичність ігор завдяки новітнім графічним технологіям, таким як трасування променів і оптимізація шейдингу."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming_Desktop",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A770_panel2.png",
                    "tr_specTitle": "ГРАЙТЕ З ВИСОКОЮ ПРОДУКТИВНІСТЮ ТА ПОВНИМ ЗАНУРЕННЯМ",
                    "tr_specText": "Поставте продуктивність на перше місце у найновіших іграх класу AAA з високою роздільною здатністю та швидкістю оновлення. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate: </strong> неймовірна реалістичність ігор завдяки новітнім графічним технологіям, таким як трасування променів і оптимізація шейдингу."
                  }
                },
                {
                  "specName": "Give_Your_Games_A_Boost",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A380_panel3.png",
                    "tr_specTitle": "ПРИСКОРТЕ СВОЇ ІГРИ",
                    "tr_specText": "Отримайте переваги, які виведуть ігровий процес на новий рівень: <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate: </strong>неймовірна реалістичність ігор завдяки новітнім графічним технологіям, таким як трасування променів і оптимізація шейдингу."
                  }
                },
                {
                  "specName": "Experience_Advanced_Fast_Paced_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A580_panel2.png",
                    "tr_specTitle": "НАСИЧЕНИЙ ІГРОВИЙ ПРОЦЕС НА ПОВНІЙ ШВИДКОСТІ",
                    "tr_specText": "Насолоджуйтеся плавною грою в багатьох популярних іграх класу AAA — від динамічних кіберспортивних шутерів до захопливих стратегій в реальному часі. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate:  </strong>виведіть свої ігри на новий рівень реалістичності за допомогою графічних технологій, таких як трасування променів і затінення змінної швидкості."
                  }
                },
                {
                  "specName": "Experience_Immersive_Hiigh_Performance_Gaming",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A750_panel2.png",
                    "tr_specTitle": "ГРАЙТЕ З ВИСОКОЮ ПРОДУКТИВНІСТЮ ТА ПОВНИМ ЗАНУРЕННЯМ",
                    "tr_specText": "Поставте продуктивність на перше місце у найновіших іграх класу AAA з високою роздільною здатністю та швидкістю оновлення. <br/><br/><strong>X<sup>e</sup>SS (X<sup>e</sup> Super Sampling):</strong> технологія Intel® для масштабування за допомогою ШІ, яка підвищує продуктивність та плавність ігор. <br/><br/>Підтримка <strong>DirectX* 12 Ultimate: </strong> неймовірна реалістичність ігор завдяки новітнім графічним технологіям, таким як трасування променів і оптимізація шейдингу."
                  }
                },
                {
                  "specName": "Graphics_Universe",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Графічний всесвіт, в якому є місце для кожного"
                  }
                },
                {
                  "specName": "Accelerate_Your_Frames",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel2.png",
                    "tr_specTitle": "ШВИДША ЧАСТОТА КАДРІВ, ШВИДША ГРА",
                    "tr_specText": "Технологія Intel® X<sup class='small_text_sup_xe'>e</sup> Super Sampling (X<sup class='small_text_sup_xe'>e</sup>SS) виводить ігровий процес на новий рівень завдяки масштабуванню на базі ШІ — для досягнення максимальної продуктивності та високої точності зображення. X<sup class='small_text_sup_xe'>e</sup>SS оптимізовано для графічних продуктів Intel® Arc™, тож ви можете повною мірою скористатися перевагами апаратного прискорення Intel® X<sup class='small_text_sup_xe'>e</sup> Matrix Extensions (Intel® XMX)."
                  }
                },
                {
                  "specName": "Ultimate_Visuals_Are_Here",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel3.png",
                    "tr_specTitle": "ЗУСТРІЧАЙТЕ НЕЙМОВІРНІ ВІЗУАЛЬНІ ЕФЕКТИ",
                    "tr_specText": "Повна підтримка DirectX* 12 Ultimate на всіх графічних процесорах Intel® Arc™ дозволяє насолоджуватися приголомшливим, захоплюючим ігровим процесом завдяки новітнім графічним технологіям, як-от трасування променів, шейдинг зі змінною швидкістю, сітковий шейдинг та зворотний зв’язок семплера — основні вимоги ігор наступного покоління."
                  }
                },
                {
                  "specName": "Seamless_Photos_And_Videos",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel4.png",
                    "tr_specTitle": "ВИНЯТКОВІ МОЖЛИВОСТІ РОБОТИ З ФОТО, ВІДЕО Й МУЛЬТИМЕДІА",
                    "tr_specText": "Дайте волю своїй уяві та полоніть аудиторію створенням різноманітного цифрового контенту за допомогою наддосконалого медіапроцесора на базі ШІ, прискореного за допомогою технологій Intel®. Створюйте вражаючий контент на основі графіки з підтримкою всіх поточних провідних медіаформатів, використовуючи при цьому найдосконаліші можливості кодування відео AV1."
                  }
                },
                {
                  "specName": "Experience_Cutting_Edge",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/A5XXM_panel5.png",
                    "tr_specTitle": "НАСОЛОДЖУЙТЕСЬ НАДСУЧАСНИМИ ЗАСОБАМИ ДЛЯ ТВОРЧОСТІ ТА ІГОР З ВИКОРИСТАННЯМ ШІ",
                    "tr_specText": "Графіка Intel® Arc™ відкриває потужні можливості штучного інтелекту, від складних творчих завдань до захоплюючих ігор. Отримайте максимум від сучасного вдосконаленого програмного забезпечення для створення контенту, зокрема генерацію зображення на основі опису та редагування відео за допомогою ШІ. Крім того, насолоджуйтесь ігровим процесом у високій роздільній здатності завдяки масштабуванню X<sup class='small_text_sup_xe'>e</sup>SS із прискоренням на основі штучного інтелекту."
                  }
                },
                {
                  "specName": "Professional_Graphics",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc_pro_badge.png",
                    "tr_specTitle": "Графіка",
                    "tr_specText": "Тут починається професійна графіка"
                  }
                },
                {
                  "specName": "Designers_And_Engineers",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel2.png",
                    "tr_specTitle": "ЧУДОВИЙ ВИБІР ДЛЯ ТВОРЧИХ ЛЮДЕЙ, ДИЗАЙНЕРІВ ТА ІНЖЕНЕРІВ",
                    "tr_specText": "Доступна на вибраних процесорах Intel® Core™ Ultra серії H вбудована графіка Intel® Arc™ Pro у два рази підвищує продуктивність графіки завдяки сертифікації незалежних постачальників програмного забезпечення (ISV) для додаткової надійності, а також забезпечує ефективне апаратне прискорення штучного інтелекту та трасування променів, дозволяючи створювати вражаючий контент на ходу. <br/><br/><span class='expandable_heading'>Сертифікація програмного забезпечення<br/></span><br/>Протягом багатьох років Intel працює пліч-о-пліч із сотнями компаній-розробників програмного забезпечення, і цей неперевершений досвід втілено у графічній карті Intel® Arc™ Pro серії A. Сертифікація є настільки ж важливою для нас, як і для вас."
                  }
                },
                {
                  "specName": "Making_Ai_Attainable",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "РОБИМО ШТУЧНИЙ ІНТЕЛЕКТ ДОСЯЖНИМ",
                    "tr_specText": "Ця лінійка графічних процесорів включає широкий вибір чудових технологій, зокрема підтримку сумісних інструментів штучного інтелекту із вбудованим спеціальним прискоренням штучного інтелекту там, де це необхідно."
                  }
                },
                {
                  "specName": "Ray_Tracing",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel3.png",
                    "tr_specTitle": "ТРАСУВАННЯ ПРОМЕНІВ БЕЗ ДОДАТКОВИХ ВИТРАТ",
                    "tr_specText": "Графічні карти повинні робити більше, ніж просто виводити пікселі на дисплеї, вони також повинні прискорювати створення красивих зображень. Апаратна технологія трасування променів, вбудована в графіку Intel® Arc™ Pro серії A, дозволяє сумісному програмному забезпеченню виконувати ці нові робочі процеси на професійному рівні. Зазвичай вважають, що трасування променів доступне лише на дорогій графіці, але найновіша серія професійних графічних процесорів Intel перевершила ці очікування."
                  }
                },
                {
                  "specName": "Immersive_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel5.png",
                    "tr_specTitle": "ЗАХОПЛИВІ ДИСПЛЕЇ РОЗШИРЮЮТЬ МОЖЛИВОСТІ КОНТЕНТ-МЕЙКЕРІВ",
                    "tr_specText": "Повна підтримка DirectX* 12 Ultimate на всіх графічних процесорах Intel® Arc™ дозволяє насолоджуватися приголомшливим, захоплюючим ігровим процесом завдяки новітнім графічним технологіям, як-от трасування променів, шейдинг зі змінною швидкістю, сітковий шейдинг та зворотний зв’язок семплера — основні вимоги ігор наступного покоління."
                  }
                },
                {
                  "specName": "Dynamically_Optimised_Images",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXX_pro_panel6.png",
                    "tr_specTitle": "ДИНАМІЧНО ОПТИМІЗОВАНЕ ЗОБРАЖЕННЯ",
                    "tr_specText": "Завдяки виділеному апаратному декодуванню на графічних процесорах Pro, технологія Dolby Vision* допомагає додати більшу глибину, вищий контраст та більше кольорів на сумісному дисплеї. Dolby Vision* розкриває весь потенціал технології HDR, динамічно оптимізуючи якість зображення залежно від вашого сервісу, пристрою відображення та платформи, щоб завжди створювати приголомшливе зображення."
                  }
                },
                {
                  "specName": "Expertly_Verified_Software",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel2.png",
                    "tr_specTitle": "ПРОГРАМНЕ ЗАБЕЗПЕЧЕННЯ ПЕРЕВІРЕНЕ ЕКСПЕРТАМИ",
                    "tr_specText": "Протягом багатьох років Intel працює пліч-о-пліч із сотнями компаній-розробників програмного забезпечення, і цей неперевершений досвід втілено у графіці Intel® Arc™ Pro серії A. Сертифікація та кваліфікація робочого процесу програмного забезпечення так само важливі для нас, як і для вас."
                  }
                },
                {
                  "specName": "Ray_Tracing_Mobile",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel3.png",
                    "tr_specTitle": "ТРАСУВАННЯ ПРОМЕНІВ БЕЗ ДОДАТКОВИХ ВИТРАТ",
                    "tr_specText": "Графічні карти повинні робити більше, ніж просто виводити пікселі на дисплеї, вони також повинні прискорювати створення красивих зображень. Апаратна технологія трасування променів, вбудована в графіку Intel® Arc™ Pro серії A, дозволяє сумісному програмному забезпеченню виконувати ці нові робочі процеси на професійному рівні. Зазвичай вважають, що трасування променів доступне лише на дорогій графіці, але найновіша серія професійних графічних процесорів Intel перевершила ці очікування."
                  }
                },
                {
                  "specName": "Multiple_Large_Display",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel4.png",
                    "tr_specTitle": "КІЛЬКА ВЕЛИКИХ ДИСПЛЕЇВ ТА ОДИН НЕВЕЛИЧКИЙ МОБІЛЬНИЙ ГРАФІЧНИЙ ПРОЦЕСОР",
                    "tr_specText": "Графіка Intel® Arc™ Pro для ноутбуків може підтримувати до чотирьох надвеликих дисплеїв для підвищення ефективності робочого процесу. Додайте також підтримку розширеного динамічного діапазону (HDR), і ви отримаєте все, що вам потрібно для налаштування системи з кількох дисплеїв вдома або в офісі, якою напевно захочеться похвалитися в соцмережах."
                  }
                },
                {
                  "specName": "Full_Memory_Bandwidth",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/AXXXM_pro_panel5.png",
                    "tr_specTitle": "ПОВНИЙ ПОТЕНЦІАЛ ПРОПУСКНОЇ ЗДАТНОСТІ ПАМ’ЯТІ",
                    "tr_specText": "Пропускна здатність вашої графічної карти є важливим фактором для робочої станції. Якщо ви помилитеся, ви можете сповільнити професійні робочі процеси, тому ми подбали про те, щоб графічний процесор Intel® Arc™ Pro серії A підтримував сучасний PCIe* 4.0, не погіршуючи зворотну сумісність. Можливості графічної пам’яті посилюються завдяки високій швидкості пропускання, що дозволяє програмному забезпеченню отримувати доступ до даних проєкту ще швидше."
                  }
                },
                {
                  "specName": "Breathe_Life",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel2.png",
                    "tr_specTitle": "ВДИХНІТЬ ЖИТТЯ В КОЖЕН КАДР",
                    "tr_specText": "<span class='expandable_heading'>На базі штучного інтелекту. З підтримкою Intel.<br/></span><br/>Intel® X<sup class='small_text_sup_xe'>e</sup>SS — це розширена технологія масштабування на базі штучного інтелекту, яка підвищує продуктивність, не погіршуючи при цьому краси кожного кадру, тож ви можете насолоджуватися ігровим процесом, як його було задумано."
                  }
                },
                {
                  "specName": "Real_Immersive",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel3.png",
                    "tr_specTitle": "У РЕАЛЬНОМУ ЧАСІ.<br/> З РЕАЛЬНИМ ЗАНУРЕННЯМ.<br/> РЕАЛІЗМ У ВСІЙ КРАСІ.",
                    "tr_specText": "Попереду вас чекають більш реалістичні враження. Завдяки вбудованому трасуванню променів ви відчуєте все — від реалістичних тіней і відображень до майстерного освітлення. Іншими словами, це візуальні враження від гри, які ви не захочете пропустити."
                  }
                },
                {
                  "specName": "Your_Best_Gameplay",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel4.png",
                    "tr_specTitle": "ВАШ КРАЩИЙ ІГРОВИЙ ПРОЦЕС У ВСІЙ КРАСІ",
                    "tr_specText": "Подаруйте своїй аудиторії бездоганний ігровий процес, який вона заслуговує бачити. Завдяки можливостям апаратного прискорення кодування AV1 графіки Intel® Arc™ вони будуть зачаровані кожним вашим рухом. Вища якість зображення при тій самій швидкості означає максимальну якість трансляції зі збереженням пропускної здатності."
                  }
                },
                {
                  "specName": "Welcome_All_Creators",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_Int_panel5.png",
                    "tr_specTitle": "Вітаємо всіх контент-мейкерів",
                    "tr_specText": "Нові та покращені можливості ШІ доступні прямо під рукою. Завдяки передовим прискорювачам штучного інтелекту, вбудованим у графічні процесори Intel® Arc™ серії A, витрачайте більше часу на створення та менше часу на очікування роботи багатьох програм.<br/><br/>Виведіть створення відео на новий рівень та прокладіть шлях вперед за допомогою високоякісного й ефективного зберігання відео AV1 на базі розширених апаратних можливостей AV1, вбудованих у графіку Intel® Arc™."
                  }
                },
                {
                  "specName": "Graphics_Universe_B",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/arc-badge.svg",
                    "tr_specTitle": "Сучасні технології, краща графіка, якісніші ігри.",
                    "tr_specText": "Грайте, створюйте, генеруйте"
                  }
                },
                {
                  "specName": "Game_Ready",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel1.png",
                    "tr_specTitle": "ГОТОВИЙ ДО ІГОР,  БАГАТОФУНКЦІОНАЛЬНИЙ",
                    "tr_specText": "Насолоджуйтесь високою продуктивністю в найновіших іграх з роздільною здатністю <strong>1080p</strong> та <strong>1440p</strong> завдяки ШІ-масштабуванню та трасуванню променів<br><br/>. Отримайте очікувану продуктивність та функції за цінами, на які ви заслуговуєте.",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>Роздільна здатність 1440p<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Game_Changing_Modern_Tech",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel2.png",
                    "tr_specTitle": "СУЧАСНІ ТЕХНОЛОГІЇ, ЯКІ ЗМІНЮЮТЬ ПРАВИЛА ГРИ",
                    "tr_specText": "Підвищуйте продуктивність, швидкість відгуку та багато іншого завдяки ігровим технологіям графіки Intel® Arc™.<br><br/> Отримайте виняткову продуктивність та якість зображення в понад 150 іграх завдяки технології Intel® X<sup>e</sup> Super Sampling (X<sup>e</sup>SS) на базі штучного інтелекту.<br><br/> Зробіть свої ігри плавнішими та оперативнішими за допомогою технологій Intel® X<sup>e</sup>SS Frame Generation та Intel® X<sup>e</sup> Low Latency від Intel.",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>10 ГБ<br></strong>пам’яті"
                      },
                      {
                        "tr_title": "Понад <strong>150<br></strong>ігор"
                      },
                      {
                        "tr_title": "<strong>Intel® X<sup>e</sup>SS<br></strong>"
                      }
                    ]
                  }
                },
                {
                  "specName": "Software_Releases",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel3.png",
                    "tr_specTitle": "АКТУАЛЬНІ ВЕРСІЇ ПРОГРАМНОГО ЗАБЕЗПЕЧЕННЯ",
                    "tr_specText": "Регулярні оновлення програмного забезпечення забезпечать підтримку найновіших ігор та найкращі враження від гри."
                  }
                },
                {
                  "specName": "Creator_Toolkit",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel4.png",
                    "tr_specTitle": "УНІВЕРСАЛЬНИЙ ПАКЕТ ІНСТРУМЕНТІВ ДЛЯ КОНТЕНТ-МЕЙКЕРІВ",
                    "tr_specText": "Заощаджуйте час та швидко експортуйте відео за допомогою двох медіатранскодерів з підтримкою подвійного кодування. Створюйте контент з підтримкою найпопулярніших медіаформатів, включно з найсучаснішим AV1.<br><br/> Потужний медіамеханізм Intel® X<sup>e</sup> дозволяє швидко створювати та редагувати контент у високій роздільній здатності."
                  }
                },
                {
                  "specName": "Explore_AI",
                  "specDetails": {
                    "targetURL": "assets/images/arc_graphics/Arc_BXXX_panel5.png",
                    "tr_specTitle": "СТВОРЕНО ДЛЯ ДОСЛІДЖЕННЯ ШТУЧНОГО ІНТЕЛЕКТУ",
                    "tr_specText": "Досліджуйте останні досягнення в галузі штучного інтелекту, такі, як генерація зображення на основі опису та чат-боти з ШІ прямо на вашому ПК. AI Playground — безкоштовний конфіденційний застосунок поєднує можливості штучного інтелекту і простоту у використанні.<br><br/> Насолоджуйтесь покращеними ігровими можливостями, прискоренням процесу створення контенту та багатьма іншими перевагами завдяки спеціалізованим механізмам штучного інтелекту, вбудованим в графіку Intel® Arc™, які називаються Intel® Xe Matrix Extensions (Intel® XMX).",
                    "subSpecs": [
                      {
                        "tr_title": "<strong>144<br></strong>ШІ-механізми<br>Intel® XMX"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "os": [
    {
      "contentType": "WINDOWS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "Усе, що потрібно для ефективної роботи",
                "tr_pretitle": "Windows* 10",
                "tr_subtitle": "Дивовижна продуктивність і надійність у тонкому й легкому ПК. Значний ресурс акумулятора, високоякісний сенсорний екран* і найновіші твердотілі диски (SSD) — їх ви знайдете в ПК з ОС Windows* 10.",
                "tr_noteSection": "*Залежно від пристрою",
                "titleArray": [
                  {
                    "tr_title": "Коли менше — це насправді більше",
                    "tr_subtitle": "Сучасні ПК зазвичай споживають менше енергії, завдяки чому тривалість роботи від акумулятора збільшується — в середньому комп'ютер здатен забезпечити понад 8 годин відтворення відео.**",
                    "tr_noteSection": "**Ресурс акумулятора залежить від пристрою, налаштувань, режиму використання та інших факторів."
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "header-IconTopGaming",
                "tr_pretitle": "УСЕ, ЩО ПОТРІБНО ДЛЯ ЕФЕКТИВНОЇ РОБОТИ",
                "tr_title": "Windows* 10",
                "tr_subtitle": "Дивовижна продуктивність і надійність у тонкому й легкому ПК. Значний ресурс акумулятора, високоякісний сенсорний екран* і найновіші твердотілі диски (SSD) — їх ви знайдете в ПК з ОС Windows* 10.",
                "tr_noteSection": "*Залежно від пристрою",
                "titleArray": [
                  {
                    "tr_title": "КОЛИ МЕНШЕ — ЦЕ НАСПРАВДІ БІЛЬШЕ",
                    "tr_subtitle": "Сучасні ПК зазвичай споживають менше енергії, завдяки чому тривалість роботи від акумулятора збільшується — в середньому комп'ютер здатен забезпечити понад 8 годин відтворення відео.**",
                    "tr_noteSection": "**Ресурс акумулятора залежить від пристрою, налаштувань, режиму використання та інших факторів."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWSUWP",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Спрощено задля безпеки й ефективності",
                "tr_pretitle": "ОС Windows*&nbsp;10 у S-режимі",
                "tr_subtitle": "При запуску Windows*&nbsp;10 у S-режимі ви отримаєте додатковий захист, що дозволить вам працювати, грати й блукати інтернетом, маючи впевненість, що ваш пристрій у безпеці."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "СПРОЩЕНО ЗАДЛЯ БЕЗПЕКИ ТА ЕФЕКТИВНОСТІ",
                "tr_title": "ОС Windows*&nbsp;10 у S-режимі",
                "tr_subtitle": "При запуску Windows*&nbsp;10 у S-режимі ви отримаєте додатковий захист, що дозволить вам працювати, грати й блукати інтернетом, маючи впевненість, що ваш пристрій у безпеці."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_GENERIC",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Зважтеся на нові досягнення",
                "tr_pretitle": "Windows*",
                "tr_subtitle": "Швидкодія, ціна й широкий асортимент. Від інноваційних тонких і легких ноутбуків 2-в-1, сенсорних екранів, від’єднуваних клавіатур&nbsp;— ви знайдете ПК на базі ОС Windows*&nbsp;10 на будь-який смак і гаманець."
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ЗВАЖТЕСЯ НА НОВІ ДОСЯГНЕННЯ",
                "tr_title": "Windows*",
                "tr_subtitle": "Швидкодія, ціна й широкий асортимент. Від інноваційних тонких і легких ноутбуків 2-в-1, сенсорних екранів, від’єднуваних клавіатур&nbsp;— ви знайдете ПК на базі ОС Windows*&nbsp;10 на будь-який смак і гаманець."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "LINUX",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "",
                "tr_pretitle": "LINUX*",
                "tr_subtitle": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "WINDOWS_11",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Операційна система",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "image-only-panel",
                "panelType2": "header-IconTop",
                "badgeUrl": "",
                "tr_title": "",
                "tr_pretitle": "",
                "badgeIcons": [
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/1.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/2.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/3.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/4.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/5.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/6.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/7.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/8.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/9.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/10.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/11.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/12.png"
                  },
                  {
                    "imgUrl": "assets/images/lang/[XX]/operating-system/13.png"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "memory": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Пам’ять",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "СКІЛЬКИ ОПЕРАТИВНОЇ ПАМ’ЯТІ ВАМ ПОТРІБНО?",
                "tr_subtitle": "",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Повсякденний: 2—8 ГБ ОПЕРАТИВНОЇ ПАМ’ЯТІ",
                    "tr_badgeSubTitle": "Підходить для користувачів, які переважно використовують ПК для обробки тексту й перегляду веб-сторінок і зазвичай одночасно користуються однією програмою."
                  },
                  {
                    "tr_badgeTitle": "Потужний: 8—16&nbsp;ГБ ОПЕРАТИВНОЇ ПАМ’ЯТІ",
                    "tr_badgeSubTitle": "Чим більша оперативна пам’ять, тим швидше працюватимуть програми й тим більше програм можна запускати одночасно."
                  },
                  {
                    "tr_badgeTitle": "Розширений: ПОНАД 16ГБ ОПЕРАТИВНОЇ ПАМ’ЯТІ",
                    "tr_badgeSubTitle": "Якщо ви граєте в ігри, займаєтеся редагуванням фото чи відео або 3D-моделюванням, вам знадобиться додаткова оперативна пам’ять для відповідних програм, що вимагають значних ресурсів."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ оперативної пам’яті для щоденної роботи в режимі багатозадачності",
                "tr_subtitle": "Пам’яті достатньо для завантаження й ефективної роботи таких основних програм, як текстовий редактор і веб-браузер.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОПЕРАТИВ&shy;НОЇ ПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ оперативної пам’яті для потужної роботи в режимі багатозадачності",
                "tr_subtitle": "Якщо ви використовуєте кілька програм одночасно, обсяг пам’яті [memory_total]&nbsp;ГБ дасть вам змогу швидко переходити між ними.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОПЕРАТИВ&shy;НОЇ ПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[XX]&nbsp;ГБ оперативної пам’яті для розширеної роботи в режимі багатозадачності",
                "tr_subtitle": "У вас цілком достатньо пам’яті, щоб одночасно запускати кілька програм, що вимагають значних ресурсів, без сповільнення ПК.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ОПЕРАТИВ&shy;НОЇ ПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12th_memory.svg",
                "tr_title": "[Value1]&nbsp;ГБ пам’яті = [Value2]&nbsp;ГБ пам’яті Intel® Optane™ + [Value3]&nbsp;ГБ оперативної пам’яті",
                "tr_subtitle": "Ця комбінація рішень забезпечить прискорену продуктивність жорсткого диска завдяки пам’яті Intel® Optane™ і підвищить швидкість відгуку оперативної пам’яті.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[XX] ГБ<br/></span><span class='subtitle-value'>ПАМ’ЯТІ</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Пам’ять Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "tr_title": "Витрачайте менше часу на очікування та більше на те, що ви любите.",
                "tr_subtitle": "Використання пам’яті Intel® Optane™ із системною пам’яттю пришвидшить запуск часто використовуваних програм і забезпечить їхні миттєвий запуск і завантаження.",
                "tr_pretitle": "[XX] ГБ пам’яті Intel® Optane™",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "titleArray": [
                  {
                    "tr_title": "ЯКІ ФУНКЦІЇ В ПК ВИКОНУЄ ПАМ’ЯТЬ?"
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-optane-faster-content.png",
                    "tr_badgeTitle": "Швидше створення контенту",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-responsive-gaming.png",
                    "tr_badgeTitle": "Вища швидкодія в іграх",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-easier-multitasking.png",
                    "tr_badgeTitle": "Покращена багатозадачність",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-optane-open-programs.png",
                    "tr_badgeTitle": "Прискорений запуск програм",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Пам’ять Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>Прискорення ігрового процесу</span>",
                "tr_pretitle": "[XX] ГБ пам’яті Intel® Optane™",
                "tr_pretitle1": "[XX] ГБ пам’яті Intel® Optane™ прискорять ігровий процес",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Пришвидшуйте запуск ігор на <br/><span class=\"optane-game\">98%</span><br/>з диска даних із процесором [optane_legal_processor_name] з пам’яттю Intel® Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Швидкість завантаження вища в <br/><span class=\"optane-game\">4,1 раза</span><br/> з диска даних із процесором [optane_legal_processor_name] з пам’яттю Intel® Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            },
            {
              "deviceType": "DEFAULT_A",
              "details": {
                "tr_tileTitle": "Пам’ять Intel® Optane™",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "panelType2": "",
                "panelType1": "badgesAndHeadings-memory",
                "tr_title": "<span class='intelOptanMemoryTitle'>Прискорення ігрового процесу</span>",
                "tr_pretitle": "[XX] ГБ пам’яті Intel® Optane™",
                "tr_pretitle1": "[XX] ГБ пам’яті Intel® Optane™ прискорять ігровий процес",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Пришвидшуйте запуск ігор на <br/><span class=\"optane-game\">98%</span><br/>з диска даних із процесором [optane_legal_processor_name] з пам’яттю Intel® Optane™<sup>15</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgePreTitle": "Швидкість завантаження вища в <br/><span class=\"optane-game\">4,1 раза</span><br/> з диска даних із процесором [optane_legal_processor_name] з пам’яттю Intel® Optane™<sup>16</sup>",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "[Value1]&nbsp;ГБ пам’яті = [Value2]&nbsp;ГБ пам’яті Intel® Optane™ + [Value3]&nbsp;ГБ оперативної пам’яті",
                "tr_subtitle": "Ця комбінація рішень забезпечить прискорену продуктивність жорсткого диска завдяки пам’яті Intel® Optane™ і підвищить швидкість відгуку оперативної пам’яті.",
                "titleArray": [
                  {
                    "tr_title": "[XX]&nbsp;ГБ оперативної пам’яті для високої багатозадачності",
                    "tr_subtitle": "Якщо ви використовуєте кілька програм одночасно, обсяг пам’яті [memory_total]&nbsp;ГБ дасть вам змогу швидко переходити між ними."
                  },
                  {
                    "tr_title": "Для повсякденних завдань",
                    "tr_subtitle": "Пам’яті достатньо для завантаження й ефективної роботи таких основних програм, як текстовий редактор і веб-браузер."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DEFAULT",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "Обсяг оперативної пам’яті: [XX]&nbsp;ГБ",
                "tr_pretitle": "ДЛЯ БІЛЬШОЇ БАГАТОЗАДАЧНОСТІ",
                "tr_subtitle": "Оперативна пам’ять спрощує доступ процесора до файлів програм, що дає змогу ПК швидше отримувати до них доступ і виконувати декілька завдань одночасно.",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Стандартна пам’ять",
                    "tr_badgeSubTitle": "До 8&nbsp;ГБ оперативної пам’яті"
                  },
                  {
                    "tr_badgeTitle": "Розширена пам’ять",
                    "tr_badgeSubTitle": "Від 8 до 16 ГБ оперативної пам’яті"
                  },
                  {
                    "tr_badgeTitle": "Елітна пам’ять",
                    "tr_badgeSubTitle": "Опера-тивна пам’ять понад 16&nbsp;ГБ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GAMING_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_title": "[XX]&nbsp;ГБ для більшої багатозадачності",
                "tr_pretitle": "ДЛЯ БІЛЬШОЇ БАГАТОЗАДАЧНОСТІ",
                "tr_subtitle": "Оперативна пам’ять спрощує доступ процесора до файлів програм, що дає змогу ПК швидше отримувати до них доступ і виконувати декілька завдань одночасно.",
                "gamingPanleType2": "gaming-panelType1",
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "Стандартна пам’ять",
                    "tr_badgeSubTitle": "До 8&nbsp;ГБ оперативної пам’яті"
                  },
                  {
                    "tr_badgeTitle": "Розширена пам’ять",
                    "tr_badgeSubTitle": "Від 8 до 16 ГБ оперативної пам’яті"
                  },
                  {
                    "tr_badgeTitle": "Елітна пам’ять",
                    "tr_badgeSubTitle": "Опера-тивна пам’ять понад 16&nbsp;ГБ"
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "ПАМ’ЯТЬ У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTick.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Звичайна",
                      "tr_badgeSubTitle": "<span class='memory-value'>8&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Сучасний",
                      "tr_badgeSubTitle": "<span class='memory-value'>16&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Елітний",
                      "tr_badgeSubTitle": "<span class='memory-value'>32&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "STANDARD_COMMON_12TH_MEMORY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Пам’ять",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "tr_title": "ПАМ’ЯТЬ У ПОРІВНЯННІ",
                "tr_subtitle": "",
                "gamingPanleType2": "gaming-panelType1",
                "enhancementCompare": {
                  "tr_title": "ПАМ’ЯТЬ У ПОРІВНЯННІ",
                  "panelType2": "enhancement-compare",
                  "tr_table_heading": "Поточний пристрій",
                  "imgUrl": "assets/images/processorCompareTickBlack.svg",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Повсякденний",
                      "tr_badgeSubTitle": "<span class='memory-value'>8&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Потужний",
                      "tr_badgeSubTitle": "<span class='memory-value'>16&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Сучасний",
                      "tr_badgeSubTitle": "<span class='memory-value'>32&nbsp;ГБ <span class='ram_value'>ОПЕРА&shy;ТИВНОЇ ПАМ’ЯТІ</span></span>"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "storage": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Накопичувачі",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "assets/images/badges/detail_page_badge_placeholder.png",
                "tr_title": "СКІЛЬКИ МОЖЕ ВМІСТИТИСЯ НА ПК?",
                "tr_subtitle": "Немає потреби гадати. Ми чітко покажемо, скільки всього можна зберігати на цьому ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/storage-songs-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Створіть бібліотеку пісень:</span> <br/><span class=\"storage-standard\">[num_songs]<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>виходячи із середнього показника 5&nbsp;МБ на пісню",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-game-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Створіть бібліотеку ігор:</span><br/><span class=\"storage-standard\">[num_games]<sup>†</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>†</sup>виходячи з середнього розміру 40&nbsp;ГБ на гру",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-videos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Зберігайте відео:</span><br/><span class=\"storage-standard\">[num_videos]<sup>§</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>§</sup>виходячи із середнього показника 5&nbsp;ГБ на відео",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/storage-photos-badge.png",
                    "tr_badgeTitle": "<span class='storage-preTile'>Зробіть і збережіть</span><br/><span class=\"storage-standard\">[num_photos] фото<sup>^</sup></span>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "<sup>^</sup>виходячи із середнього показника 4&nbsp;МБ на фото",
                    "imgUrl": ""
                  }
                ],
                "titleArray": [
                  {
                    "storageType": "HDD",
                    "tr_pretitle": "[capacity]&nbsp;ГБ жорсткого диска"
                  },
                  {
                    "storageType": "SSD",
                    "tr_pretitle": "[capacity]&nbsp;ГБ твердотілого накопичувача"
                  },
                  {
                    "storageType": "SSD_AND_HDD",
                    "tr_pretitle": ""
                  },
                  {
                    "storageType": "OPTANE",
                    "tr_pretitle": "Пам’ять Intel®&nbsp;Optane™ обсягом [total_optane_memory]&nbsp;ГБ + твердотілий диск обсягом [convertedSSD]&nbsp;ГБ"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "tileBG": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_preTitle": "Обсяг пам’яті твердотілого накопичувача: [capacity]&nbsp;ГБ",
                "tr_preTitle1": "Обсяг пам’яті твердотілого накопичувача: [capacity]&nbsp;ТБ",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "Цей ПК оснащено твердотілим диском обсягом [capacity]&nbsp;ГБ. Це означає, що ви зможете зберігати неймовірну кількість фотографій, відеофайлів і програм й отримувати доступ до них набагато швидше, ніж за використання жорсткого диска.",
                    "tr_title": "На вашому ПК вистачить місця для всього"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "Цей ПК оснащено твердотілим диском обсягом [capacity]&nbsp;ТБ. Це означає, що ви зможете зберігати неймовірну кількість фотографій, відеофайлів і програм й отримувати доступ до них набагато швидше, ніж за використання жорсткого диска.",
                    "tr_title": "Цей пристрій має вражаючий об’єм сховища"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ГБ<br/></span>",
                    "tr_badgeTitle1": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ТБ<br/></span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "Твердо&shy;тілий диск",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "badgeUrl": "assets/images/std12storage.svg",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgeAndHeadings",
                "tr_preTitle": "Обсяг пам’яті жорсткого диска: [capacity]&nbsp;ГБ",
                "tr_preTitle1": "Обсяг пам’яті жорсткого диска: [capacity]&nbsp;ТБ",
                "titleArray": [
                  {
                    "detailPageName": "WIN10S_Storage",
                    "tr_subtitle": "Жорсткі диски&nbsp;– це гарний вибір для людей, які хочуть мати сховище з великим об'ємом безпосередньо на своєму ПК.",
                    "tr_title": "На вашому ПК вистачить місця для всього"
                  },
                  {
                    "detailPageName": "WIN10S_Storage-1000",
                    "tr_subtitle": "Жорсткі диски&nbsp;– це гарний вибір для людей, які хочуть мати сховище з великим об'ємом безпосередньо на своєму ПК.",
                    "tr_title": "Цей пристрій має вражаючий об’єм сховища"
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='value'>[capacity]<br/></span><span class='subtitle-value'>МІСТКІСТЬ НАКОПИЧУ&shy;ВАЧА</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "ЖОРСТ&shy;КИЙ ДИСК",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "badgeUrl": "assets/images/intel_optane_memory.svg",
                "tr_title": "",
                "tr_pretitle": "СКІЛЬКИ МОЖЕ ВМІСТИТИСЯ НА ПК?",
                "tr_subtitle": "Немає потреби гадати. Ми чітко покажемо, скільки всього можна зберігати на цьому ПК.",
                "titleArray": [
                  {
                    "tr_title": "[XX]&nbsp;ГБ жорсткого диска"
                  },
                  {
                    "tr_title": "[XX]&nbsp;ГБ твердотілого диска"
                  },
                  {
                    "tr_title": "Твердотілий диск Intel®  обсягом [total_capacity]&nbsp;ГБ + пам’ять Intel® Optane™ [optane_memory_size]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "Твердотілий диск Intel® обсягом [total_capacity] TB + пам’ять Intel® Optane™ обсягом [optane_memory_size]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ГБ + жорсткий диск [convertedHDD]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ТБ + жорсткий диск [convertedHDD]&nbsp;ГБ"
                  },
                  {
                    "tr_title": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ГБ + жорсткий диск [convertedHDD]&nbsp;ТБ"
                  },
                  {
                    "tr_title": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ТБ + жорсткий диск [convertedHDD]&nbsp;ТБ"
                  }
                ],
                "badgeIcons": [
                  {
                    "storageType": "GB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ГБ<br/></span>",
                        "tr_badgeSubTitle": "Твердо&shy;тілий диск"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ГБ<br/></span>",
                        "tr_badgeSubTitle": "ЖОРСТ&shy;КИЙ ДИСК"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ГБ<br/></span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>твердо&shy;тілий диск<br/><span class='storage-seperator'> +  </span><br/>Жорст&shy;кий диск</span>"
                      }
                    ]
                  },
                  {
                    "storageType": "TB",
                    "items": [
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ТБ<br/></span>",
                        "tr_badgeSubTitle": "Твердо&shy;тілий диск"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ТБ<br/></span>",
                        "tr_badgeSubTitle": "ЖОРСТ&shy;КИЙ ДИСК"
                      },
                      {
                        "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ТБ<br/></span>",
                        "tr_badgeSubTitle": "<span class='subtitle-value'>твердо&shy;тілий диск<br/><span class='storage-seperator'> +  </span><br/>Жорст&shy;кий диск</span>"
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "SSD_AND_HDD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/std12storage.svg",
                "tr_preTitle": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ГБ + жорсткий диск обсягом [convertedHDD]&nbsp;ГБ",
                "tr_preTitle1": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ТБ + жорсткий диск обсягом [convertedHDD]&nbsp;ГБ",
                "tr_preTitle2": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ГБ + жорсткий диск обсягом [convertedHDD]&nbsp;ТБ",
                "tr_preTitle3": "Твердотілий накопичувач обсягом [convertedSSD]&nbsp;ТБ + жорсткий диск обсягом [convertedHDD]&nbsp;ТБ",
                "titleArray": [
                  {
                    "tr_title": "На вашому ПК вистачить місця для всього",
                    "tr_title1": "Цей пристрій має вражаючий об’єм сховища",
                    "tr_subtitle": "Цей ПК оснащено твердотілим диском обсягом [convertedSSD] ГБ і жорстким диском обсягом [convertedHDD] ГБ. Це дасть вам величезний обсяг накопичувача й швидкість під час роботи з даними.",
                    "tr_subtitle1": "Цей ПК оснащено твердотілим диском обсягом [convertedSSD] ТБ і жорстким диском обсягом [convertedHDD] ГБ. Це дасть вам величезний обсяг накопичувача й швидкість під час роботи з даними.",
                    "tr_subtitle2": "Цей ПК оснащено твердотілим диском обсягом [convertedSSD] ГБ і жорстким диском обсягом [convertedHDD] ТБ. Це дасть вам величезний обсяг накопичувача й швидкість під час роботи з даними.",
                    "tr_subtitle3": "Цей ПК оснащено твердотілим диском обсягом [convertedSSD] ТБ і жорстким диском обсягом [convertedHDD] ТБ. Це дасть вам величезний обсяг накопичувача й швидкість під час роботи з даними."
                  }
                ],
                "badgeIcons": [
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ГБ<br/></span>",
                    "tr_badgeTitle1": "<span class='subtitle-value'>НАКОПИЧУВАЧ</span> <span class='value'>[capacity]&nbsp;ТБ<br/></span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "tr_badgeTitle": "<span class='subtitle-value'>твердо&shy;тілий диск<br/><span class='storage-seperator'> +  </span><br/>Жорст&shy;кий диск</span>",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OPTANE",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/intel_optane_storage.svg",
                "badgeUrl2": "assets/images/std12storage.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Отримайте прискорений доступ до носія великої ємності завдяки пам’яті Intel® Optane™ із твердотілим накопичувачем.",
                "tr_title": "Працюєте з великими файлами? Не проблема!",
                "tr_pretitle": "Твердотілий диск Intel®  обсягом [total_capacity]&nbsp;ГБ + пам’ять Intel® Optane™ [optane_memory_size]&nbsp;ГБ",
                "tr_pretitle1": "Твердотілий диск Intel® обсягом [total_capacity] TB + пам’ять Intel® Optane™ обсягом [optane_memory_size]&nbsp;ГБ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Твердо&shy;тілий диск",
                    "tr_badgeSubTitle": ""
                  }
                ],
                "titleArray": [
                  {
                    "tr_subtitle": "Це революційне рішення для зберігання даних&nbsp;– перше, у якому було поєднано пам’ять Intel® Optane™ із твердотілим накопичувачем в одній мікросхемі. Переваги цього рішення:",
                    "tr_title": "ЩО ТАКЕ ПАМ’ЯТЬ INTEL® OPTANE™ ІЗ ТВЕРДОТІЛИМ НАКОПИЧУВАЧЕМ?"
                  }
                ],
                "panel2BadgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-frequency-badge.png",
                    "tr_badgeTitle": "Дає змогу швидко відкривати необхідний контент",
                    "tr_badgeSubTitle": "Завдяки попередньому завантаженню часто використовуваних файлів і програм час очікування скорочується, тож ви зможете швидше відкривати їх і починати роботу.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/optane-memory-storage-badge.svg",
                    "tr_badgeTitle": "Сховище даних і швидкість",
                    "tr_badgeSubTitle": "Ви отримаєте необхідний простір для зберігання мультимедійних файлів і швидкість твердотілого диска.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "assets/images/memory-time-badge.png",
                    "tr_badgeTitle": "Покращення відгуку з часом",
                    "tr_badgeSubTitle": "Пам’ять Intel® Optane™ із твердотілим диском вивчає вашу манеру роботи, завдяки чому підвищує ефективність ПК.",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "НАКОПИЧУВАЧІ",
                "tileBG": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_subtitle": "Зберігайте медіавміст надійно й у швидкому доступі завдяки величезному обсягу накопичувача.",
                "tr_title": "Достатньо обсягу для всіх фото, відео й пісень"
              }
            }
          ]
        }
      ]
    }
  ],
  "display": [
    {
      "contentType": "TOUCH_SCREEN",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Екран",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "[screenResolution] млн пікселів, щоб гортати, торкатися й дивувати",
                "tr_subtitle": "Взаємодійте зі своїм ПК, немов зі смартфоном завдяки інтуїтивно зрозумілому управлінню, чіткішим і яскравішим деталям.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal]&nbsp;<br/>дюймів<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Роздільна здатність: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Пікселів: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей з діагоналлю [screenDiagonal]&nbsp;дюймів",
                    "tr_badgeSubTitle": "Висота екрана: [screenHeight]&nbsp;дюймів",
                    "tr_badgePreTitle": "Ширина екрана: [YY]&nbsp;дюймів"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "Дисплей із сенсорним екраном",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "DISPLAY",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Екран",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "",
                "tr_title": "Пориньте у [screenResolution]&nbsp;млн&nbsp;пікселів",
                "tr_subtitle": "Саме пікселі мають значення. Щобільше пікселів, тим чіткішими і яскравішими будуть зображення.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "<span class='value'>[screenDiagonal]&nbsp;<br/>дюймів<br/></span><span class='subtitle-value'>[screenResolutionType]</span>",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Роздільна здатність: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Пікселів: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей з діагоналлю [screenDiagonal]&nbsp;дюймів",
                    "tr_badgeSubTitle": "Висота екрана: [screenHeight]&nbsp;дюймів",
                    "tr_badgePreTitle": "Ширина екрана: [YY]&nbsp;дюймів"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Екран",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/display-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_title": "[screenDiagonal]&nbsp;дюймів <br/>[screenResolutionX] x [screenResolutionY]",
                "tr_pretitle": "ВІКНО У ВАШ ІГРОВИЙ СВІТ",
                "tr_subtitle": "Як і у випадку з телевізором, головним параметром ігрового дисплея буде розмір і роздільна здатність.",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Роздільна здатність: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Пікселів: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей з діагоналлю [screenDiagonal]&nbsp;дюймів",
                    "tr_badgeSubTitle": "Висота екрана: [screenHeight]&nbsp;дюймів",
                    "tr_badgePreTitle": "Ширина екрана: [screenWidth]&nbsp;дюймів"
                  },
                  {
                    "badgeUrl": "assets/images/display-touchscreen-badge.svg",
                    "tr_badgeTitle": "Дисплей із сенсорним екраном"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "4K",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Екран",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_badgeTitle": "4K",
                "tr_title": "Цей пристрій має вражаючий екран",
                "tr_subtitle": "Завдяки більш ніж увосьмеро більшій кількості пікселів, ваші відео й ігри вийдуть на новий рівень чіткості та яскравості кольорів.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "4K",
                    "tr_badgeSubTitle": ""
                  },
                  {
                    "badgeUrl": "assets/images/display-badge.svg",
                    "tr_badgeTitle": "[screenResolutionType]",
                    "tr_badgeSubTitle": "Роздільна здатність: [screenResolutionX] X [screenResolutionY]",
                    "tr_badgePreTitle": "Пікселів: [screenResolution] млн"
                  },
                  {
                    "badgeUrl": "assets/images/display-inch-badge.svg",
                    "tr_badgeTitle": "Дисплей з діагоналлю [screenDiagonal]&nbsp;дюймів",
                    "tr_badgeSubTitle": "Висота екрана: [screenHeight]&nbsp;дюймів",
                    "tr_badgePreTitle": "Ширина екрана: [YY]&nbsp;дюймів"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Екран",
                "tileBG": "",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Роздільна здатність [screenResolution] млн пікселів, щоб натискати, гортати й торкатися",
                    "tr_subTitle": "Переглядайте все, що ви любите, насолоджуючись повною взаємодією з чіткими жвавими зображеннями."
                  },
                  {
                    "tr_title": "Роздільна здатність [screenResolution]&nbsp;млн пікселів для розширення вашого цифрового світу",
                    "tr_subTitle": "Саме пікселі мають значення. Щобільше пікселів, тим чіткішими і яскравішими будуть зображення."
                  },
                  {
                    "tr_title": "Цей пристрій має вражаючий екран",
                    "tr_subTitle": "Завдяки майже в чотири рази більшій кількості пікселів, ніж у HD, ваші відео й ігри набудуть абсолютно нового рівня чіткості та кольоровості."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "connectivity": [
    {
      "contentType": "VERSION_3",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Технологія Thunderbolt™&nbsp;3 забезпечує найшвидші й найуніверсальніші можливості з’єднання з будь-якими док-станціями, екранами або пристроями зберігання даних.",
                "tr_title": "Один порт, який здатен на все",
                "tr_title1": "ОДИН ПОРТ, ЯКИЙ ЗДАТЕН НА ВСЕ",
                "titleArray": [
                  {
                    "tr_title": "ДЛЯ ЧОГО Я МОЖУ ВИКОРИСТОВУВАТИ ТЕХНОЛОГІЮ THUNDERBOLT™&nbsp;3?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Технологія Thunderbolt™ 3"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-4k.png",
                    "tr_badgeTitle": "Монітори з роздільною здатністю 4K",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Використовуйте екрани з надзвичайною роздільною здатністю, контрастністю й кольором"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-graphic.png",
                    "tr_badgeTitle": "Зовнішня відеокарта",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Миттєве додавання графічної потужності будь-якому ПК"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-networking.png",
                    "tr_badgeTitle": "Швидка робота в мережі",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Забезпечує швидке з’єднання однорангових вузлів"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "tr_subtitle": "Технологія Thunderbolt™ 3 передає дані швидше ніж стандартні порти USB, що дає змогу швидко переміщувати файли й легко підключати периферійні пристрої, наприклад монітори або зовнішні відеокарти.",
                "tr_title": "Технологія Thunderbolt™ 3",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_pretitle": "БЛИСКАВИЧНИЙ ОБМІН ДАНИМИ",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 2.0",
                    "tr_badgeSubTitle": "480&nbsp;Мбіт/с",
                    "tr_badgePreTitle": "",
                    "imgUrl": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "USB* 3.0",
                    "tr_badgeSubTitle": "5&nbsp;Гбіт/с",
                    "tr_badgePreTitle": ""
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Технологія Thunderbolt™ 3",
                    "tr_badgeSubTitle": "40&nbsp;Гбіт/с",
                    "tr_badgePreTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_4",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>Через єдиний універсальний порт і кабель можна підключати всі ваші улюблені пристрої</li> <li>Надійне заряджання ноутбука</li> <li>Надійна сертифікація, що гарантує відсутність проблем</li></ul>",
                "tr_title": "Універсальний кабель",
                "tr_title1": "УНІВЕРСАЛЬНИЙ КАБЕЛЬ",
                "tr_noteSection": "<sup>†</sup>На основі мінімальних вимог, зазначених у характеристиках.",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "ДЛЯ ЧОГО Я МОЖУ ВИКОРИСТОВУВАТИ ТЕХНОЛОГІЮ THUNDERBOLT™&nbsp;4?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Технологія Thunderbolt™ 4"
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "Для втілення ідей",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Підключайте зовнішній монітор та швидкі носії даних для перегляду та редагування фото й відео."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "Док-станція",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Створіть впорядкований ергономічний простір на робочому столі завдяки підключенню всіх аксесуарів до ноутбука за допомогою єдиного кабелю."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "Гра",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Щоб додавати більше твердотілих і жорстких дисків зі швидкістю передачі даних до 3000&nbsp;МБ/с для зберігання бібліотек ігор і медійних файлів."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальна продуктивність<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "У чотири рази швидше, ніж USB* 3.2. <br/>У два рази швидше, ніж HDMI* 2."
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "Та сама виняткова продуктивність технології Thunderbolt™&nbsp;3 з розширеними можливостями підключення, що дозволяють підключати й використовувати найновіші док-станції Thunderbolt™, монітори, будь-які пристрої з роз’ємом USB*, а також швидко зберегти дані.",
                "tr_title": "Технологія Thunderbolt™ 4",
                "tr_pretitle": "УНІВЕРСАЛЬНИЙ КАБЕЛЬ",
                "tr_noteSection": "<sup>†</sup>На основі мінімальних вимог, зазначених у характеристиках.",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-icon.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "Єдиний універсальний кабель Thunderbolt™&nbsp;4 може замінити всі ваші кабелі з роз’ємом USB-C*."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "",
                    "tr_badgeSubTitle": "Док-станції з технологією Thunderbolt™&nbsp;4 мають до чотирьох портів Thunderbolt™ для підключення будь-яких пристроїв."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальна продуктивність<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "У чотири рази швидше, ніж USB* 3.2. <br/>У два рази швидше, ніж HDMI* 2."
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "EVO",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "badgesAndHeadings",
                "tr_subtitle": "<ul><li>Через єдиний універсальний порт і кабель можна підключати всі ваші улюблені пристрої</li> <li>Надійне заряджання ноутбука</li> <li>Надійна сертифікація, що гарантує відсутність проблем</li></ul>",
                "tr_title": "Максимальні враження з аксесуарами Thunderbolt™",
                "tr_noteSection": "<sup>†</sup>На основі мінімальних вимог, зазначених у характеристиках.",
                "badgeUrl": "assets/images/evo_thunderbolt4.png",
                "tileBG": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "tr_title": "ДЛЯ ЧОГО Я МОЖУ ВИКОРИСТОВУВАТИ ТЕХНОЛОГІЮ THUNDERBOLT™&nbsp;4?",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/thunderbolt-create.png",
                    "tr_badgeTitle": "Для втілення ідей",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Підключайте зовнішній монітор та швидкі носії даних для перегляду та редагування фото й відео."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-dock.png",
                    "tr_badgeTitle": "Док-станція",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Створіть впорядкований ергономічний простір на робочому столі завдяки підключенню всіх аксесуарів до ноутбука за допомогою єдиного кабелю."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-game.png",
                    "tr_badgeTitle": "Гра",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "Щоб додавати більше твердотілих і жорстких дисків зі швидкістю передачі даних до 3000&nbsp;МБ/с для зберігання бібліотек ігор і медійних файлів."
                  },
                  {
                    "badgeUrl": "assets/images/thunderbolt-peformance.png",
                    "tr_badgeTitle": "Максимальна продуктивність<sup>†</sup>",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": "У чотири рази швидше, ніж USB* 3.2. <br/>У два рази швидше, ніж HDMI* 2."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Підключення",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "gaming-panelType1",
                "tr_subtitle": "Відчуйте переваги технології Thunderbolt™ 5",
                "tr_title": "Одне просте, надійне, надшвидке підключення, яке здатне на все!",
                "tr_title1": "ОДНЕ ПРОСТЕ, НАДІЙНЕ, НАДШВИДКЕ ПІДКЛЮЧЕННЯ, ЯКЕ ЗДАТНЕ НА ВСЕ!",
                "tr_noteSection": "",
                "badgeUrl": "assets/images/badges/connectivity-badge.svg",
                "titleArray": [
                  {
                    "imgUrl": "assets/images/unrivaled_icon.svg",
                    "tr_title": "Неперевершена простота",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/reliable_icon.svg",
                    "tr_title": "Надійне підключення",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/performance_icon.svg",
                    "tr_title": "Максимальна продуктивність",
                    "tr_subTitle": ""
                  },
                  {
                    "imgUrl": "assets/images/compatibility_icon.svg",
                    "tr_title": "Універсальна сумісність",
                    "tr_subTitle": ""
                  }
                ],
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "КОМП’ЮТЕРИ З ТЕХНОЛОГІЄЮ THUNDERBOLT™ 5 ЗАБЕЗПЕЧУЮТЬ НАЙШВИДШУ ПЕРЕДАЧУ ДАНИХ",
                    "tr_badgeSubTitle": "",
                    "tr_badgePreTitle": ""
                  }
                ],
                "enhancementCompare": {
                  "tr_title": "КОМП’ЮТЕРИ З ТЕХНОЛОГІЄЮ THUNDERBOLT™ 5 ЗАБЕЗПЕЧУЮТЬ НАЙШВИДШУ ПЕРЕДАЧУ ДАНИХ",
                  "panelType2": "enhancement-compare",
                  "badgeIcons": [
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Технологія Thunderbolt™ 5",
                      "tr_badgeSubTitle": "6000 Мбіт/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "Технологія Thunderbolt™ 4",
                      "tr_badgeSubTitle": "3000 Мбіт/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB4*",
                      "tr_badgeSubTitle": "1500 Мбіт/с"
                    },
                    {
                      "imgUrl": "",
                      "tr_badgeIconTile": "USB 3.2",
                      "tr_badgeSubTitle": "450 Мбіт/с"
                    }
                  ]
                },
                "titleArray1": [
                  {
                    "imgUrl": "assets/images/thunderbolt_panel1.png",
                    "tr_title": "",
                    "tr_subtitle": "Використовуйте <strong>утиліту спільного доступу Thunderbolt™</strong>,<br>щоб легко передавати файли та надавати спільний доступ до моніторів, накопичувачів та інших ресурсів із блискавичною швидкістю<sup>53</sup>",
                    "align": "left"
                  },
                  {
                    "imgUrl": "assets/images/thunderbolt_panel2.png",
                    "tr_title": "",
                    "tr_subtitle": "<strong>Розумніший робочий простір завдяки одному кабелю, підключеному до док-станції та аксесуарів</strong><br><br/>Комп’ютери, кабелі та аксесуари сертифіковані для створення <span class ='expandable_bold_text'>надійного комплексного рішення</span>",
                    "align": "right"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "wifi": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "badgesAndHeadings",
                "badgeUrl": "",
                "tr_subtitle": "Найпоширеніші типи Wi‑Fi:",
                "tr_title": "ДЕТАЛЬНІШЕ ПРО СТАНДАРТИ WI‑FI",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 забезпечує більшу швидкість, навіть якщо до одного сигналу підключено кілька користувачів<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "Остання інновація Intel у сфері Wi-Fi може забезпечувати вищу швидкість, ніж у гігабітного Wi-Fi, навіть якщо один і той самий сигнал використовують багато користувачів<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Найбільший прорив Wi‑Fi за 20 років Wi‑Fi 6E відкриває нові високошвидкісні канали для покращення швидкодії, надійності й зменшення перешкод."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 забезпечує більшу швидкість, навіть якщо до одного сигналу підключено кілька користувачів<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Всі переваги Wi-Fi 6E в поєднанні з механізмом пріоритезації Intel® Killer™, який надає пропускну здатність вебсайтам та програмам, які її найбільше потребують."
                  },
                  {
                    "badgeUrl": "assets/images/Wi-fi-6E-badge.svg",
                    "tr_badgeTitle": "Wi‑Fi 6E",
                    "tr_badgeSubTitle": "Завдяки меншій завантаженості високошвидкісних каналів, ви зможете насолоджуватися кращою продуктивністю та надійністю."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Intel® Wi-Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 забезпечує більшу швидкість, навіть якщо до одного сигналу підключено кілька користувачів<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 6 (Gig+)",
                    "tr_badgeSubTitle": "Завдяки меншій кількості перешкод під час використання Wi-Fi 6 та інтелектуальній продуктивності механізму пріоритезації Intel® Killer™, ваша робота в мережі буде ще швидшою.⁶."
                  },
                  {
                    "badgeUrl": "assets/images/standard_generic_wifi.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Завдяки меншій завантаженості високошвидкісних каналів, ви зможете насолоджуватися кращою продуктивністю та надійністю."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Wi-Fi 7 (5 Gig)",
                    "tr_badgeSubTitle": "Швидкість Wi-Fi на ПК понад 5 Гбіт/с та стабільна низька затримка — діліться файлами за секунди, а не хвилини."
                  },
                  {
                    "badgeUrl": "assets/images/killerwifi-7-badge.png",
                    "tr_badgeTitle": "Intel® Killer™ Wi‑Fi 7",
                    "tr_badgeSubTitle": "Intel® Killer™ Wi-Fi 7 (5 Gig) — це новітня технологія, що забезпечує «екстремальну» надійність, низьку затримку та високу швидкість завдяки оптимізації мережі на базі штучного інтелекту."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Wi-Fi 6 забезпечує більшу швидкість, навіть якщо до одного сигналу підключено кілька користувачів<sup>9</sup>."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                    "tr_badgeTitle": "Intel® Wi‑Fi 6E (Gig+)",
                    "tr_badgeSubTitle": "Intel® Wi-Fi 6E (Gig+) забезпечує швидкість понад 1 Гбіт/с, високу надійність і низьку затримку завдяки використанню каналів у діапазоні 6 ГГц."
                  },
                  {
                    "badgeUrl": "assets/images/wifi-6-badge.png",
                    "tr_badgeTitle": "Wi‑Fi 6",
                    "tr_badgeSubTitle": "Краща ефективність, пропускна здатність і швидкість порівняно з Wi-Fi 5 у перевантажених мережах."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "Забезпечте вищу швидкість підключення до інтернету<sup>†</sup> й надійніше з’єднання завдяки технології Wi‑Fi [XX].",
                "tr_title": "Ширший діапазон покриття та вища швидкість",
                "tr_noteSection": "<sup>†</sup>Доступна пропускна здатність бездротового зв’язку й&nbsp;/ або радіус дії можуть мінятись.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi [XX]"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В епоху багатокористувацьких і онлайнових ігор залишатися на зв’язку важливіше, ніж будь-коли. Окрім швидкості вам знадобиться бездротовий сигнал, який зможе підтримувати ці швидкості на відстані.",
                "tr_title": "[XX]",
                "tr_pretitle": "З’ЄДНАННЯ&nbsp;– КЛЮЧ ДО УСЬОГО",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6E-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Підключення із модулем від Intel® Wi‑Fi 6 (Gig+) до маршрутизаторів Wi‑Fi 6, що підтримують канали з частотою 160 МГц, здатне забезпечити ще вищу швидкість й надійність зв’язку для більшої кількості активних користувачів.",
                "tr_title": "Майже втричі більша швидкість з Intel® <span class='no-warp'>Wi-Fi&nbsp;6 </span> (Gig+)<sup>†</sup>",
                "tr_noteSection": "<sup>†</sup>У порівнянні з Wi‑Fi стандарту AC. Окремі функції доступні лише для певних артикулів. За докладнішою інформацією зверніться до виробника. Щоб дізнатися більше про Wi‑Fi, відвідайте сторінку: intel.com/wifi6disclaimers"
              }
            },
            {
              "deviceType": "MODEL_AX101",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-6-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Дводіапазонний адаптер Intel® Wi-Fi 6 початкового рівня забезпечує покращену продуктивність для простих завдань у мережі, на кшталт надсилання електронної пошти чи перегляду вебсторінок у мережах з великою кількістю користувачів<sup>9</sup>.",
                "tr_title": "Базовий Wi-Fi",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В епоху багатокористувацьких і онлайнових ігор залишатися на зв’язку важливіше, ніж будь-коли. Окрім швидкості вам знадобиться бездротовий сигнал, який зможе підтримувати ці швидкості на відстані.",
                "tr_title": "[XX]",
                "tr_pretitle": "З’ЄДНАННЯ&nbsp;– КЛЮЧ ДО УСЬОГО",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "Нові канали Wi‑Fi дають змогу не ділити пропускну смугу зі старішими пристроями у вашому оточенні, забезпечуючи плавний перегляд потокового відео, швидке завантаження вебсайтів, віддалену роботу й навчання без перешкод.",
                "tr_title": "З’єднання поза конкуренцією",
                "tr_noteSection": ""
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "OTHERS",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/wifi-6E-Gig-badge.png",
                "tr_subtitle": "Забезпечте собі вищу швидкість підключення до інтернету<sup>†</sup> й надійніше з’єднання завдяки технології [XX].",
                "tr_title": "Ширший діапазон покриття та вища швидкість",
                "tr_noteSection": "<sup>†</sup>Доступна пропускна здатність бездротового зв’язку й&nbsp;/ або радіус дії можуть мінятись.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  }
                ]
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В епоху багатокористувацьких і онлайнових ігор залишатися на зв’язку важливіше, ніж будь-коли. Окрім швидкості вам знадобиться бездротовий сигнал, який зможе підтримувати ці швидкості на відстані.",
                "tr_title": "[graphic_display]",
                "tr_pretitle": "З’ЄДНАННЯ&nbsp;– КЛЮЧ ДО УСЬОГО",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "NON_INTEL",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "tileBG": "",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Вбудований надшвидкий Wi‑Fi",
                "tr_subtitle": "Позбудьтеся дротів і залишайтесь онлайн."
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6E_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1675_badge.svg",
                "tr_subtitle": "За допомогою виділених високошвидкісних смуг, що забезпечують меншу кількість перешкод, і механізму пріоритезації Intel® Killer™, який підвищує пріоритет ігор, онлайн-ігри виходять на найвищий рівень.",
                "tr_title": "Обійдіть конкурентів",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "За допомогою виділених високошвидкісних смуг, що забезпечують меншу кількість перешкод, і механізму пріоритезації Intel® Killer™, який підвищує пріоритет ігор, онлайн-ігри виходять на найвищий рівень.",
                "tr_title": "[XX]",
                "tr_pretitle": "ОБІЙДІТЬ КОНКУРЕНТІВ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "INTEL_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/[image_path].png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Виділені високошвидкісні смуги забезпечують меншу кількість перешкод та роблять ігри пріоритетним завданням, що дозволяє вивести онлайн-ігри на вищий рівень.",
                "tr_title": "[XX]",
                "tr_pretitle": "ОБІЙДІТЬ КОНКУРЕНТІВ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_6_KILLER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "tr_subtitle": "Intel® Killer™ Wi-Fi автоматично прискорює мережевий трафік для програм, які найбільше потребують цього, тому ваші потокові відео мають чітку деталізацію і менше буферизується.",
                "tr_title": "Швидший та розумніший спосіб підключення⁶.",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/standard_wifi_killer_AX1650_badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В епоху багатокористувацьких і онлайнових ігор залишатися на зв’язку важливіше, ніж будь-коли. Окрім швидкості вам знадобиться бездротовий сигнал, який зможе підтримувати ці швидкості на відстані.",
                "tr_title": "[XX]",
                "tr_pretitle": "З’ЄДНАННЯ&nbsp;– КЛЮЧ ДО УСЬОГО",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_5",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "badgeUrl": "",
                "tr_subtitle": "Забезпечте собі вищу швидкість підключення до інтернету<sup>†</sup> й надійніше з’єднання завдяки технології Wi-Fi&nbsp;5.",
                "tr_title": "Ширший діапазон покриття та вища швидкість",
                "tr_noteSection": "<sup>†</sup>Доступна пропускна здатність бездротового зв’язку й&nbsp;/ або радіус дії можуть мінятись.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "THIRDPARTY_6E",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "В епоху багатокористувацьких і онлайнових ігор залишатися на зв’язку важливіше, ніж будь-коли. Окрім швидкості вам знадобиться бездротовий сигнал, який зможе підтримувати ці швидкості на відстані.",
                "tr_title": "[XX]",
                "tr_pretitle": "ОБІЙДІТЬ КОНКУРЕНТІВ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/wifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "Функції Wi-Fi 7 ґрунтуватимуться на попередніх поколіннях Wi-Fi, але будуть їхньою вдосконаленою версією. Це означатиме не лише вищу швидкість, але й значно покращену швидкодію відгуку та надійність для забезпечення захопливих вражень споживачів і підтримки неперевершених технологій майбутнього.",
                "tr_title": "Мережеве підключення ПК на рівні дротового",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Функції Wi-Fi 7 ґрунтуватимуться на попередніх поколіннях Wi-Fi, але будуть їхньою вдосконаленою версією. Це означатиме не лише вищу швидкість, але й значно покращену швидкодію відгуку та надійність для забезпечення захопливих вражень споживачів і підтримки неперевершених технологій майбутнього.",
                "tr_title": "[XX]",
                "tr_pretitle": "ЕВОЛЮЦІЯ ВРАЖЕНЬ КОРИСТУВАЧА",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "KILLER_VERSION_7",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_subtitle": "",
                "tr_title": "Вища швидкість, менша затримка та краща надійність завдяки оптимізації роботи мережі на основі ШІ",
                "tr_noteSection": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Wi‑Fi",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/killerwifi-7-badge.png",
                "panelType1": "header-IconTopGaming",
                "panelType2": "gaming-graphics",
                "tr_subtitle": "Вища швидкість, менша затримка та краща надійність завдяки оптимізації роботи мережі на основі ШІ.",
                "tr_title": "[XX]",
                "tr_pretitle": "ШВИДКІСТЬ ВІДГУКУ, ЯК У ДРОТОВОЇ МЕРЕЖІ",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "Wi‑Fi 6E"
                  },
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]"
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "battery": [
    {
      "contentType": "COMMON",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "",
                "panelType2": "badgesAndHeadings",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/memory-power-icon.png",
                    "tr_badgeTitle": "Як оцінити акумулятор?",
                    "tr_badgeSubTitle": "Більшість виробників визначають ресурс своїх акумуляторів у годинах. Хоча цей розрахунок не є абсолютно точним, він допоможе вам порівняти ресурс акумулятора одного ПК з іншим."
                  }
                ],
                "tr_subtitle": "",
                "tr_title": ""
              }
            }
          ]
        },
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-IconTopGaming",
                "panelType2": "",
                "tr_pretitle": "ДЛЯ ІГОР У ДОРОЗІ",
                "tr_subtitle": "Завдяки потужності сучасних ігрових ноутбуків немає потреби обмежувати себе настільними ПК. Тепер ваші ігри будуть із вами будь-де.",
                "tr_title": "[Dynamic.battery.values.hours]&nbsp;год ресурсу акумулятора"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BATTERYLIFE",
      "iposTypes": [
        {
          "iposType": "DEFAULT",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Intel® Core™ Ultra: новий стандарт ресурсу акумулятора ПК",
                "detailBGUrl": "assets/images/battery_life_bg.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "bannerImgUrl": "assets/images/battery_life_banner_img.svg",
                "tr_subtitle": "Новий стандарт ресурсу акумулятора ПК",
                "tr_title": "Процесор Intel® Core™ Ultra серія 200V",
                "tr_noteSection": "Стосується процесорів Intel® Core™ Ultra серії 200V станом на серпень 2025 року, виходячи з їх унікальної архітектури та вражаючого ресурсу акумулятора, виміряного на провідних моделях.<br/>Детальніше див. на www.Intel.com/PerformanceIndex.<br/>Жоден продукт не може бути абсолютно безпечним. ©&nbsp;Корпорація&nbsp;Intel.",
                "tileBG": "assets/images/batteryLifeTile_img.svg",
                "titleArray": [
                  {
                    "tr_title": "Робіть більше без підзарядки",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "Насолоджуйтеся чудовою продуктивністю без підключення до електромережі",
                    "tr_subTitle": ""
                  },
                  {
                    "tr_title": "Створюйте те, що надихає. Без зусиль.",
                    "tr_subTitle": ""
                  }
                ],
                "badgeUrl": "assets/images/badges/battery_life_badge.svg",
                "tr_badgeTitle": "Це потужність <span class='battery_highlight'>Intel Inside®.</span>"
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "GOOD",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Від’єднайте пристрій від мережі і годинами залишайтеся на зв’язку, насолоджуючись улюбленою музикою, іграми та програмами.",
                "tr_title": "[XX]&nbsp;год перегляду потокового відео без підзарядки<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>На основі заявленого виробником ресурсу акумулятора ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]&nbsp;год",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BETTER",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Від’єднайте пристрій від мережі і годинами залишайтеся на зв’язку, насолоджуючись улюбленою музикою, іграми та програмами.",
                "tr_title": "[Dynamic.battery.values.hours]&nbsp;год роботи на ходу<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>На основі заявленого виробником ресурсу акумулятора ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]&nbsp;год",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "BEST",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "Від’єднайте пристрій від мережі і годинами залишайтеся на зв’язку, насолоджуючись улюбленою музикою, іграми та програмами.",
                "tr_title": "[Dynamic.battery.values.hours]&nbsp;год безперервної роботи без підзарядки<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>На основі заявленого виробником ресурсу акумулятора ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]&nbsp;год",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "contentType": "EVO",
      "iposTypes": [
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "DEFAULT",
              "details": {
                "tr_tileTitle": "Акумулятор",
                "detailBGUrl": "",
                "badgeUrl": "assets/images/badges/battery-badge.svg",
                "panelType1": "header-BadgeIconTop",
                "panelType2": "",
                "tr_subtitle": "ПК оптимізує ресурс акумулятора, щоб зберегти його, та забезпечує щонайменше 4&nbsp;год автономної роботи після 30 хвилин заряджання<sup>4</sup>.",
                "tr_title": "Довший час автономної роботи [Dynamic.battery.values.hours]&nbsp;год<sup class='sup-symbol'>†</sup>",
                "tr_noteSection": "<sup>†</sup>На основі заявленого виробником ресурсу акумулятора ПК.",
                "badgeIcons": [
                  {
                    "badgeUrl": "",
                    "tr_badgeTitle": "[XX]&nbsp;год",
                    "tr_badgeSubTitle": ""
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "headerTabs": [
    {
      "tabName": "homepage",
      "headerDetails": {
        "tr_specTitle": "Головна сторінка",
        "targetURL": "Home",
        "iconURL": "assets/images/home.svg"
      }
    },
    {
      "tabName": "why_this_pc",
      "headerDetails": {
        "tr_specTitle": "Чому саме цей ПК",
        "targetURL": "WhyThisPC",
        "iconURL": "assets/images/whythispc.svg"
      }
    },
    {
      "tabName": "pc_specs",
      "headerDetails": {
        "tr_specTitle": "Переглянути всі характеристики",
        "targetURL": "PcSpec",
        "iconURL": "assets/images/pcspecs.svg"
      }
    },
    {
      "tabName": "remote",
      "headerDetails": {
        "tr_specTitle": "Віддалені",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "mobile",
      "headerDetails": {
        "tr_specTitle": "Мобільні",
        "targetURL": "",
        "iconURL": "assets/images/Frame_3468.svg"
      }
    },
    {
      "tabName": "legal",
      "headerDetails": {
        "tr_specTitle": "Правова інформація",
        "tr_paragraph_array": [
          "Можливо, що програмне забезпечення та робочі навантаження, що застосовуються під час випробувань робочих характеристик, оптимізовані для продуктивної роботи лише на базі мікропроцесорів Intel®. Випробування робочих характеристик за допомогою пакетів, як-от SYSmark* і MobileMark*, виконано з використанням певних комп’ютерних систем, компонентів, програмного забезпечення, операцій та функцій. Результати випробувань чутливі до зміни будь-якого зі вказаних чинників. Для прийняття оптимального рішення про купівлю рекомендується оглянути інформацію з інших джерел та ознайомитися з результатами інших випробувань, у тому числі з даними тестування спільної роботи з іншими пристроями. Щоб отримати більш докладну інформацію щодо продуктивності та результатів тестування, завітайте на: www.intel.com/benchmarks.",
          "¹Вироби Intel® Wi-Fi 6 (Gig+) підтримують додаткові канали 160&nbsp;МГц, що дає змогу досягти максимально можливої теоретичної швидкості (2402&nbsp;Мбіт/с) для типових продуктів Wi-Fi 2x2 802.11ax для ПК. Преміальні вироби Intel® Wi-Fi 6 (Gig+) забезпечують збільшення максимальної теоретичної швидкості у 2–4&nbsp;рази в порівнянні зі стандартними виробами Wi-Fi 2x2 (1201&nbsp;Мбіт/с) або 1x1 (600&nbsp;Мбіт/с) 802.11ax для ПК, які підтримують тільки обов’язкову вимогу для каналів 80&nbsp;МГц.",
          "²Рекомендація призначена лише для довідки. Приймаючи рішення про покупку, радимо звернутися до інших джерел.",
          "³Характеристики й переваги технологій Intel залежать від конфігурації системи та можуть вимагати використання певного апаратного й програмного забезпечення або активації послуг. Продуктивність може змінюватися залежно від конфігурації системи. Жодна комп’ютерна система не може бути абсолютно безпечною. Проконсультуйтесь із виробником системи чи роздрібним продавцем, або дізнайтеся більше за адресою intel.com.",
          "⁴У разі використання систем з екраном FHD і бездротовим з’єднанням із мережею для перегляду вебсторінок. У разі вимкнення системи за досягнення встановленого виробником рівня заряду.",
          "⁵У порівнянні з іншими технологіями вводу/виводу для ПК, поміж іншого, eSATA, USB та IEEE 1394* FireWire. Показники продуктивності можуть різнитися залежно від конкретного апаратного й програмного забезпечення. Потрібен пристрій, сумісний з технологією Thunderbolt™.",
          "⁶Майже в три рази швидший: 802.11ax 2x2 160 МГц підтримує максимальну теоретичну швидкість передачі даних 2402 Мбіт/с. ~Майже в три рази швидший, ніж стандартний Wi‑Fi 802.11ac 2x2 80 МГц (867 Мбіт/с), як зазначено в технічних характеристиках бездротового стандарту IEEE 802.11* і потребує використання аналогічним чином налаштованих бездротових маршрутизаторів 802.11ax.",
          "⁷Зниження затримки на 75%: на основі даних моделювання Intel (79%) в мережі 802.11ax із 9 клієнтами, з використанням OFDMA і без. Середня затримка без OFDM становить 36&nbsp;мс, при чому середня затримка OFDMA знижена до 7,6&nbsp;мс. Для меншої затримки потрібно, щоб маршрутизатор 802.11ax (Wi-Fi 6) і всі клієнти підтримували OFDMA.",
          "⁸На основі порівняння теоретичної максимальної швидкості передачі даних у технічних характеристиках стандарту 802.11, маршрутизатор 2x2 з частотою 160 МГц Wi‑Fi 6/6E (802.11ax) може забезпечити швидкість 2402 Мбіт/с у порівнянні з маршрутизатором 2x2 з частотою 80 МГц Wi‑Fi 5 (802.11ac), швидкість якого до 867 Мбіт/с. Це означає, що швидкість вища у 2,8 раза.",
          "⁹Найкращий у своєму класі Wi‑Fi 6: вироби Intel® Wi‑Fi 6 (Gig+) підтримують додаткові канали 160 МГц, що забезпечує найвищу можливу теоретичну максимальну швидкість (2402 Мбіт/с) для стандартних ПК із підтримкою Wi‑Fi 2x2 802.11ax. Преміальні вироби Intel® Wi‑Fi 6 (Gig+) забезпечують збільшення максимальної теоретичної швидкості у 2–4 рази в порівнянні зі стандартними виробами Wi‑Fi 2x2 (1201 Мбіт/с) або 1x1 (600 Мбіт/с) 802.11ax для ПК, які підтримують тільки обов’язкову вимогу для каналів 80 МГц.",
          "Лише окремі артикули, функціональність різниться залежно від конструкції кінцевого виробника обладнання. Щоб дізнатися більше, зверніться до кінцевого виробника або роздрібного продавця. Щоб дізнатися більше про Wi‑Fi, відвідайте сторінку: intel.com/wifi6disclaimers.",
          "¹⁰Технологія Thunderbolt™&nbsp;4 зі швидкістю 40&nbsp;Гбіт/с забезпечує найшвидші, найпростіші й найнадійніші можливості з’єднання через кабель з будь-якими док-станціями, екранами або пристроями для роботи з даними у порівнянні з іншими технологіями вводу/виводу для ПК, включаючи eSATA*, USB* та IEEE 1394* FireWire.",
          "¹¹Потребує використання маршрутизатора 802.11ax з підтримкою OFDMA (багатостанційний доступ з ортогональним частотним розділенням) і декількох клієнтів у мережі з підтримкою AX. Вища ефективність в інтенсивно використовуваних середовищах завдяки функції OFDMA, підтримуваній клієнтами 802.11ax і точками доступу. 2&nbsp;Гбіт/с на основі припущення приблизно 70% максимальної теоретичної швидкості передачі даних за технічними характеристиками IEEE 802.11* становить 802.11ax 2402&nbsp;Мбіт/с при частоті 160&nbsp;МГц.",
          "¹²Розраховано на основі запуску документа з активністю у фоновому режимі, у ході якого порівнювалася продуктивність процесора Intel® Core™ i7-8565U 8-го покоління (твердотілий диск 512&nbsp;ГБ TLC) з продуктивністю процесора Intel® Core™ i7-8565U 8-го покоління (пам’ять Intel® Optane™ H10 32&nbsp;ГБ із твердотілим накопичувачем 512&nbsp;ГБ).",
          "¹³Intel® Thread Director розроблено для процесорів Intel® Core™ 12-го покоління, що допомагає підтримувати операційні системи, спрямовуючи робочі навантаження відповідному ядру. Користувачу не потрібно нічого робити. Подробиці див. на intel.com.",
          "¹⁴Недоступно на деяких процесорах Intel® Core™ 12-го покоління. Гібридна архітектура продуктивності поєднує на одному кристалі процесора дві нові мікроархітектури — ядра Performance-core (P-core) і Efficient-core (E-core). Окремі процесори Intel® Core™ 12-го покоління (деякі процесори Intel® Core™ i5 12-го покоління і ранішого покоління) не підтримують гібридну архітектуру продуктивності, лише P-core.",
          "¹⁵За результатами тесту Game Launch Workload під час порівняння процесора Intel® Core™ i7-8750H восьмого покоління (модуль пам’яті 32&nbsp;ГБ Intel® Optane™ + твердотілий диск 256&nbsp;ГБ Intel® PCIe* + жорсткий диск 1&nbsp;ТБ) з процесором Intel® Core™ i7-8750H восьмого покоління (твердотілий диск 256&nbsp;ГБ Intel® PCIe + жорсткий диск 1&nbsp;ТБ). Game Launch Workload&nbsp;– робоче навантаження, розроблене компанією Intel, за яким вимірюється час, що минув до запуску Total War: WARHAMMER* II версії 5577.0 і час переходу до головного меню з вимкненим вступним відео (запуск). Конфігурації пам’яті Intel® Optane™ для прискорення жорсткого диска: процесор Intel® Core™ i7-8750H, PL1=45&nbsp;Вт TDP, 6C12T, прискорення Turbo до 4&nbsp;ГГц на передсерійній системі від виробника, відеокарта: NVIDIA* GeForce* GTX 1070, пам’ять: 2x4&nbsp;ГБ DDR4, накопичувач: твердотілий диск 256&nbsp;ГБ Intel® 760p (PCIe*)&nbsp;+ жорсткий диск 1&nbsp;ТБ + пам’ять 32&nbsp;ГБ Intel® Optane™, ОС: Windows*&nbsp;10 RS3 збірка 1709, MCU 0x84; процесор Intel® Core™ i7-8750H, PL1=45&nbsp;Вт TDP, 6C12T, прискорення Turbo до 4&nbsp;ГГц на передсерійній системі від виробника, відеокарта: NVIDIA* GeForce* GTX 1070, пам’ять: 2x4&nbsp;ГБ DDR4, накопичувач: твердотілий диск 256&nbsp;ГБ Intel® 760p (PCIe*) + жорсткий диск 1&nbsp;ТБ, ОС: Windows*&nbsp;10 RS3 збірка 1709, MCU 0x84.",
          "¹⁶За результатами тесту робочого навантаження у вигляді завантаження рівня гри під час порівняння процесора Intel® Core™ i7-8750H восьмого покоління (модуль пам’яті Intel® Optane™ 32&nbsp;ГБ) з процесором Intel® Core™ i7-8750H восьмого покоління (тільки жорсткий диск). Game Level Load Workload&nbsp;– робоче навантаження, розроблене компанією Intel, за яким вимірюється час, що минув від відкриття головного меню до завершення завантаження рівня (Level Load) у грі Total War: WARHAMMER* II версії 5577.0. Конфігурації пам’яті Intel® Optane™ для прискорення жорсткого диска: процесор Intel® Core™ i7-8750H, PL1=45&nbsp;Вт TDP, 6C12T, прискорення Turbo до 4&nbsp;ГГц на передсерійній системі від виробника, відеокарта: NVIDIA* GeForce* GTX 1070, пам’ять: 2x4&nbsp;ГБ DDR4, накопичувач: твердотілий диск 256&nbsp;ГБ Intel® 760p (PCIe*)&nbsp;+ жорсткий диск 1&nbsp;ТБ + пам’ять 32&nbsp;ГБ Intel® Optane™, ОС: Windows*&nbsp;10 RS3 збірка 1709, MCU 0x84; процесор Intel® Core™ i7-8750H, PL1=45&nbsp;Вт TDP, 6C12T, прискорення Turbo до 4&nbsp;ГГц на передсерійній системі від виробника, відеокарта: NVIDIA* GeForce* GTX 1070, пам’ять: 2x4&nbsp;ГБ DDR4, накопичувач: твердотілий диск 256&nbsp;ГБ Intel® 760p (PCIe*) + жорсткий диск 1&nbsp;ТБ, ОС: Windows*&nbsp;10 RS3 збірка 1709, MCU 0x84.",
          "¹⁷З використанням ядер Performance-core. Швидкодія залежить від використання, налаштування й інших факторів. Подробиці: www.intel.com/PerformanceIndex.",
          "¹⁸Зміна тактової частоти або напруги може пошкодити процесор або скоротити термін служби процесора та інших компонентів системи, а також знизити стабільність і продуктивність системи. Гарантії на виріб можуть не застосовуватися, якщо процесор експлуатується поза межами його технічних характеристик. Для отримання додаткової інформації зверніться до виробників системи та компонентів.",
          "¹⁹Визначено на основі неперевершеного поєднання у платформі Intel vPro® можливостей безпеки ОС, захисту програм і даних, а також розширеного захисту від загроз для бізнесу будь-якого розміру, а також пріоритетного підходу Intel до безпеки при розробці, виробництві та підтримці продуктів. Усі бізнес-ПК, побудовані на платформі Intel vPro®, пройшли перевірку на відповідність суворим вимогам, та оснащені унікальними апаратними функціями безпеки. Додаткову інформацію можна переглянути на вебсайті www.intel.com/PerformanceIndex (платформи). Жоден продукт чи компонент неможливо захистити повністю.",
          "²⁰Intel® Connectivity Performance Suite доступний лише в системах на базі Windows*. Тестування Intel Over The Air (OTA) Wi-Fi у перевантаженій мережі порівняно з пріоритезацією бездротового трафіку програмного забезпечення ICPS і розумним перемиканням точок доступу. Докладніше можна дізнатися на www.intel.com/PerformanceIndex (підключення). Результати можуть різнитися.",
          "²¹Порівняно з попереднім поколінням процесорів.",
          "²²Графіка Intel® Arc™ є першою на ринку з підтримкою кодування AV1 (станом на 1&nbsp;квартал 2022&nbsp;року). Подробиці за посиланням: intel.com/performanceindex.",
          "²³Згідно з унікальними функціями дизайну Intel® Evo™, які також підтверджено на відповідність ключовим пороговим вимогам мобільних користувачів. Тестування станом на лютий 2022&nbsp;р.",
          "²⁴Рішення Intel® Unison™ наразі доступне лише в окремих дизайнах Intel® Evo™ на базі Windows*, і сумісне лише з телефонами Android або iOS; усі пристрої мусять працювати під керуванням підтримуваної версії ОС.",
          "²⁵Максимальна швидкість пам’яті пов’язана з конфігураціями 1 модуль пам’яті DIMM на канал (1DPC). Додаткове завантаження DIMM на будь-якому каналі може вплинути на максимальну швидкість пам’яті. До DDR5-5600 MT/с 1DPC UDIMM 1Rx8, 1Rx16 і DDR5-5200 1Rx8, 1Rx16, 2Rx8 на вибраних артикулах. Максимальний обсяг пам’яті досягається за допомогою конфігурацій з 2DPC.",
          "²⁶У порівнянні зі звичайним Wi-Fi. Докладніше за посиланням: intel.com/performance-wireless. Результати можуть різнитися.",
          "²⁷Гібридна архітектура продуктивності поєднує мікроархітектури двох ядер — Performance-core (P-core) і Efficient-core (E-core) — на одному кристалі процесора. Уперше таку архітектуру представлено на процесорах Intel® Core™ 12-го покоління. Деякі процесори Intel® Core™ 12-го покоління і новіше не мають гібридної архітектури продуктивності, лише ядра P-core та такий самий розмір кеш-пам’яті, як і попереднє покоління. Докладніше про артикул за посиланням: ark.intel.com.",
          "²⁸Інтегрована в обладнання технологія Intel® Thread Director доступна лише в конфігураціях із гібридною архітектурою продуктивності в процесорах Intel® Core™ 12-го покоління чи новіших. Потрібна підтримка з боку ОС. Доступні можливості та функціонал відрізняються залежно від ОС.",
          "²⁹Інтегрована в обладнання технологія Intel® Thread Director доступна лише в конфігураціях із гібридною архітектурою продуктивності процесорів Intel® Core™ 12-го й 13-го поколінь. Потрібна підтримка з боку ОС. Доступні можливості та функціонал відрізняються залежно від ОС.",
          "³⁰За результатами вимірювань продуктивності референсної платформи валідації процесора Intel®&nbsp;Core™ Ultra для мобільних ПК (Серія 2 — кодова назва: Lunar Lake) і процесора Intel®&nbsp;Core™ Ultra для мобільних ПК (Серія 1 — кодова назва: Meteor Lake) з використанням 3DMark Time Spy. Докладніше за посиланням: intel.com/performanceindex. Результати можуть різнитися.",
          "³¹Розмиття фону й відстеження обличчя доступні лише в системах на базі Windows*.",
          "³²У виробів Wi-Fi 7 є доступ до каналів 320 МГц у діапазоні 6 ГГц і нових комбінацій каналів 160 МГц у діапазоні 5 ГГц завдяки новим можливостям Multi-Resource Unit Puncturing.",
          "³³Відповідно до специфікацій стандарту бездротового зв’язку IEEE та максимальної теоретичної швидкості передачі даних для пристроїв з підтримкою двох потоків даних.",
          "³⁴Проведене Intel інженерне моделювання перевантажених мережевих середовищ показує, що затримки значно зменшуються завдяки новим можливостям багатоканальної роботи Wi-Fi 7 Multi-Link Operation.",
          "³⁵Мінімальний заряд, досягнутий від рівня відключення пристрою, заданого кінцевим виробником. Індивідуальні результати системи можуть різнитися. Докладніше за посиланням: intel.com/performance-evo.",
          "³⁶Діапазон Wi-Fi 6 ГГц доступний для використання в окремих країнах/регіонах.",
          "³⁷Лише для Windows*",
          "³⁸Заряд, досягнутий від рівня відключення пристрою, заданого кінцевим виробником. Щоб отримати більш докладну інформацію щодо продуктивності та результатів тестування, завітайте на intel.com/Evo.",
          "³⁹Стосується процесорів Intel®&nbsp;Core™ Ultra для мобільних ПК (Серія&nbsp;2) на основі унікальних апаратних рішень безпеки, неперевершеного поєднання можливостей безпеки ОС та вражаючої продуктивності навіть за нижчого енергоспоживання порівняно з попереднім поколінням (станом на вересень 2024 р.). Докладніше за посиланням: intel.com/performanceindex. Результати можуть різнитися.",
          "⁴⁰Програмні застосунки зображено лише для ілюстративних цілей. Функції ШІ можуть вимагати придбання додаткового програмного забезпечення, підписки або ввімкнення постачальником програмного забезпечення чи платформи, а також мати специфічні вимоги до конфігурації чи сумісності. Докладніше за посиланням: www.intel.com/PerformanceIndex. Результати можуть різнитися. © Корпорація Intel.",
          "⁴¹Показані зображення могли бути змінені або змодельовані. Функції ШІ можуть вимагати придбання додаткового програмного забезпечення, підписки або ввімкнення постачальником програмного забезпечення чи платформи, а також мати специфічні вимоги до конфігурації чи сумісності. Подробиці за посиланням: www.intel.com/AIPC.",
          "⁴²Поступове розгортання попередньої версії в рамках останнього оновлення Windows* 11 на деяких світових ринках. Терміни доступності залежать від пристрою та ринку. Подробиці за посиланням: aka.ms/WindowsAIFeatures. © Корпорація Intel.",
          "⁴³Рішення Intel® Unison™ наразі доступне для відповідних дизайнів. Докладніше за посиланням: www.intel.com/PerformanceIndex.",
          "⁴⁴Частота кадрів, підвищена за допомогою Intel® X<sup>e</sup>SS, проти нативної частоти кадрів за результатами тестування в Dying Light 2 Stay Human з використанням процесора Intel® Core™ Ultra 7 165H. Докладніше за посиланням: www.intel.com/PerformanceIndex. Результати можуть різнитися.",
          "⁴⁵За результатами вимірювань нижчої потужності інтегральної системи процесора Intel® Core™ Ultra для мобільних ПК (Серія 2 — кодова назва Lunar Lake) на референсній платформі валідації проти процесора Intel® Core™ Ultra для мобільних ПК (Серія 1 — кодова назва Meteor Lake) на референсній платформі валідації з використанням відео YouTube* з роздільною здатністю 4K, 30 кадрів на секунду у форматі AV1. Докладніше за посиланням: intel.com/performanceindex. Результати можуть різнитися.",
          "⁴⁶За результатами вимірювань продуктивності референсної платформи валідації процесора Intel® Core™ Ultra для мобільних ПК (Cерія 2 — кодова назва: Lunar Lake) і процесора Meteor Lake з використанням 3DMark* Time Spy. Докладніше за посиланням: intel.com/performanceindex. Результати можуть різнитися.",
          "⁴⁷За результатами вимірювань нижчої потужності інтегральної системи процесора Intel® Core™ Ultra для мобільних ПК (Серія 2 — кодова назва: Lunar Lake) на референсній платформі валідації проти референсної платформи валідації Meteor Lake з використанням відео YouTube* з роздільною здатністю 4K, 30 кадрів на секунду у форматі AV1. Докладніше за посиланням: intel.com/performanceindex. Результати можуть різнитися.",
          "⁴⁸Intel® Application Optimization — це політика в рамках Intel® Dynamic Tuning Technology, яка оптимізує продуктивність в окремих іграх із необхідними конфігураціями на окремих процесорах Intel® Core™ 14-го покоління. Додаткову інформацію про Intel® Application Optimization див. за посиланням: <br/>www.intel.com/content/<br/>www/us/en/support/articles/<br/>000095419/processors.html.",
          "⁴⁹Wi-Fi 7: залежить від регіональної доступності, підтримки операційної системи й сумісності маршрутизатора. Докладніше за посиланням: intel.com/performance-wireless. Результати можуть різнитися.",
          "⁵⁰Станом на квітень 2024 року, в порівнянні з іншим технологіями двонапрямного підключення вводу/виводу клієнта, як-от технологія Thunderbolt™ 5, eSATA та USB. Потрібно підключити через аксесуар з підтримкою технології Thunderbolt™ 5, щоб забезпечити подвійну продуктивність. Докладніше за посиланням: intel.com/performance-wired. Результати можуть різнитися.",
          "⁵¹Докладніше про технологію Thunderbolt™ 5 див. за посиланням: intel.com/thunderbolt.",
          "⁵²На основі мінімальних вимог, зазначених у характеристиках.",
          "⁵³Утиліта спільного доступу Thunderbolt™ — це додаткове ліцензійне програмне рішення виробника і може бути присутнім не на всіх ПК або пристроях з підтримкою Thunderbolt™ 5.<br>Швидке з’єднання порівняно з іншими технологіями з'єднання вводу-виводу ПК, зокрема eSATA, USB та IEEE 1394 Firewire. Показники продуктивності можуть різнитися залежно від конкретного апаратного й програмного забезпечення. Потрібно використати пристрій з підтримкою Thunderbolt™.<br>Технології Thunderbolt™ 4 та Thunderbolt™ 5 підтримують вивід через інтерфейс DisplayPort з нативною можливістю підключення до всіх дисплеїв із DisplayPort та mini-DisplayPort. Завдяки адаптерам можна також підключатися до всіх інших сучасних інтерфейсів дисплеїв, зокрема HDMI, DVI та VGA.<br>Результати роботи окремих аксесуарів можуть відрізнятися; потужність та продуктивність залежать від використання, конфігурації та інших факторів і не гарантують індивідуальної продуктивності аксесуарів.",
          "⁵⁴Завдяки широкій сумісності, широким можливостям програмного забезпечення, унікальній архітектурі та винятковій продуктивності процесорів Intel® Core™ Ultra, які в поєднанні забезпечують найкращі загальні можливості ШІ, зокрема проти процесорів конкурентів (станом на серпень 2024 року).",
          "⁵⁵Ресурс акумулятора значно варіюється залежно від конфігурації, використання та інших факторів.",
          "⁵⁶Стосується окремих ноутбуків Dell* XPS на базі процесора Intel® Core™ Ultra 7 268V, що відповідають вимогам тестування ресурсу акумулятора UL Procyon* Battery Life Benchmark – Office Productivity subscore; роздільна здатність дисплея: 1920 x 1080 та місткість акумулятора: 55 Вт-год.",
          "⁵⁷Графічний процесор Intel® Arc™ доступний лише в деяких системах на базі процесорів Intel® Core™ Ultra. Інші конфігурації системи оснащені графікою Intel®. Конфігурації системи можна дізнатися в кінцевого виробника обладнання або роздрібного продавця.",
          "⁵⁸© 2025 Take - Two Interactive Software, Inc. © 2025 Techland S.A. ©&nbsp;Корпорація&nbsp;Intel. Використайте до 15 вересня 2025 року. Застосовуються умови.",
          "⁵⁹Призначений ПК мусить мати процесор Intel® Core™ Ultra, працювати на Windows* 11 Home або Pro та бути підключеним до Інтернету. Ви маєте скористатися безкоштовною програмою Laplink* PCmover* Express не пізніше 28 лютого 2026 року.",
          "⁶⁰Стосується продуктивності в ряді популярних тестувань на системах із процесорами Intel® Core™ Ultra серії 200V у порівнянні з процесорами конкурентів.",
          "⁶¹Стосується результатів тестування, проведеного в серпні 2024 року з використанням різних популярних ігор на системах з процесорами Intel® Core™ Ultra серії 200V у порівнянні з процесорами конкурентів.",
          "⁶²Стосується систем на базі процесорів Intel® Core™ Ultra серії 200V із вбудованою графічною картою Intel® Arc™ у порівнянні з іншими ультратонкими системами станом на серпень 2024 року, виходячи з виняткової продуктивності в графічних тестах, продуктивності в іграх та високих показників у тестах штучного інтелекту для графіки, зокрема у порівнянні з процесорами конкурентів.",
          "⁶³Стосується систем на базі процесорів Intel® Core™ Ultra серії 200V, що демонструють найкращі показники продуктивності в широкому діапазоні застосувань, тестувань і робочих навантажень порівняно з процесорами конкурентів (станом на серпень 2024 року). Потребує безплатного оновлення. Час оновлення залежить від пристрою та регіону. Додаткову інформацію див. на сайті aka.ms/copilotpluspcs.",
          "⁶⁴Стосується окремих ноутбуків Dell* XPS на базі процесора Intel® Core™ Ultra 7 268V, виходячи з оцінки Office Productivity тестування ресурсу акумулятора UL Procyon* Battery Life Benchmark; роздільна здатність дисплея: 1920 x 1080 та місткість акумулятора: 55 Вт·год. Детальну інформацію щодо виносок 1–7 див. на сайті intel.com/performanceindex.",
          "⁶⁵Станом на січень 2024 р, судячи з унікальних особливостей дизайну Intel® Evo™, як-от високопродуктивні процесори Intel® Core™, компоненти преміумкласу, неперевершена сумісність і новітні рішення для підключення в елегантному інноваційному дизайні. Всі дизайни під товарною маркою Intel® Evo™ повинні відповідати суворим вимогам щодо основних можливостей мобільних користувачів, таких як швидкість реагування та ресурс акумулятора. Продуктивність окремих пристроїв може відрізнятися. Докладніше за посиланням: intel.com/Performance-Evo. Жоден продукт чи компонент неможливо захистити повністю. Програмні застосунки зображено лише для ілюстративних цілей. Функції штучного інтелекту можуть вимагати придбання програмного забезпечення, підписки або активації, а також можуть мати вимоги до конфігурації або сумісності. Переваги конфіденційності даних стосуються нехмарних застосунків штучного інтелекту. Детальну інформацію див. на сайті intel.com/AIPC. Результати можуть різнитися. ©&nbsp;Корпорація&nbsp;Intel. Інші назви та товарні знаки можуть бути власністю інших сторін.",
          "⁶⁶На основі перевіреного в реальних умовах ресурсу акумулятора під час виконання типових робочих процесів у реалістичному середовищі за середньостатистичних сценаріїв щоденного використання. Результати можуть різнитися. Докладніше за посиланням: intel.com/Performance-Evo. ©&nbsp;Корпорація&nbsp;Intel",
          "⁶⁷Розроблено для забезпечення роботи від акумулятора протягом усього дня: стосується ноутбуків на базі процесорів Intel Core 3 з мінімальною ємністю акумулятора та енергоефективною конструкцією за типового сценарію використання ПК із періодами багатозадачності, відтворення відео та роботи в режимі очікування у реалістичному середовищі. Під час оцінювання ресурсу акумулятора враховувалися періоди виконання типових робочих завдань у реалістичному середовищі використання, зокрема хмарні та (за наявності) локальні застосунки й вебсторінки, локальне відтворення відео, а також робота в режимі очікування, що відображають типові сценарії використання ПК звичайними користувачами. Сценарії використання базуються на масштабних дослідженнях користувачів ноутбуків, включаючи внутрішній аналіз доступної інформації компанією Intel станом на квітень 2026 року та інші репрезентативні дослідження споживачів, і включають періодичні тривалі інтервали перебування в режимах сну та простою. Результати окремих систем можуть суттєво відрізнятися залежно від сценарію використання, ємності акумулятора та інших конструктивних особливостей виробників оригінального обладнання",
          "⁶⁸Результати продуктивності базуються на тестуванні станом на 10 квітня 2026 року. Процесор: Intel Core 7 360 (Wildcat Lake) PL1=15 Вт; протестовано на еталонній платформі Intel; пам’ять: 16 ГБ LPDDR5 7467; накопичувач: Samsung PM9A1 512 ГБ; роздільна здатність дисплея: 1920x1200; ОС: Windows 11 26200.7922; графічний драйвер: 32.0.101.8572; драйвер нейронного процесора: 32.0.100.4561; BIOS: WCLPFWI1. R00.4100. D03; план живлення встановлений як «Збалансований» (Balanced); режим живлення встановлений як «Максимальна продуктивність» (Best Performance). Процесор: Qualcomm Snapdragon X Plus X1P-42-100; протестовано в HP OmniBook 5; памʼять: 16 ГБ LPDDR5-8448; накопичувач: PC SN5000S SDEPNSJ-512G; дисплей: 1920x1200; ОС: Windows 11 26200.8037; графічний драйвер: 31.0.148.0; драйвер нейронного процесора: 30.0.220.3000; BIOS: F.06; план живлення встановлений на «Збалансований» (Balanced), режим живлення встановлений як «Максимальна продуктивність» (Best Performance); ємність акумулятора: 59 Вт·год",
          "⁶⁹Результати продуктивності базуються на тестуванні станом на 10 квітня 2026 року. Процесор: Intel Core 7 360 (Wildcat Lake) PL1=15 Вт; протестовано на еталонній платформі Intel; пам’ять: 16 ГБ LPDDR5 7467; накопичувач: Samsung PM9A1 512 ГБ; роздільна здатність дисплея: 1920x1200; ОС: Windows 11 26200.7922; графічний драйвер: 32.0.101.8572; драйвер нейронного процесора: 32.0.100.4561; BIOS: WCLPFWI1. R00.4100. D03; план живлення встановлений як «Збалансований» (Balanced); режим живлення встановлений як «Максимальна продуктивність» (Best Performance). Процесор: Intel Core i7-1185G7 (Tiger Lake); протестовано в Lenovo ThinkPad X1 Gen9 14 із підтримкою PL1=20 Вт; памʼять: 16 ГБ DDR4 4267; накопичувач: Samsung 980 Pro 1 ТБ; дисплей: 1920x1200; ОС: Windows 11 26200.8037; графічний драйвер: 32.0.101.7085; драйвер нейронного процесора: Н/З; BIOS: 1.77; План живлення встановлений як «Збалансований» (Balanced); режим живлення встановлений як «Максимальна продуктивність» (Best Performance). Ємність акумулятора: 57 Вт·год",
          "⁷⁰Показники продуктивності базуються на тестуванні від 10 квітня 2026 року. Процесор: Intel Core 7 350 (Wildcat Lake); протестовано на передсерійному HP OmniBook 5 14″ з постійною потужністю PL1=21 Вт; пам’ять: 16 ГБ LPDDR5 7467; накопичувач: Samsung 9100 Pro 1 ТБ; дисплей: 1920x1200; ОС: Windows 11 26200.8037; Драйвер графіки: 32.0.101.8572; драйвер нейронного процесора: 32.0.100.4561; BIOS: B.17T01; план живлення встановлений як «Збалансований», режим живлення встановлений як «Збалансований»; HP = Збалансований. Ємність акумулятора: 59 Вт·год",
          "[ZhCn Only Legal Text General]",
          "[ZhCn Only Legal Text Point12]",
          "[ZhCn Only Legal Text Point13]",
          "Intel не несе відповідальності за хибно вказані ціни.",
          "*Інші назви та товарні знаки можуть бути власністю інших сторін.",
          "АВТОРСЬКІ ПРАВА 2022&nbsp;INFLEXION GAMES. NIGHTINGALE, INFLEXION GAMES, ПОВ’ЯЗАНИЙ ДИЗАЙН ТА КОМБІНОВАНІ ЗНАКИ Є ТОВАРНИМИ ЗНАКАМИ INFLEXION STUDIOS INC. УСІ ПРАВА ЗАХИЩЕНО.",
          "Технології Intel можуть вимагати під’єднання певного обладнання, застосування специфічного програмного забезпечення або підключення послуг. Жоден продукт чи компонент неможливо захистити повністю. Ваші витрати та результати можуть відрізнятися. Подробиці див. на сайті: https://edc.intel.com/content/<br/>www/us/en/products/performance/<br/>benchmarks/wired/",
          "Будь-які результати та дані від NERO* надаються для зручності й виключно в інформаційних цілях. Корпорація Intel не несе ніякої відповідальності за точність програми NERO*, результати продуктивності та оцінки, а також можливі варіанти оцінок від інших завантажуваних версій, доступних на вебсайті www.nero.com або інших сторонніх вебсайтах. Оцінки за результатами тестування ПК NERO* вимірюються за допомогою певних комп’ютерних систем, компонентів, програмного забезпечення, операцій та функцій. Результати випробувань чутливі до зміни будь-якого зі вказаних чинників. Для прийняття оптимального рішення про купівлю рекомендується оглянути інформацію з інших джерел та ознайомитися з результатами інших випробувань, у тому числі з даними тестування спільної роботи з іншими пристроями.",
          "Для всіх версій платформи Intel vPro® потрібен відповідний процесор Intel® Core™, підтримувана операційна система, мікросхема Intel® LAN і/або WLAN, удосконалення вбудованого ПЗ та інше апаратне й програмне забезпечення, необхідне для забезпечення керованості використання, функцій безпеки, продуктивності й стабільності системи, які характеризують платформу.",
          "Швидкодія залежить від використання, налаштування й інших факторів. Подробиці: www.intel.com/PerformanceIndex.",
          "Intel не контролює і не перевіряє дані третіх сторін. Слід звернутися до інших джерел, щоб оцінити точність.",
          "© 2024 Ubisoft Entertainment*. All Rights Reserved. © Корпорація Intel. Intel, логотип Intel та інші марки Intel є товарними знаками корпорації Intel або її дочірніх компаній. *Інші назви та товарні знаки можуть бути власністю інших сторін.",
          "Жоден продукт чи компонент неможливо захистити повністю.",
          "Ваші витрати та результати можуть відрізнятися.",
          "Intel, логотип Intel, Intel Core, Intel Optane, Intel Iris, Thunderbolt і логотип Thunderbolt є товарними знаками корпорації Intel або її дочірніх компаній у США та/або інших країнах. Інші назви та товарні знаки можуть бути власністю інших сторін.",
          "©&nbsp;Корпорація Intel."
        ],
        "targetURL": "",
        "iconURL": ""
      }
    },
    {
      "tabName": "navigation",
      "navigationTabs": [
        {
          "tr_specTitle": "Головна сторінка",
          "targetURL": "mob-content",
          "iconURL": "assets/images/nav-home.svg"
        },
        {
          "tr_specTitle": "Відскануйте для порівняння",
          "targetURL": "compare",
          "iconURL": ""
        },
        {
          "tr_specTitle": "Тенденції",
          "targetURL": "trending",
          "iconURL": "assets/images/trending.svg"
        }
      ]
    }
  ],
  "trending": [
    {
      "tr_specTitle": "Відкрийте нові можливості ШІ з процесорами Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video"
    },
    {
      "tr_specTitle": "Відкрийте нові можливості ШІ з процесорами Intel® Core™ Ultra",
      "targetURL": "assets/videos/trending/IPOS_AI_Video.mp4",
      "iconURL": "",
      "videoName": "IPOS_AI_Video"
    },
    {
      "tr_specTitle": "Відкрийте нові можливості ШІ з процесорами Intel® Core™ Ultra",
      "targetURL": "assets/lang/[XX]/trending/Ultra_Processor_Video_Panel2.mp4",
      "iconURL": "",
      "videoName": "Ultra_Processor_Video_Panel2"
    },
    {
      "tr_specTitle": "Stable Diffusion*: генерація зображення на основі опису",
      "targetURL": "assets/lang/[XX]/trending/text_link.mp4",
      "iconURL": "",
      "videoName": "text_link"
    },
    {
      "tr_specTitle": "Adobe*: редагування фотографій",
      "targetURL": "assets/lang/[XX]/trending/photo_link.mp4",
      "iconURL": "",
      "videoName": "photo_link"
    },
    {
      "tr_specTitle": "Intel® X<sup>e</sup>SS : масштабування зображень",
      "targetURL": "assets/lang/[XX]/trending/imgUpscaling_link.mp4",
      "iconURL": "",
      "videoName": "imgUpscaling_link"
    },
    {
      "tr_specTitle": "McAfee*: Deepfake Detector",
      "targetURL": "assets/lang/[XX]/trending/Security_link.mp4",
      "iconURL": "",
      "videoName": "Security_link"
    },
    {
      "tr_specTitle": "Microsoft* Copilot",
      "targetURL": "assets/lang/[XX]/trending/copilot_link.mp4",
      "iconURL": "",
      "videoName": "copilot_link"
    },
    {
      "tr_specTitle": "Ефективна співпраця (Teams)",
      "targetURL": "assets/lang/[XX]/trending/Collaboration_link.mp4",
      "iconURL": "",
      "videoName": "Collaboration_link"
    },
    {
      "tr_specTitle": "IQIYI: керування жестами",
      "targetURL": "assets/lang/[XX]/trending/Gesture_link.mp4",
      "iconURL": "",
      "videoName": "Gesture_link"
    },
    {
      "tr_specTitle": "Синхронізуйте свій ПК з телефоном і переглядайте сповіщення, дзвінки та текстові повідомлення",
      "targetURL": "assets/videos/trending/unison_evo_mtl_ultra_processor_video.mp4",
      "iconURL": "",
      "videoName": "unison_evo_mtl_ultra_processor_video"
    },
    {
      "tr_specTitle": "Вбудований графічний процесор для насиченого та яскравого зображення",
      "targetURL": "assets/videos/trending/intel_iris_plus_graphics.mp4",
      "iconURL": "",
      "videoName": "intel_iris_plus_graphics"
    },
    {
      "tr_specTitle": "Microsoft*: живіть по-своєму",
      "targetURL": "assets/videos/trending/standard_home_detail_run_your_life_with_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_run_your_life_with_microsoft_365"
    },
    {
      "tr_specTitle": "Microsoft*: все, що вам важливо. Все як на долоні та завжди під рукою",
      "targetURL": "assets/videos/trending/standard_home_detail_onedrive_in_microsoft_365.mp4",
      "iconURL": "",
      "videoName": "standard_home_detail_onedrive_in_microsoft_365"
    },
    {
      "tr_specTitle": "Xbox* Game Pass Ultimate",
      "targetURL": "assets/videos/trending/windows_10_home.mp4",
      "iconURL": "",
      "videoName": "windows_10_home"
    },
    {
      "tr_specTitle": "Процесор працюватиме швидше та на вищих частотах завдяки тонкому налаштуванню  системи",
      "targetURL": "assets/videos/trending/gaming_processor_detail_enthusiast _overclocking.mp4",
      "iconURL": "",
      "videoName": "gaming_processor_detail_enthusiast _overclocking"
    },
    {
      "tr_specTitle": "Підвищте продуктивність настільної або мобільної системи без шкоди для обсягу накопичувача",
      "targetURL": "assets/videos/trending/optane_memory.mp4",
      "iconURL": "",
      "videoName": "optane_memory"
    },
    {
      "tr_specTitle": "Підвищте продуктивність настільної або мобільної системи без шкоди для обсягу накопичувача",
      "targetURL": "assets/videos/trending/standard_detail_panel_memory_optanememory_optane-memory.mp4",
      "iconURL": "",
      "videoName": "standard_detail_panel_memory_optanememory_optane-memory"
    },
    {
      "tr_specTitle": "Samsung OLED: насправді милує око",
      "targetURL": "assets/lang/[XX]/trending/Samsung_OLED.mp4",
      "iconURL": "",
      "videoName": "Samsung_OLED"
    },
    {
      "tr_specTitle": "Вища швидкість, менша затримка та краща надійність завдяки оптимізації роботи мережі на основі ШІ",
      "targetURL": "assets/videos/trending/standard__wifi_killer_7.mp4",
      "iconURL": "",
      "videoName": "standard__wifi_7_killer"
    },
    {
      "tr_specTitle": "Мережеве підключення ПК на рівні дротового",
      "targetURL": "assets/videos/trending/standard_wifi_7.mp4",
      "iconURL": "",
      "videoName": "standard_wifi_7"
    },
    {
      "tr_specTitle": "Мережеве підключення ПК на рівні дротового",
      "targetURL": "assets/videos/trending/wifi_7_desktop_video.mp4",
      "iconURL": "",
      "videoName": "wifi_7_desktop_video"
    },
    {
      "tr_specTitle": "Майже втричі більша швидкість з Intel® Wi-Fi&nbsp;6 (Gig+)",
      "targetURL": "assets/lang/[XX]/trending/nongaming__wifi_6e.mp4",
      "iconURL": "",
      "videoName": "wifi_6e"
    },
    {
      "tr_specTitle": "З’єднання поза конкуренцією",
      "targetURL": "assets/videos/trending/standard_tile_wifi_intel_panel2_video.mp4",
      "iconURL": "",
      "videoName": "standard_tile_wifi_intel_panel2_video"
    },
    {
      "tr_specTitle": "Універсальний кабель",
      "targetURL": "assets/videos/trending/standard_facttag_details_thunderbolt_version3.mp4",
      "iconURL": "",
      "videoName": "standard_facttag_details_thunderbolt_version3"
    },
    {
      "tr_specTitle": "Грайте як профі: дізнайтеся, про співпрацю Intel з геймерами та ігровою індустрією",
      "targetURL": "assets/videos/trending/gaming_graphics_detail.mp4",
      "iconURL": "",
      "videoName": "gaming_graphics_detail"
    },
    {
      "tr_specTitle": "Грайте як профі: чемпіонами стають завдяки Intel",
      "targetURL": "assets/videos/trending/gaming_detail_panel_influencer_video.mp4",
      "iconURL": "",
      "videoName": "gaming_detail_panel_influencer_video"
    }
  ],
  "uiText": {
    "tr_welcomePageTitle": "ВІТАЄМО",
    "tr_welcomePagetrSubtitle": "Керуйте цим ПК віддалено за допомогою смартфона",
    "tr_welcomePagembSubtitle": "Вітаємо! Ознайомтеся з технічними характеристиками цього ПК на вашому смартфоні",
    "tr_welcomePageBtnText": "Почати",
    "tr_welcomePageText": "Ознайомтеся з технічними характеристиками цього ПК і порівняйте їх на смартфоні",
    "tr_scrollText": "Ознайомтеся з пристроєм перед вами",
    "tr_toolTipTextc1": "Щоб переходити між сторінками, натискайте кнопки на пристрої перед вами.",
    "tr_toolTipTextc2": "Щоб перейти на сторінку докладних технічних характеристик кожного пристрою, натискайте на картки нижче.",
    "tr_toolTipTextc3": "Щоб переміщатися вгору й вниз по екрану перед вами, натискайте ці кнопки.",
    "tr_toolTipTextc4": "Щоб переглянути технічні характеристики пристрою на смартфоні, вимкніть режим віддаленого доступу.",
    "tr_toolTipTextmb1": "Щоб переглянути сторінки з докладним вмістом, натискайте картки.",
    "tr_toolTipTextmb2": "Щоб переглянути загальні технічні характеристики пристрою, натисніть тут",
    "tr_toolTipTextmb3": "Щоб відсканувати QR-код і порівняти до 4&nbsp;пристроїв, натисніть кнопку",
    "tr_nextButton": "Далі",
    "tr_prevButton": "Назад",
    "tr_gotItButton": "ЗРОЗУМІЛО",
    "tr_skipButton": "Пропустити",
    "tr_placeholderText": "*заповнювач",
    "tr_processorHeading": "Процесор",
    "tr_processorSubheading": "Процесор Intel®&nbsp;Core™&nbsp;i7 10&#8209;го покоління",
    "tr_memorySubheading": "[XX]&nbsp;ГБ",
    "tr_storageSubheading": "Пам’ять Intel® Optane™ обсягом [XX]&nbsp;ГБ + твердотілий диск обсягом [YY]&nbsp;ГБ",
    "tr_coachmarkProcessor": "Процесор XX",
    "tr_coachmarkGraphics": "Графіка [XX]",
    "tr_coachmarkMemory": "Технічні характеристики",
    "tr_coachmarkOS": "[XX]",
    "tr_deviceName": "HP Envy&nbsp;17T",
    "tr_price": "$ 999,95",
    "tr_compare": "Порівняти",
    "tr_viewallspecs": "ПЕРЕГЛЯНУТИ ВСІ ХАРАКТЕРИСТИКИ",
    "tr_operatingSystem": "ОС",
    "tr_AmdProcessorNonIntel": "Процесор AMD*",
    "tr_QualcommProcessorNonIntel": "Процесор Qualcomm*",
    "tr_GBText": "ГБ",
    "tr_remoteText": "Технічні характеристики, що відображаються на екрані ноутбука",
    "tr_scanErrorText": "Ви можете сканувати щонайбільше 3&nbsp;пристрої за один раз. Видаліть один чи кілька пристроїв.",
    "tr_scanErrorText2": "Ви вже відсканували цей пристрій, будь ласка, відскануйте інший.",
    "tr_scanMsg": "Відскануйте, щоб додати пристрій",
    "tr_scanQRCode": "Проскануйте QR-код",
    "tr_addDevice": "Додати інший пристрій",
    "tr_download": "Завантажити",
    "tr_confirm": "Підтвердити",
    "tr_cancel": "Скасувати",
    "tr_downloadFile": "Завантажити файл?",
    "tr_downloadSubtitle": "Результати порівняння пристроїв будуть збережені у форматі PDF.",
    "tr_backToScan": "Назад до порівняння",
    "tr_scanToCompare": "Відскануйте для порівняння",
    "tr_compareDevice": "Порівняти пристрої",
    "tr_processorTitle": "ПРОЦЕСОР",
    "tr_graphicTitle": "ГРАФІКА",
    "tr_storageTitle": "НАКОПИЧУВАЧІ",
    "tr_displayTitle": "ДИСПЛЕЙ",
    "tr_batteryTitle": "АКУМУЛЯТОР",
    "tr_memoryTitle": "ОПЕРАТИВНА ПАМ’ЯТЬ",
    "tr_wifiTitle": "Wi‑Fi",
    "tr_connectivityTitle": "ПІДКЛЮЧЕННЯ",
    "tr_priceTitle": "ЦІНА",
    "tr_operatingSystemTitle": "ОПЕРАЦІЙНА СИСТЕМА",
    "tr_batteryHoursText": "Годин: [XX]",
    "tr_hrsText": "год",
    "tr_touchscreeenText": "Сенсорний екран з діагоналлю [screenDiagonal]&nbsp;дюймів",
    "tr_HDText": "HD",
    "tr_FHDText": "Full HD",
    "tr_4KText": "4K",
    "tr_HDTochScreenText": "HD, сенсорний екран",
    "tr_FHDTouchScreenText": "Full HD, сенсорний екран",
    "tr_4KTouchscreenText": "4K, сенсорний екран",
    "tr_wifi_gigText": "(Gig+)",
    "tr_save": "Зберегти",
    "tr_device_comparison": "Документ порівняння пристроїв [dd]-[mm]-[yyyy]",
    "tr_Save_As_JPEG": "Зберегти у форматі JPEG",
    "tr_Save_As_PDF": "Зберегти у форматі PDF",
    "tr_Downloading_PDF": "Завантаження PDF",
    "tr_pdf_file": "[XXX].pdf",
    "tr_open": "Відкрити",
    "tr_logo": "логотип",
    "tr_laptop_name": "Назва комп’ютера",
    "tr_TBText": "ТБ",
    "tr_optaneMemoryTitle": "Пам’ять Intel® Optane™",
    "tr_inchUnit": "&nbsp;дюймів",
    "tr_wifi1": "Wi‑Fi 1",
    "tr_wifi2": "Wi‑Fi 2",
    "tr_wifi3": "Wi‑Fi 3",
    "tr_wifi4": "Wi‑Fi 4",
    "tr_wifi5": "Wi‑Fi 5",
    "tr_wifi6": "Intel® Wi‑Fi 6 (Gig+)",
    "tr_wifi6Caps": "INTEL® WI‑FI 6 (GIG+)",
    "tr_wifi6e": "6E",
    "tr_wifi6eValue": "Wi‑Fi 6E",
    "tr_wifiXX": "Wi‑Fi [XX]",
    "tr_wifiXXCaps": "WI‑FI [XX]",
    "tr_wifi6E": "Intel® Wi‑Fi 6E (Gig+)",
    "tr_IntelOptaneMemory": "ПАМ’ЯТЬ INTEL® OPTANE™",
    "tr_Thunderbolt3": "Технологія Thunderbolt™ 3",
    "tr_Thunderbolt4": "Технологія Thunderbolt™ 4",
    "tr_Thunderbolt5": "Технологія Thunderbolt™ 5",
    "tr_processorGraphicsCaps": "ГРАФІЧНИЙ ПРОЦЕСОР",
    "tr_processorGraphicsSmall": "Графічний процесор",
    "tr_graphicsCardCaps": "ВИДІЛЕНА ГРАФІКА",
    "tr_graphicsCardSmall": "Виділена графіка",
    "tr_processorTitleCamel": "Процесор",
    "tr_graphicTitleCamel": "Графіка",
    "tr_storageTitleCamel": "Накопичувачі",
    "tr_displayTitleCamel": "Екран",
    "tr_batteryTitleCamel": "Акумулятор",
    "tr_batteryLifeTitleCamel": "Ресурс акумулятора",
    "tr_exceptionalBattery": "Винятковий ресурс акумулятора",
    "tr_memoryTitleCamel": "Пам’ять",
    "tr_connectivityTitleCamel": "Підключення",
    "tr_priceTitleCamel": "Ціна",
    "tr_operatingSystemTitleCamel": "Операційна система",
    "tr_viewallspecsCamel": "Переглянути всі характеристики",
    "tr_displayText": "[screenDiagonal]&nbsp;дюймів",
    "tr_displayTextResolution": "[screenDiagonal]&nbsp;дюймів [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen": "Сенсорний екран з діагоналлю [screenDiagonal]&nbsp;дюймів [screenResolutionType]",
    "tr_OS": "ОС",
    "tr_Chrome_OS": "ОС Chrome*",
    "tr_thisPC": "Цей ПК",
    "tr_PCSpecs_text": "Характеристики ПК",
    "tr_explorePC_text": "Дізнайтеся все про цей ПК",
    "tr_mtlPC_text": "Дивіться, що насправді означає «створені, щоб робити все»",
    "tr_optaneMemory": "Пам’ять Intel® Optane™",
    "tr_displayText_Display": "ДИСПЛЕЙ З ДІАГОНАЛЛЮ [screenDiagonal]&nbsp;ДЮЙМІВ",
    "tr_displayTextResolution_Display": "ДИСПЛЕЙ З ДІАГОНАЛЛЮ [screenDiagonal] ДЮЙМІВ І РОЗДІЛЬНОЮ ЗДАТНІСТЮ [screenResolutionType]",
    "tr_displayTextResolutionTouchscreen_Display": "СЕНСОРНИЙ ДИСПЛЕЙ З ДІАГОНАЛЛЮ [screenDiagonal]&nbsp;ДЮЙМІВ І РОЗДІЛЬНОЮ ЗДАТНІСТЮ [screenResolutionType]",
    "tr_displayTextTouchscreeenText": "СЕНСОРНИЙ ДИСПЛЕЙ З ДІАГОНАЛЛЮ [screenDiagonal]&nbsp;ДЮЙМІВ ",
    "tr_learnMoreLabel": "Докладніше",
    "tr_batteryHoursTextUpperCase": "[XX]&nbsp;ГОД",
    "tr_processorGraphicsIrisXe": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 11-ГО ПОКОЛІННЯ ТА ГРАФІКА INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 11-ГО ПОКОЛІННЯ ТА ГРАФІКА INTEL® IRIS® X<sup class='small_text_sup_xe'>e</sup> MAX",
    "tr_Thunderbolt3UpperCase": "ТЕХНОЛОГІЯ THUNDERBOLT™ 3",
    "tr_Thunderbolt4UpperCase": "ТЕХНОЛОГІЯ THUNDERBOLT™ 4",
    "tr_Thunderbolt5UpperCase": "ВІДЧУЙТЕ ПЕРЕВАГИ ТЕХНОЛОГІЇ THUNDERBOLT™ 5",
    "tr_processorWithArcGraphics": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛІННЯ І ГРАФІКА&nbsp;INTEL®&nbsp;ARC™",
    "tr_processorGraphicsIrisXe12Gen": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛІННЯ ТА ГРАФІКА&nbsp;INTEL®&nbsp;IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax12Gen": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 12-ГО ПОКОЛІННЯ ТА ГРАФІКА&nbsp;INTEL®&nbsp;IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>&nbsp;MAX",
    "tr_samsung_oled": "Samsung OLED",
    "tr_oled": "OLED",
    "tr_processorWithArcGraphics13Gen": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛІННЯ І ГРАФІКА&nbsp;INTEL®&nbsp;ARC™",
    "tr_processorGraphicsIrisXe13Gen": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛІННЯ ТА ГРАФІКА&nbsp;INTEL®&nbsp;IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>",
    "tr_processorGraphicsIrisXeMax13Gen": "ПРОЦЕСОР INTEL® CORE™ [cpu_fam] 13-ГО ПОКОЛІННЯ ТА ГРАФІКА&nbsp;INTEL®&nbsp;IRIS®&nbsp;X<sup class='small_text_sup_xe'>e</sup>&nbsp;MAX",
    "tr_ultra5": "Intel®&nbsp;Core™ Ultra&nbsp;5",
    "tr_ultra7": "Intel®&nbsp;Core™ Ultra&nbsp;7",
    "tr_ultra9": "Intel®&nbsp;Core™ Ultra&nbsp;9",
    "tr_arcGraphicsBadgeToModelNameMapping": {
      "tr_A350M": "ГРАФІКА INTEL® ARC™ A350M",
      "tr_A370M": "ГРАФІКА INTEL® ARC™ A370M",
      "tr_A730M": "ГРАФІКА INTEL® ARC™ A730M",
      "tr_A770M": "ГРАФІКА INTEL® ARC™ A770M",
      "tr_A310": "ГРАФІКА INTEL® ARC™ A310",
      "tr_A380": "ГРАФІКА INTEL® ARC™ A380",
      "tr_A580": "ГРАФІКА INTEL® ARC™ A580",
      "tr_A750": "ГРАФІКА INTEL® ARC™ A750",
      "tr_A770": "ГРАФІКА INTEL® ARC™ A770"
    },
    "tr_memoryValue": "Обсяг оперативної пам’яті: [XX]&nbsp;ГБ",
    "tr_memoryWithOptaneDesc": "[Value1]&nbsp;ГБ пам’яті = [Value2]&nbsp;ГБ пам’яті Intel® Optane™ + [Value3]&nbsp;ГБ оперативної пам’яті",
    "tr_textGBGB": "[convertedSSD]&nbsp;ГБ твердотілого накопичувача +&nbsp;[convertedHDD]&nbsp;ГБ жорсткого&nbsp;диска",
    "tr_textGBTB": "[convertedSSD]&nbsp;ГБ твердотілого накопичувача +&nbsp;[convertedHDD]&nbsp;ТБ жорсткого&nbsp;диска",
    "tr_textTBGB": "[convertedSSD]&nbsp;ТБ твердотілого накопичувача +&nbsp;[convertedHDD]&nbsp;ГБ жорсткого&nbsp;диска",
    "tr_textTBTB": "[convertedSSD]&nbsp;ТБ твердотілого накопичувача +&nbsp;[convertedHDD]&nbsp;ТБ жорсткого&nbsp;диска",
    "tr_textGBSSD": "[convertedSSD]&nbsp;ГБ твердотілого накопичувача",
    "tr_textTBSSD": "[convertedSSD]&nbsp;ТБ твердотілого накопичувача",
    "tr_textGBHDD": "[convertedHDD]&nbsp;ГБ жорсткого диска",
    "tr_textTBHDD": "[convertedHDD]&nbsp;ТБ жорсткого диска",
    "tr_textStorageWithOptaneGB": "Пам’ять Intel®&nbsp;Optane™ [XX]&nbsp;ГБ + [convertedSSD]&nbsp;ГБ твердотілого диска",
    "tr_textStorageWithOptaneTB": "Пам’ять Intel®&nbsp;Optane™ [XX]&nbsp;ГБ + [convertedSSD]&nbsp;ТБ твердотілого диска",
    "tr_OSDescriptionMapping": {
      "tr_OS_A": "Windows* 7",
      "tr_OS_B": "Windows* 7 Home Basic",
      "tr_OS_C": "Windows* 7 Home Premium",
      "tr_OS_D": "Windows* 7 Professional",
      "tr_OS_E": "Windows* 7 Enterprise",
      "tr_OS_F": "Windows* 7 Ultimate",
      "tr_OS_G": "Windows* 8",
      "tr_OS_H": "Windows* 8 Pro",
      "tr_OS_I": "Windows* 8 Enterprise",
      "tr_OS_J": "Windows* 8.1",
      "tr_OS_K": "Windows* 8.1 Pro",
      "tr_OS_L": "Windows* 8.1 Enterprise",
      "tr_OS_M": "Windows* 8.1",
      "tr_OS_N": "Windows* 10 Home",
      "tr_OS_O": "Windows* 10 Pro",
      "tr_OS_P": "Windows* 10 Enterprise",
      "tr_OS_Q": "Windows* 11 Home",
      "tr_OS_R": "Windows* 11 Pro",
      "tr_OS_S": "Windows* 11 Enterprise",
      "tr_OS_T": "ОС Windows* 10 Home у S-режимі",
      "tr_OS_U": "ОС Windows* 10 Pro у S-режимі",
      "tr_OS_V": "ОС Windows* 10 Enterprise у S-режимі",
      "tr_OS_W": "ОС Windows* 11 Home у S-режимі",
      "tr_OS_X": "ОС Windows* 11 Pro у S-режимі",
      "tr_OS_Y": "ОС Windows* 11 Enterprise у S-режимі"
    },
    "tr_GraphicsDescriptionMapping": {
      "tr_GR1": "AMD* Mobility Radeon* 4100",
      "tr_GR2": "AMD* Mobility Radeon* HD 2400",
      "tr_GR3": "AMD* Mobility Radeon* HD 2400 XT",
      "tr_GR4": "AMD* Mobility Radeon* HD 2600",
      "tr_GR5": "AMD* Mobility Radeon* HD 2600 XT",
      "tr_GR6": "AMD* Mobility Radeon* HD 3400",
      "tr_GR7": "AMD* Mobility Radeon* HD 3430",
      "tr_GR8": "AMD* Mobility Radeon* HD 3650",
      "tr_GR9": "AMD* Mobility Radeon* HD 3670",
      "tr_GR10": "AMD* Mobility Radeon* HD 3850",
      "tr_GR11": "AMD* Mobility Radeon* HD 3850 X2",
      "tr_GR12": "AMD* Mobility Radeon* HD 3870",
      "tr_GR13": "AMD* Mobility Radeon* HD 3870 X2",
      "tr_GR14": "AMD* Mobility Radeon* HD 4200",
      "tr_GR15": "AMD* Mobility Radeon* HD 4300",
      "tr_GR16": "AMD* Mobility Radeon* HD 4330",
      "tr_GR17": "AMD* Mobility Radeon* HD 4500",
      "tr_GR18": "AMD* Mobility Radeon* HD 4650",
      "tr_GR19": "AMD* Mobility Radeon* HD 4670",
      "tr_GR20": "AMD* Mobility Radeon* HD 4830",
      "tr_GR21": "AMD* Mobility Radeon* HD 4850",
      "tr_GR22": "AMD* Mobility Radeon* HD 4860",
      "tr_GR23": "AMD* Mobility Radeon* HD 4870",
      "tr_GR24": "AMD* Mobility Radeon* HD 5000",
      "tr_GR25": "AMD* Mobility Radeon* HD 5570",
      "tr_GR26": "AMD* Mobility Radeon* HD 5800",
      "tr_GR27": "AMD* Mobility Radeon* HD 6000",
      "tr_GR28": "AMD* Radeon* HD 2350",
      "tr_GR29": "AMD* Radeon* HD 2400",
      "tr_GR30": "AMD* Radeon* HD 2400 Pro",
      "tr_GR31": "AMD* Radeon* HD 2400 XT",
      "tr_GR32": "AMD* Radeon* HD 2600",
      "tr_GR33": "AMD* Radeon* HD 2600 Pro",
      "tr_GR34": "AMD* Radeon* HD 2600 XT",
      "tr_GR35": "AMD* Radeon* HD 2900 GT",
      "tr_GR36": "AMD* Radeon* HD 2900 Pro",
      "tr_GR37": "AMD* Radeon* HD 2900 XT",
      "tr_GR38": "AMD* Radeon* HD 3200",
      "tr_GR39": "AMD* Radeon* HD 3300",
      "tr_GR40": "AMD* Radeon* HD 3450",
      "tr_GR41": "AMD* Radeon* HD 3470",
      "tr_GR42": "AMD* Radeon* HD 3600",
      "tr_GR43": "AMD* Radeon* HD 3650",
      "tr_GR44": "AMD* Radeon* HD 3830",
      "tr_GR45": "AMD* Radeon* HD 3850",
      "tr_GR46": "AMD* Radeon* HD 3850 X2",
      "tr_GR47": "AMD* Radeon* HD 3870",
      "tr_GR48": "AMD* Radeon* HD 3870 X2",
      "tr_GR49": "AMD* Radeon* HD 4200",
      "tr_GR50": "AMD* Radeon* HD 4250",
      "tr_GR51": "AMD* Radeon* HD 4290",
      "tr_GR52": "AMD* Radeon* HD 4300",
      "tr_GR53": "AMD* Radeon* HD 4550",
      "tr_GR54": "AMD* Radeon* HD 4600",
      "tr_GR55": "AMD* Radeon* HD 4700",
      "tr_GR56": "AMD* Radeon* HD 4770",
      "tr_GR57": "AMD* Radeon* HD 4800",
      "tr_GR58": "AMD* Radeon* HD 4850 X2",
      "tr_GR59": "AMD* Radeon* HD 4870 X2",
      "tr_GR60": "AMD* Radeon* HD 5000",
      "tr_GR61": "AMD* Radeon* HD 5400",
      "tr_GR62": "AMD* Radeon* HD 5450",
      "tr_GR63": "AMD* Radeon* HD 5470",
      "tr_GR64": "AMD* Radeon* HD 5490",
      "tr_GR65": "AMD* Radeon* HD 5500",
      "tr_GR66": "AMD* Radeon* HD 5530",
      "tr_GR67": "AMD* Radeon* HD 5570",
      "tr_GR68": "AMD* Radeon* HD 5600",
      "tr_GR69": "AMD* Radeon* HD 5630",
      "tr_GR70": "AMD* Mobility Radeon* 4100",
      "tr_GR71": "AMD* Radeon* HD 5690",
      "tr_GR72": "AMD* Radeon* HD 5700",
      "tr_GR73": "AMD* Radeon* HD 5730",
      "tr_GR74": "AMD* Radeon* HD 5800",
      "tr_GR75": "AMD* Radeon* HD 5850X2",
      "tr_GR76": "AMD* Radeon* HD 5900",
      "tr_GR77": "AMD* Radeon* HD 6230",
      "tr_GR78": "AMD* Radeon* HD 6250",
      "tr_GR79": "AMD* Radeon* HD 6290",
      "tr_GR80": "AMD* Radeon* HD 6300M",
      "tr_GR81": "AMD* Radeon* HD 6350",
      "tr_GR82": "AMD* Radeon* HD 6350A",
      "tr_GR83": "AMD* Radeon* HD 6390",
      "tr_GR84": "AMD* Radeon* HD 6400",
      "tr_GR85": "AMD* Radeon* HD 6430M",
      "tr_GR86": "AMD* Radeon* HD 6450",
      "tr_GR87": "AMD* Radeon* HD 6490",
      "tr_GR88": "AMD* Radeon* HD 6500",
      "tr_GR89": "AMD* Radeon* HD 6510",
      "tr_GR90": "AMD* Radeon* HD 6530",
      "tr_GR91": "AMD* Radeon* HD 6570",
      "tr_GR92": "AMD* Radeon* HD 6600A",
      "tr_GR93": "AMD* Radeon* HD 6610",
      "tr_GR94": "AMD* Radeon* HD 6670",
      "tr_GR95": "AMD* Radeon* HD 6700",
      "tr_GR96": "AMD* Radeon* HD 6700M",
      "tr_GR97": "AMD* Radeon* HD 6750",
      "tr_GR98": "AMD* Radeon* HD 6800",
      "tr_GR99": "AMD* Radeon* HD 6800M",
      "tr_GR100": "AMD* Radeon* HD 6850",
      "tr_GR101": "AMD* Radeon* HD 6850 X2",
      "tr_GR102": "AMD* Radeon* HD 6870",
      "tr_GR103": "AMD* Radeon* HD 6870 X2",
      "tr_GR104": "AMD* Radeon* HD 6900",
      "tr_GR105": "AMD* Radeon* HD 6900M",
      "tr_GR106": "AMD* Radeon* HD 7000",
      "tr_GR107": "AMD* Radeon* HD 7000M",
      "tr_GR108": "AMD* Radeon* HD 7300",
      "tr_GR109": "AMD* Radeon* HD 7350",
      "tr_GR110": "AMD* Radeon* HD 7400",
      "tr_GR111": "AMD* Radeon* HD 7400A",
      "tr_GR112": "AMD* Radeon* HD 7400G",
      "tr_GR113": "AMD* Radeon* HD 7400M",
      "tr_GR114": "AMD* Radeon* HD 7420G",
      "tr_GR115": "AMD* Radeon* HD 7450",
      "tr_GR116": "AMD* Radeon* HD 7450A",
      "tr_GR117": "AMD* Radeon* HD 7470",
      "tr_GR118": "AMD* Radeon* HD 7480D",
      "tr_GR119": "AMD* Radeon* HD 7500",
      "tr_GR120": "AMD* Radeon* HD 7500G",
      "tr_GR121": "AMD* Radeon* HD 7500M",
      "tr_GR122": "AMD* Radeon* HD 7510",
      "tr_GR123": "AMD* Radeon* HD 7520G",
      "tr_GR124": "AMD* Radeon* HD 7540D",
      "tr_GR125": "AMD* Radeon* HD 7560D",
      "tr_GR126": "AMD* Radeon* HD 7570",
      "tr_GR127": "AMD* Radeon* HD 7600",
      "tr_GR128": "AMD* Radeon* HD 7600A",
      "tr_GR129": "AMD* Radeon* HD 7600G",
      "tr_GR130": "AMD* Radeon* HD 7600M",
      "tr_GR131": "AMD* Radeon* HD 7620G",
      "tr_GR132": "AMD* Radeon* HD 7640G",
      "tr_GR133": "AMD* Radeon* HD 7660D",
      "tr_GR134": "AMD* Radeon* HD 7660G",
      "tr_GR135": "AMD* Radeon* HD 7670",
      "tr_GR136": "AMD* Radeon* HD 7670M",
      "tr_GR137": "AMD* Radeon* HD 7700",
      "tr_GR138": "AMD* Radeon* HD 7700M",
      "tr_GR139": "AMD* Radeon* HD 7720",
      "tr_GR140": "AMD* Radeon* HD 7800",
      "tr_GR141": "AMD* Radeon* HD 7800M",
      "tr_GR142": "AMD* Radeon* HD 7900",
      "tr_GR143": "AMD* Radeon* HD 7970M",
      "tr_GR144": "AMD* Radeon* HD 8180",
      "tr_GR145": "AMD* Radeon* HD 8200",
      "tr_GR146": "AMD* Radeon* HD 8210",
      "tr_GR147": "AMD* Radeon* HD 8210E",
      "tr_GR148": "AMD* Radeon* HD 8250",
      "tr_GR149": "AMD* Radeon* HD 8280E",
      "tr_GR150": "AMD* Radeon* HD 8310G",
      "tr_GR151": "AMD* Radeon* HD 8330",
      "tr_GR152": "AMD* Radeon* HD 8330E",
      "tr_GR153": "AMD* Radeon* HD 8350",
      "tr_GR154": "AMD* Radeon* HD 8350G",
      "tr_GR155": "AMD* Radeon* HD 8370D",
      "tr_GR156": "AMD* Radeon* HD 8400",
      "tr_GR157": "AMD* Radeon* HD 8400E",
      "tr_GR158": "AMD* Radeon* HD 8410G",
      "tr_GR159": "AMD* Radeon* HD 8450",
      "tr_GR160": "AMD* Radeon* HD 8450G",
      "tr_GR161": "AMD* Radeon* HD 8470",
      "tr_GR162": "AMD* Radeon* HD 8470D",
      "tr_GR163": "AMD* Radeon* HD 8490",
      "tr_GR164": "AMD* Radeon* HD 8500M",
      "tr_GR165": "AMD* Radeon* HD 8510",
      "tr_GR166": "AMD* Radeon* HD 8510G",
      "tr_GR167": "AMD* Radeon* HD 8550",
      "tr_GR168": "AMD* Radeon* HD 8550D",
      "tr_GR169": "AMD* Radeon* HD 8550G",
      "tr_GR170": "AMD* Radeon* HD 8570",
      "tr_GR171": "AMD* Radeon* HD 8570D",
      "tr_GR172": "AMD* Radeon* HD 8600",
      "tr_GR173": "AMD* Radeon* HD 8600M",
      "tr_GR174": "AMD* Radeon* HD 8610G",
      "tr_GR175": "AMD* Radeon* HD 8650D",
      "tr_GR176": "AMD* Radeon* HD 8650G",
      "tr_GR177": "AMD* Radeon* HD 8670D",
      "tr_GR178": "AMD* Radeon* HD 8730",
      "tr_GR179": "AMD* Radeon* HD 8760",
      "tr_GR180": "AMD* Radeon* HD 8770",
      "tr_GR181": "AMD* Radeon* HD 8790M",
      "tr_GR182": "AMD* Radeon* HD 8800M",
      "tr_GR183": "AMD* Radeon* HD 8870",
      "tr_GR184": "AMD* Radeon* HD 8950",
      "tr_GR185": "AMD* Radeon* HD 8970",
      "tr_GR186": "AMD* Radeon* HD 8970M",
      "tr_GR187": "AMD* Radeon* HD 8990",
      "tr_GR188": "AMD* Radeon* HD 9000",
      "tr_GR189": "AMD* Radeon* Pro 450",
      "tr_GR190": "AMD* Radeon* Pro 455",
      "tr_GR191": "AMD* Radeon* Pro 460",
      "tr_GR192": "AMD* Radeon* Pro 465",
      "tr_GR193": "AMD* Radeon* Pro Duo",
      "tr_GR194": "AMD* Radeon* Pro SSG",
      "tr_GR195": "AMD* Radeon* Pro V340",
      "tr_GR196": "AMD* Radeon* Pro V5300X",
      "tr_GR197": "AMD* Radeon* Pro V7300X",
      "tr_GR198": "AMD* Radeon* Pro V7350x2",
      "tr_GR199": "AMD* Radeon* Pro Vega 56",
      "tr_GR200": "AMD* Radeon* Pro VII",
      "tr_GR201": "AMD* Radeon* Pro W5500",
      "tr_GR202": "AMD* Radeon* Pro W5500M",
      "tr_GR203": "AMD* Radeon* Pro W5700",
      "tr_GR204": "AMD* Radeon* Pro W6300",
      "tr_GR205": "AMD* Radeon* Pro W6300M",
      "tr_GR206": "AMD* Radeon* Pro W6400",
      "tr_GR207": "AMD* Radeon* Pro W6500M",
      "tr_GR208": "AMD* Radeon* Pro W6600",
      "tr_GR209": "AMD* Radeon* Pro W6600M",
      "tr_GR210": "AMD* Radeon* Pro W6800",
      "tr_GR211": "AMD* Radeon* Pro W7500",
      "tr_GR212": "AMD* Radeon* Pro W7600",
      "tr_GR213": "AMD* Radeon* Pro W7700",
      "tr_GR214": "AMD* Radeon* Pro W7800",
      "tr_GR215": "AMD* Radeon* Pro W7900",
      "tr_GR216": "AMD* Radeon* Pro WX 2100",
      "tr_GR217": "AMD* Radeon* Pro WX 3100",
      "tr_GR218": "AMD* Radeon* Pro WX 3200",
      "tr_GR219": "AMD* Radeon* Pro WX 4100",
      "tr_GR220": "AMD* Radeon* Pro WX 4150",
      "tr_GR221": "AMD* Radeon* Pro WX 4170",
      "tr_GR222": "AMD* Radeon* Pro WX 5100",
      "tr_GR223": "AMD* Radeon* Pro WX 7100",
      "tr_GR224": "AMD* Radeon* Pro WX 8200",
      "tr_GR225": "AMD* Radeon* Pro WX 9100",
      "tr_GR226": "AMD* Radeon* R5 200",
      "tr_GR227": "AMD* Radeon* R5 220",
      "tr_GR228": "AMD* Radeon* R5 230",
      "tr_GR229": "AMD* Radeon* R5 235",
      "tr_GR230": "AMD* Radeon* R5 240",
      "tr_GR231": "AMD* Radeon* R5 340",
      "tr_GR232": "AMD* Radeon* R5 340X",
      "tr_GR233": "AMD* Radeon* R5 420",
      "tr_GR234": "AMD* Radeon* R5 430",
      "tr_GR235": "AMD* Radeon* R5 430M",
      "tr_GR236": "AMD* Radeon* R5 M200",
      "tr_GR237": "AMD* Radeon* R5 M230",
      "tr_GR238": "AMD* Radeon* R5 M240",
      "tr_GR239": "AMD* Radeon* R5 M255",
      "tr_GR240": "AMD* Radeon* R5 M315",
      "tr_GR241": "AMD* Radeon* R5 M320",
      "tr_GR242": "AMD* Radeon* R5 M330",
      "tr_GR243": "AMD* Radeon* R5 M335",
      "tr_GR244": "AMD* Radeon* R5 M430",
      "tr_GR245": "AMD* Radeon* R5 M435",
      "tr_GR246": "AMD* Radeon* R6 M255DX",
      "tr_GR247": "AMD* Radeon* R6 M335DX",
      "tr_GR248": "AMD* Radeon* R6 M340DX",
      "tr_GR249": "AMD* Radeon* R6 M435DX",
      "tr_GR250": "AMD* Radeon* R7 200",
      "tr_GR251": "AMD* Radeon* R7 240",
      "tr_GR252": "AMD* Radeon* R7 250",
      "tr_GR253": "AMD* Radeon* R7 250X",
      "tr_GR254": "AMD* Radeon* R7 265",
      "tr_GR255": "AMD* Radeon* R7 300",
      "tr_GR256": "AMD* Radeon* R7 340",
      "tr_GR257": "AMD* Radeon* R7 350",
      "tr_GR258": "AMD* Radeon* R7 350X",
      "tr_GR259": "AMD* Radeon* R7 360",
      "tr_GR260": "AMD* Radeon* R7 370",
      "tr_GR261": "AMD* Radeon* R7 430",
      "tr_GR262": "AMD* Radeon* R7 450",
      "tr_GR263": "AMD* Radeon* R7 M260",
      "tr_GR264": "AMD* Radeon* R7 M260DX",
      "tr_GR265": "AMD* Radeon* R7 M265",
      "tr_GR266": "AMD* Radeon* R7 M265DX",
      "tr_GR267": "AMD* Radeon* R7 M340",
      "tr_GR268": "AMD* Radeon* R7 M350",
      "tr_GR269": "AMD* Radeon* R7 M360",
      "tr_GR270": "AMD* Radeon* R7 M370",
      "tr_GR271": "AMD* Radeon* R7 M380",
      "tr_GR272": "AMD* Radeon* R7 M440",
      "tr_GR273": "AMD* Radeon* R7 M460",
      "tr_GR274": "AMD* Radeon* R7 M465",
      "tr_GR275": "AMD* Radeon* R7 M465X",
      "tr_GR276": "AMD* Radeon* R8 M350DX",
      "tr_GR277": "AMD* Radeon* R8 M435DX",
      "tr_GR278": "AMD* Radeon* R8 M535DX",
      "tr_GR279": "AMD* Radeon* R9 200",
      "tr_GR280": "AMD* Radeon* R9 255",
      "tr_GR281": "AMD* Radeon* R9 260",
      "tr_GR282": "AMD* Radeon* R9 270",
      "tr_GR283": "AMD* Radeon* R9 280",
      "tr_GR284": "AMD* Radeon* R9 290",
      "tr_GR285": "AMD* Radeon* R9 290X",
      "tr_GR286": "AMD* Radeon* R9 295X2",
      "tr_GR287": "AMD* Radeon* R9 360",
      "tr_GR288": "AMD* Radeon* R9 370",
      "tr_GR289": "AMD* Radeon* R9 370X",
      "tr_GR290": "AMD* Radeon* R9 380",
      "tr_GR291": "AMD* Radeon* R9 390",
      "tr_GR292": "AMD* Radeon* R9 390X",
      "tr_GR293": "AMD* Radeon* R9 Fury",
      "tr_GR294": "AMD* Radeon* R9 Fury X",
      "tr_GR295": "AMD* Radeon* R9 M200X",
      "tr_GR296": "AMD* Radeon* R9 M275X",
      "tr_GR297": "AMD* Radeon* R9 M280X",
      "tr_GR298": "AMD* Radeon* R9 M360",
      "tr_GR299": "AMD* Radeon* R9 M365X",
      "tr_GR300": "AMD* Radeon* R9 M370X",
      "tr_GR301": "AMD* Radeon* R9 M375",
      "tr_GR302": "AMD* Radeon* R9 M375X",
      "tr_GR303": "AMD* Radeon* R9 M380",
      "tr_GR304": "AMD* Radeon* R9 M385",
      "tr_GR305": "AMD* Radeon* R9 M385X",
      "tr_GR306": "AMD* Radeon* R9 M390X",
      "tr_GR307": "AMD* Radeon* R9 M395X",
      "tr_GR308": "AMD* Radeon* R9 M470X",
      "tr_GR309": "AMD* Radeon* RX 455",
      "tr_GR310": "AMD* Radeon* RX 460",
      "tr_GR311": "AMD* Radeon* RX 470",
      "tr_GR312": "AMD* Radeon* RX 480",
      "tr_GR313": "AMD* Radeon* RX 5300",
      "tr_GR314": "AMD* Radeon* RX 5300M",
      "tr_GR315": "AMD* Radeon* RX 540",
      "tr_GR316": "AMD* Radeon* RX 540X",
      "tr_GR317": "AMD* Radeon* RX 550",
      "tr_GR318": "AMD* Radeon* RX 5500",
      "tr_GR319": "AMD* Radeon* RX 5500 XT",
      "tr_GR320": "AMD* Radeon* RX 5500M",
      "tr_GR321": "AMD* Radeon* RX 550X",
      "tr_GR322": "AMD* Radeon* RX 560",
      "tr_GR323": "AMD* Radeon* RX 560 XT",
      "tr_GR324": "AMD* Radeon* RX 5600",
      "tr_GR325": "AMD* Radeon* RX 5600 OEM",
      "tr_GR326": "AMD* Radeon* RX 5600 XT",
      "tr_GR327": "AMD* Radeon* RX 5600M",
      "tr_GR328": "AMD* Radeon* RX 560X",
      "tr_GR329": "AMD* Radeon* RX 570",
      "tr_GR330": "AMD* Radeon* RX 5700",
      "tr_GR331": "AMD* Radeon* RX 5700 XT",
      "tr_GR332": "AMD* Radeon* RX 5700M",
      "tr_GR333": "AMD* Radeon* RX 570X",
      "tr_GR334": "AMD* Radeon* RX 580",
      "tr_GR335": "AMD* Radeon* RX 580X",
      "tr_GR336": "AMD* Radeon* RX 590",
      "tr_GR337": "AMD* Radeon* RX 590 GME",
      "tr_GR338": "AMD* Radeon* RX 6300",
      "tr_GR339": "AMD* Radeon* RX 6300M",
      "tr_GR340": "AMD* Radeon* RX 640",
      "tr_GR341": "AMD* Radeon* RX 6400",
      "tr_GR342": "AMD* Radeon* RX 6450M",
      "tr_GR343": "AMD* Radeon* RX 6500",
      "tr_GR344": "AMD* Radeon* RX 6500 XT",
      "tr_GR345": "AMD* Radeon* RX 6500M",
      "tr_GR346": "AMD* Radeon* RX 6550M",
      "tr_GR347": "AMD* Radeon* RX 6600",
      "tr_GR348": "AMD* Radeon* RX 6600 LE",
      "tr_GR349": "AMD* Radeon* RX 6600 XT",
      "tr_GR350": "AMD* Radeon* RX 6600M",
      "tr_GR351": "AMD* Radeon* RX 6600S",
      "tr_GR352": "AMD* Radeon* RX 6650 XT",
      "tr_GR353": "AMD* Radeon* RX 6650M",
      "tr_GR354": "AMD* Radeon* RX 6650M XT",
      "tr_GR355": "AMD* Radeon* RX 6700",
      "tr_GR356": "AMD* Radeon* RX 6700 XT",
      "tr_GR357": "AMD* Radeon* RX 6700M",
      "tr_GR358": "AMD* Radeon* RX 6700S",
      "tr_GR359": "AMD* Radeon* RX 6750 GRE",
      "tr_GR360": "AMD* Radeon* RX 6750 XT",
      "tr_GR361": "AMD* Radeon* RX 6800",
      "tr_GR362": "AMD* Radeon* RX 6800 XT",
      "tr_GR363": "AMD* Radeon* RX 6800M",
      "tr_GR364": "AMD* Radeon* RX 6800S",
      "tr_GR365": "AMD* Radeon* RX 6850M XT",
      "tr_GR366": "AMD* Radeon* RX 6900 XT",
      "tr_GR367": "AMD* Radeon* RX 6950 XT",
      "tr_GR368": "AMD* Radeon* RX 7600",
      "tr_GR369": "AMD* Radeon* RX 7600 XT",
      "tr_GR370": "AMD* Radeon* RX 7600M",
      "tr_GR371": "AMD* Radeon* RX 7600M XT",
      "tr_GR372": "AMD* Radeon* RX 7600S",
      "tr_GR373": "AMD* Radeon* RX 7700 XT",
      "tr_GR374": "AMD* Radeon* RX 7700S",
      "tr_GR375": "AMD* Radeon* RX 7800 XT",
      "tr_GR376": "AMD* Radeon* RX 7900 GRE",
      "tr_GR377": "AMD* Radeon* RX 7900 XT",
      "tr_GR378": "AMD* Radeon* RX 7900 XTX",
      "tr_GR379": "AMD* Radeon* RX 7900M",
      "tr_GR380": "AMD* Radeon* RX Vega",
      "tr_GR381": "AMD* Radeon* RX Vega 10",
      "tr_GR382": "AMD* Radeon* RX Vega 11",
      "tr_GR383": "AMD* Radeon* RX Vega 64",
      "tr_GR384": "AMD* Radeon* RX Vega M GH",
      "tr_GR385": "AMD* Radeon* RX Vega M GL",
      "tr_GR386": "Графіка Intel®&nbsp;Arc™ A310",
      "tr_GR387": "Графіка Intel®&nbsp;Arc™ A350M",
      "tr_GR388": "Графіка Intel®&nbsp;Arc™ A370M",
      "tr_GR389": "Графіка Intel®&nbsp;Arc™ A380",
      "tr_GR390": "Графіка Intel®&nbsp;Arc™ A530M",
      "tr_GR391": "Графіка Intel®&nbsp;Arc™ A550M",
      "tr_GR392": "Графіка Intel®&nbsp;Arc™ A570M",
      "tr_GR393": "Графіка Intel®&nbsp;Arc™ A580",
      "tr_GR394": "Графіка Intel®&nbsp;Arc™ A730M",
      "tr_GR395": "Графіка Intel®&nbsp;Arc™ A750",
      "tr_GR396": "Графіка Intel®&nbsp;Arc™ A770",
      "tr_GR397": "Графіка Intel®&nbsp;Arc™ A770M",
      "tr_GR398": "Графіка Intel® Arc™",
      "tr_GR399": "Графіка Intel® Arc™ Pro A30M",
      "tr_GR400": "Графіка Intel® Arc™ Pro A40/A50",
      "tr_GR401": "Графіка Intel® Arc™ Pro A60",
      "tr_GR402": "Графіка Intel® Arc™ Pro A60M",
      "tr_GR403": "Intel® Graphics",
      "tr_GR404": "HD-графіка Intel® 2000",
      "tr_GR405": "HD-графіка Intel® 2500",
      "tr_GR406": "HD-графіка Intel® 3000",
      "tr_GR407": "HD-графіка Intel® 400",
      "tr_GR408": "HD-графіка Intel® 4000",
      "tr_GR409": "HD-графіка Intel® 405",
      "tr_GR410": "HD-графіка Intel® 4200",
      "tr_GR411": "HD-графіка Intel® 4400",
      "tr_GR412": "HD-графіка Intel® 4600",
      "tr_GR413": "HD-графіка Intel® 500",
      "tr_GR414": "HD-графіка Intel® 5000",
      "tr_GR415": "HD-графіка Intel® 505",
      "tr_GR416": "HD-графіка Intel® 510",
      "tr_GR417": "HD-графіка Intel® 515",
      "tr_GR418": "HD-графіка Intel® 520",
      "tr_GR419": "HD-графіка Intel® 530",
      "tr_GR420": "HD-графіка Intel® 5300",
      "tr_GR421": "HD-графіка Intel® 5500",
      "tr_GR422": "HD-графіка Intel® 5600",
      "tr_GR423": "HD-графіка Intel® 6000",
      "tr_GR424": "HD-графіка Intel® 610",
      "tr_GR425": "HD-графіка Intel® 615",
      "tr_GR426": "HD-графіка Intel® 620",
      "tr_GR427": "HD-графіка Intel® 630",
      "tr_GR428": "HD-графіка Intel®",
      "tr_GR429": "Графіка Intel® Iris® 5100",
      "tr_GR430": "Графіка Intel® Iris® 540",
      "tr_GR431": "Графіка Intel® Iris® 550",
      "tr_GR432": "Графіка Intel® Iris® 6100",
      "tr_GR433": "Графіка Intel® Iris® Plus 640",
      "tr_GR434": "Графіка Intel® Iris® Plus 645",
      "tr_GR435": "Графіка Intel® Iris® Plus 650",
      "tr_GR436": "Графіка Intel® Iris® Plus 655",
      "tr_GR437": "Графіка Intel® Iris® Plus",
      "tr_GR438": "Графіка Intel® Iris® Pro 5200",
      "tr_GR439": "Графіка Intel® Iris® Pro 580",
      "tr_GR440": "Графіка Intel® Iris® Pro 6200",
      "tr_GR441": "Графіка Intel® Iris® X<sup>e</sup>",
      "tr_GR442": "Графіка Intel® Iris® X<sup>e</sup> MAX A220M",
      "tr_GR443": "Графіка Intel® Iris® X<sup>e</sup> MAX",
      "tr_GR444": "Інтегрована графіка Intel®",
      "tr_GR445": "UHD-графіка Intel® 600",
      "tr_GR446": "UHD-графіка Intel® 605",
      "tr_GR447": "UHD-графіка Intel® 610",
      "tr_GR448": "UHD-графіка Intel® 615",
      "tr_GR449": "UHD-графіка Intel® 617",
      "tr_GR450": "UHD-графіка Intel® 620",
      "tr_GR451": "UHD-графіка Intel® 630",
      "tr_GR452": "UHD-графіка Intel® 710",
      "tr_GR453": "UHD-графіка Intel® 730",
      "tr_GR454": "UHD-графіка Intel® 770",
      "tr_GR455": "UHD-графіка Intel®",
      "tr_GR456": "UHD-графіка Intel®",
      "tr_GR457": "UHD-графіка Intel®",
      "tr_GR458": "NVIDIA* GeForce* MX110",
      "tr_GR459": "NVIDIA* GeForce* MX130",
      "tr_GR460": "NVIDIA* GeForce* MX150",
      "tr_GR461": "NVIDIA* GeForce* MX230",
      "tr_GR462": "NVIDIA* GeForce* MX250",
      "tr_GR463": "NVIDIA* GeForce* MX330",
      "tr_GR464": "NVIDIA* GeForce* MX350",
      "tr_GR465": "NVIDIA* GeForce* 410M",
      "tr_GR466": "NVIDIA* GeForce* MX450",
      "tr_GR467": "NVIDIA* GeForce* 510",
      "tr_GR468": "NVIDIA* GeForce* MX550",
      "tr_GR469": "NVIDIA* GeForce* MX570",
      "tr_GR470": "NVIDIA* GeForce* MX570 A",
      "tr_GR471": "NVIDIA* GeForce* 605",
      "tr_GR472": "NVIDIA* GeForce* 610",
      "tr_GR473": "NVIDIA* GeForce* 610M",
      "tr_GR474": "NVIDIA* GeForce* 615",
      "tr_GR475": "NVIDIA* GeForce* 620M",
      "tr_GR476": "NVIDIA* GeForce* 705A",
      "tr_GR477": "NVIDIA* GeForce* 705M",
      "tr_GR478": "NVIDIA* GeForce* 710A",
      "tr_GR479": "NVIDIA* GeForce* 710M",
      "tr_GR480": "NVIDIA* GeForce* 720A",
      "tr_GR481": "NVIDIA* GeForce* 720M",
      "tr_GR482": "NVIDIA* GeForce* 730A",
      "tr_GR483": "NVIDIA* GeForce* 800A",
      "tr_GR484": "NVIDIA* GeForce* 800M",
      "tr_GR485": "NVIDIA* GeForce* 805A",
      "tr_GR486": "NVIDIA* GeForce* 810A",
      "tr_GR487": "NVIDIA* GeForce* 810M",
      "tr_GR488": "NVIDIA* GeForce* 820A",
      "tr_GR489": "NVIDIA* GeForce* 820M",
      "tr_GR490": "NVIDIA* GeForce* 825M",
      "tr_GR491": "NVIDIA* GeForce* 830A",
      "tr_GR492": "NVIDIA* GeForce* 830M",
      "tr_GR493": "NVIDIA* GeForce* 840A",
      "tr_GR494": "NVIDIA* GeForce* 840M",
      "tr_GR495": "NVIDIA* GeForce* 845M",
      "tr_GR496": "NVIDIA* GeForce* 910M",
      "tr_GR497": "NVIDIA* GeForce* 920A",
      "tr_GR498": "NVIDIA* GeForce* 920M",
      "tr_GR499": "NVIDIA* GeForce* 920MX",
      "tr_GR500": "NVIDIA* GeForce* 930A",
      "tr_GR501": "NVIDIA* GeForce* 930M",
      "tr_GR502": "NVIDIA* GeForce* 930MX",
      "tr_GR503": "NVIDIA* GeForce* 940A",
      "tr_GR504": "NVIDIA* GeForce* 940M",
      "tr_GR505": "NVIDIA* GeForce* 940MX",
      "tr_GR506": "NVIDIA* GeForce* 945A",
      "tr_GR507": "NVIDIA* GeForce* 945M",
      "tr_GR508": "NVIDIA* GeForce* GT 1010",
      "tr_GR509": "NVIDIA* GeForce* GT 1030",
      "tr_GR510": "NVIDIA* GeForce* GT 415M",
      "tr_GR511": "NVIDIA* GeForce* GT 420",
      "tr_GR512": "NVIDIA* GeForce* GT 420M",
      "tr_GR513": "NVIDIA* GeForce* GT 425M",
      "tr_GR514": "NVIDIA* GeForce* GT 430",
      "tr_GR515": "NVIDIA* GeForce* GT 435M",
      "tr_GR516": "NVIDIA* GeForce* GT 440",
      "tr_GR517": "NVIDIA* GeForce* GT 445M",
      "tr_GR518": "NVIDIA* GeForce* GT 520",
      "tr_GR519": "NVIDIA* GeForce* GT 520M",
      "tr_GR520": "NVIDIA* GeForce* GT 520MX",
      "tr_GR521": "NVIDIA* GeForce* GT 525M",
      "tr_GR522": "NVIDIA* GeForce* GT 530",
      "tr_GR523": "NVIDIA* GeForce* GT 540M",
      "tr_GR524": "NVIDIA* GeForce* GT 545",
      "tr_GR525": "NVIDIA* GeForce* GT 550M",
      "tr_GR526": "NVIDIA* GeForce* GT 555M",
      "tr_GR527": "NVIDIA* GeForce* GT 610",
      "tr_GR528": "NVIDIA* GeForce* GT 620",
      "tr_GR529": "NVIDIA* GeForce* GT 620M",
      "tr_GR530": "NVIDIA* GeForce* GT 625",
      "tr_GR531": "NVIDIA* GeForce* GT 625M",
      "tr_GR532": "NVIDIA* GeForce* GT 630",
      "tr_GR533": "NVIDIA* GeForce* GT 630M",
      "tr_GR534": "NVIDIA* GeForce* GT 635",
      "tr_GR535": "NVIDIA* GeForce* GT 635M",
      "tr_GR536": "NVIDIA* GeForce* GT 640",
      "tr_GR537": "NVIDIA* GeForce* GT 640M",
      "tr_GR538": "NVIDIA* GeForce* GT 640M LE",
      "tr_GR539": "NVIDIA* GeForce* GT 645",
      "tr_GR540": "NVIDIA* GeForce* GT 645M",
      "tr_GR541": "NVIDIA* GeForce* GT 650M",
      "tr_GR542": "NVIDIA* GeForce* GT 705",
      "tr_GR543": "NVIDIA* GeForce* GT 710",
      "tr_GR544": "NVIDIA* GeForce* GT 710M",
      "tr_GR545": "NVIDIA* GeForce* GT 720",
      "tr_GR546": "NVIDIA* GeForce* GT 720A",
      "tr_GR547": "NVIDIA* GeForce* GT 720M",
      "tr_GR548": "NVIDIA* GeForce* GT 730",
      "tr_GR549": "NVIDIA* GeForce* GT 730M",
      "tr_GR550": "NVIDIA* GeForce* GT 735M",
      "tr_GR551": "NVIDIA* GeForce* GT 740",
      "tr_GR552": "NVIDIA* GeForce* GT 740A",
      "tr_GR553": "NVIDIA* GeForce* GT 740M",
      "tr_GR554": "NVIDIA* GeForce* GT 745A",
      "tr_GR555": "NVIDIA* GeForce* GT 745M",
      "tr_GR556": "NVIDIA* GeForce* GT 750M",
      "tr_GR557": "NVIDIA* GeForce* GT 755M",
      "tr_GR558": "NVIDIA* GeForce* GT 820M",
      "tr_GR559": "NVIDIA* GeForce* GTS 450",
      "tr_GR560": "NVIDIA* GeForce* GTX 1050",
      "tr_GR561": "NVIDIA* GeForce* GTX 1050 з дизайном Max-Q",
      "tr_GR562": "NVIDIA* GeForce* GTX 1050 Ti",
      "tr_GR563": "NVIDIA* GeForce* GTX 1050 Ti з дизайном Max-Q",
      "tr_GR564": "NVIDIA* GeForce* GTX 1060",
      "tr_GR565": "NVIDIA* GeForce* GTX 1060 з дизайном Max-Q",
      "tr_GR566": "NVIDIA* GeForce* GTX 1070",
      "tr_GR567": "NVIDIA* GeForce* GTX 1070 з дизайном Max-Q",
      "tr_GR568": "NVIDIA* GeForce* GTX 1070 Ti",
      "tr_GR569": "NVIDIA* GeForce* GTX 1080",
      "tr_GR570": "NVIDIA* GeForce* GTX 1080 з дизайном Max-Q",
      "tr_GR571": "NVIDIA* GeForce* GTX 1080 Ti",
      "tr_GR572": "NVIDIA* GeForce* GTX 1630",
      "tr_GR573": "NVIDIA* GeForce* GTX 1650",
      "tr_GR574": "NVIDIA* GeForce* GTX 1650 з дизайном Max-Q",
      "tr_GR575": "NVIDIA* GeForce* GTX 1650 SUPER",
      "tr_GR576": "NVIDIA* GeForce* GTX 1650 Ti",
      "tr_GR577": "NVIDIA* GeForce* GTX 1650 Ti з дизайном Max-Q",
      "tr_GR578": "NVIDIA* GeForce* GTX 1660",
      "tr_GR579": "NVIDIA* GeForce* GTX 1660 SUPER",
      "tr_GR580": "NVIDIA* GeForce* GTX 1660 Ti",
      "tr_GR581": "NVIDIA* GeForce* GTX 1660 Ti з дизайном Max-Q",
      "tr_GR582": "NVIDIA* GeForce* GTX 460",
      "tr_GR583": "NVIDIA* GeForce* GTX 460 SE",
      "tr_GR584": "NVIDIA* GeForce* GTX 460 v2",
      "tr_GR585": "NVIDIA* GeForce* GTX 460M",
      "tr_GR586": "NVIDIA* GeForce* GTX 465",
      "tr_GR587": "NVIDIA* GeForce* GTX 470",
      "tr_GR588": "NVIDIA* GeForce* GTX 470M",
      "tr_GR589": "NVIDIA* GeForce* GTX 480",
      "tr_GR590": "NVIDIA* GeForce* GTX 480M",
      "tr_GR591": "NVIDIA* GeForce* GTX 485M",
      "tr_GR592": "NVIDIA* GeForce* GTX 550 Ti",
      "tr_GR593": "NVIDIA* GeForce* GTX 555",
      "tr_GR594": "NVIDIA* GeForce* GTX 560",
      "tr_GR595": "NVIDIA* GeForce* GTX 560 SE",
      "tr_GR596": "NVIDIA* GeForce* GTX 560 Ti",
      "tr_GR597": "NVIDIA* GeForce* GTX 560M",
      "tr_GR598": "NVIDIA* GeForce* GTX 570",
      "tr_GR599": "NVIDIA* GeForce* GTX 570M",
      "tr_GR600": "NVIDIA* GeForce* GTX 580",
      "tr_GR601": "NVIDIA* GeForce* GTX 580M",
      "tr_GR602": "NVIDIA* GeForce* GTX 590",
      "tr_GR603": "NVIDIA* GeForce* GTX 645",
      "tr_GR604": "NVIDIA* GeForce* GTX 650",
      "tr_GR605": "NVIDIA* GeForce* GTX 650 Ti",
      "tr_GR606": "NVIDIA* GeForce* GTX 660",
      "tr_GR607": "NVIDIA* GeForce* GTX 660 Ti",
      "tr_GR608": "NVIDIA* GeForce* GTX 660M",
      "tr_GR609": "NVIDIA* GeForce* GTX 670",
      "tr_GR610": "NVIDIA* GeForce* GTX 670M",
      "tr_GR611": "NVIDIA* GeForce* GTX 670MX",
      "tr_GR612": "NVIDIA* GeForce* GTX 675M",
      "tr_GR613": "NVIDIA* GeForce* GTX 675MX",
      "tr_GR614": "NVIDIA* GeForce* GTX 680",
      "tr_GR615": "NVIDIA* GeForce* GTX 680M",
      "tr_GR616": "NVIDIA* GeForce* GTX 680MX",
      "tr_GR617": "NVIDIA* GeForce* GTX 690",
      "tr_GR618": "NVIDIA* GeForce* GTX 745",
      "tr_GR619": "NVIDIA* GeForce* GTX 750",
      "tr_GR620": "NVIDIA* GeForce* GTX 750 Ti",
      "tr_GR621": "NVIDIA* GeForce* GTX 760",
      "tr_GR622": "NVIDIA* GeForce* GTX 760 Ti",
      "tr_GR623": "NVIDIA* GeForce* GTX 760A",
      "tr_GR624": "NVIDIA* GeForce* GTX 760M",
      "tr_GR625": "NVIDIA* GeForce* GTX 765M",
      "tr_GR626": "NVIDIA* GeForce* GTX 770",
      "tr_GR627": "NVIDIA* GeForce* GTX 770M",
      "tr_GR628": "NVIDIA* GeForce* GTX 775M",
      "tr_GR629": "NVIDIA* GeForce* GTX 780",
      "tr_GR630": "NVIDIA* GeForce* GTX 780 Ti",
      "tr_GR631": "NVIDIA* GeForce* GTX 780M",
      "tr_GR632": "NVIDIA* GeForce* GTX 850A",
      "tr_GR633": "NVIDIA* GeForce* GTX 850M",
      "tr_GR634": "NVIDIA* GeForce* GTX 860M",
      "tr_GR635": "NVIDIA* GeForce* GTX 870M",
      "tr_GR636": "NVIDIA* GeForce* GTX 880M",
      "tr_GR637": "NVIDIA* GeForce* GTX 950",
      "tr_GR638": "NVIDIA* GeForce* GTX 950A",
      "tr_GR639": "NVIDIA* GeForce* GTX 950M",
      "tr_GR640": "NVIDIA* GeForce* GTX 960",
      "tr_GR641": "NVIDIA* GeForce* GTX 960A",
      "tr_GR642": "NVIDIA* GeForce* GTX 960M",
      "tr_GR643": "NVIDIA* GeForce* GTX 965M",
      "tr_GR644": "NVIDIA* GeForce* GTX 970",
      "tr_GR645": "NVIDIA* GeForce* GTX 970M",
      "tr_GR646": "NVIDIA* GeForce* GTX 980",
      "tr_GR647": "NVIDIA* GeForce* GTX 980 Ti",
      "tr_GR648": "NVIDIA* GeForce* GTX 980M",
      "tr_GR649": "NVIDIA* GeForce* GTX TITAN",
      "tr_GR650": "NVIDIA* GeForce* GTX TITAN Black",
      "tr_GR651": "NVIDIA* GeForce* GTX TITAN X",
      "tr_GR652": "NVIDIA* GeForce* GTX TITAN Z",
      "tr_GR653": "NVIDIA* GeForce* RTX 2050",
      "tr_GR654": "NVIDIA* GeForce* RTX 2060",
      "tr_GR655": "NVIDIA* GeForce* RTX 2060 з дизайном Max-Q",
      "tr_GR656": "NVIDIA* GeForce* RTX 2060 SUPER",
      "tr_GR657": "NVIDIA* GeForce* RTX 2070",
      "tr_GR658": "NVIDIA* GeForce* RTX 2070 з дизайном Max-Q",
      "tr_GR659": "NVIDIA* GeForce* RTX 2070 SUPER",
      "tr_GR660": "NVIDIA* GeForce* RTX 2070 Super із дизайном Max-Q",
      "tr_GR661": "NVIDIA* GeForce* RTX 2080",
      "tr_GR662": "NVIDIA* GeForce* RTX 2080 з дизайном Max-Q",
      "tr_GR663": "NVIDIA* GeForce* RTX 2080 SUPER",
      "tr_GR664": "NVIDIA* GeForce* RTX 2080 Super із дизайном Max-Q",
      "tr_GR665": "NVIDIA* GeForce* RTX 2080 Ti",
      "tr_GR666": "NVIDIA* GeForce* RTX 3050",
      "tr_GR667": "NVIDIA* GeForce* RTX 3050 Ti",
      "tr_GR668": "NVIDIA* GeForce* RTX 3060",
      "tr_GR669": "NVIDIA* GeForce* RTX 3060 Ti",
      "tr_GR670": "NVIDIA* GeForce* RTX 3070",
      "tr_GR671": "NVIDIA* GeForce* RTX 3070 Ti",
      "tr_GR672": "NVIDIA* GeForce* RTX 3080",
      "tr_GR673": "NVIDIA* GeForce* RTX 3080 Ti",
      "tr_GR674": "NVIDIA* GeForce* RTX 3090",
      "tr_GR675": "NVIDIA* GeForce* RTX 3090 Ti",
      "tr_GR676": "NVIDIA* GeForce* RTX 4050",
      "tr_GR677": "NVIDIA* GeForce* RTX 4060",
      "tr_GR678": "NVIDIA* GeForce* RTX 4060 Ti",
      "tr_GR679": "NVIDIA* GeForce* RTX 4070",
      "tr_GR680": "NVIDIA* GeForce* RTX 4070 SUPER",
      "tr_GR681": "NVIDIA* GeForce* RTX 4070 Ti",
      "tr_GR682": "NVIDIA* GeForce* RTX 4070 Ti SUPER",
      "tr_GR683": "NVIDIA* GeForce* RTX 4080",
      "tr_GR684": "NVIDIA* GeForce* RTX 4090",
      "tr_GR685": "NVIDIA* GeForce* RTX 4090 D",
      "tr_GR686": "NVIDIA* NVS* 310",
      "tr_GR687": "NVIDIA* NVS* 315",
      "tr_GR688": "NVIDIA* NVS* 4200M",
      "tr_GR689": "NVIDIA* NVS* 510",
      "tr_GR690": "NVIDIA* NVS* 5200M",
      "tr_GR691": "NVIDIA* NVS* 5400M",
      "tr_GR692": "NVIDIA* NVS* 810",
      "tr_GR693": "NVIDIA* Quadro* 410",
      "tr_GR694": "NVIDIA* Quadro* GP100",
      "tr_GR695": "NVIDIA* Quadro* GV100",
      "tr_GR696": "NVIDIA* Quadro* K1000M",
      "tr_GR697": "NVIDIA* Quadro* K1100M",
      "tr_GR698": "NVIDIA* Quadro* K1200",
      "tr_GR699": "NVIDIA* Quadro* K2000",
      "tr_GR700": "NVIDIA* Quadro* K2000D",
      "tr_GR701": "NVIDIA* Quadro* K2000M",
      "tr_GR702": "NVIDIA* Quadro* K2100M",
      "tr_GR703": "NVIDIA* Quadro* K2200",
      "tr_GR704": "NVIDIA* Quadro* K2200M",
      "tr_GR705": "NVIDIA* Quadro* K3000M",
      "tr_GR706": "NVIDIA* Quadro* K3100M",
      "tr_GR707": "NVIDIA* Quadro* K4000",
      "tr_GR708": "NVIDIA* Quadro* K4000M",
      "tr_GR709": "NVIDIA* Quadro* K4100M",
      "tr_GR710": "NVIDIA* Quadro* K420",
      "tr_GR711": "NVIDIA* Quadro* K4200",
      "tr_GR712": "NVIDIA* Quadro* K5000",
      "tr_GR713": "NVIDIA* Quadro* K5000M",
      "tr_GR714": "NVIDIA* Quadro* K500M",
      "tr_GR715": "NVIDIA* Quadro* K5100M",
      "tr_GR716": "NVIDIA* Quadro* K510M",
      "tr_GR717": "NVIDIA* Quadro* K5200",
      "tr_GR718": "NVIDIA* Quadro* K600",
      "tr_GR719": "NVIDIA* Quadro* K6000",
      "tr_GR720": "NVIDIA* Quadro* K610M",
      "tr_GR721": "NVIDIA* Quadro* K620",
      "tr_GR722": "NVIDIA* Quadro* K620M",
      "tr_GR723": "NVIDIA* Quadro* M1000M",
      "tr_GR724": "NVIDIA* Quadro* M1200",
      "tr_GR725": "NVIDIA* Quadro* M2000",
      "tr_GR726": "NVIDIA* Quadro* M2000M",
      "tr_GR727": "NVIDIA* Quadro* M2200",
      "tr_GR728": "NVIDIA* Quadro* M3000M",
      "tr_GR729": "NVIDIA* Quadro* M4000",
      "tr_GR730": "NVIDIA* Quadro* M4000M",
      "tr_GR731": "NVIDIA* Quadro* M5000",
      "tr_GR732": "NVIDIA* Quadro* M5000M",
      "tr_GR733": "NVIDIA* Quadro* M500M",
      "tr_GR734": "NVIDIA* Quadro* M520",
      "tr_GR735": "NVIDIA* Quadro* M5500",
      "tr_GR736": "NVIDIA* Quadro* M6000",
      "tr_GR737": "NVIDIA* Quadro* M600M",
      "tr_GR738": "NVIDIA* Quadro* M620",
      "tr_GR739": "NVIDIA* Quadro* P1000",
      "tr_GR740": "NVIDIA* Quadro* P2000",
      "tr_GR741": "NVIDIA* Quadro* P2000 з дизайном Max-Q",
      "tr_GR742": "NVIDIA* Quadro* P2200",
      "tr_GR743": "NVIDIA* Quadro* P3000",
      "tr_GR744": "NVIDIA* Quadro* P3200",
      "tr_GR745": "NVIDIA* Quadro* P3200 з дизайном Max-Q",
      "tr_GR746": "NVIDIA* Quadro* P400",
      "tr_GR747": "NVIDIA* Quadro* P4000",
      "tr_GR748": "NVIDIA* Quadro* P4000 з дизайном Max-Q",
      "tr_GR749": "NVIDIA* Quadro* P4200",
      "tr_GR750": "NVIDIA* Quadro* P4200 з дизайном Max-Q",
      "tr_GR751": "NVIDIA* Quadro* P500",
      "tr_GR752": "NVIDIA* Quadro* P5000",
      "tr_GR753": "NVIDIA* Quadro* P520",
      "tr_GR754": "NVIDIA* Quadro* P5200",
      "tr_GR755": "NVIDIA* Quadro* P5200 з дизайном Max-Q",
      "tr_GR756": "NVIDIA* Quadro* P600",
      "tr_GR757": "NVIDIA* Quadro* P6000",
      "tr_GR758": "NVIDIA* Quadro* P620",
      "tr_GR759": "NVIDIA* Quadro* RTX 3000",
      "tr_GR760": "NVIDIA* Quadro* RTX 3000 з дизайном Max-Q",
      "tr_GR761": "NVIDIA* Quadro* RTX 4000",
      "tr_GR762": "NVIDIA* Quadro* RTX 4000 з дизайном Max-Q",
      "tr_GR763": "NVIDIA* Quadro* RTX 5000",
      "tr_GR764": "NVIDIA* Quadro* RTX 5000 з дизайном Max-Q",
      "tr_GR765": "NVIDIA* Quadro* RTX 6000",
      "tr_GR766": "NVIDIA* Quadro* RTX 8000",
      "tr_GR767": "NVIDIA* Quadro* T1000",
      "tr_GR768": "NVIDIA* Quadro* T1000 з дизайном Max-Q",
      "tr_GR769": "NVIDIA* Quadro* T2000",
      "tr_GR770": "NVIDIA* Quadro* T2000 з дизайном Max-Q",
      "tr_GR771": "NVIDIA* T500",
      "tr_GR772": "NVIDIA* RTX 2000 покоління Ada",
      "tr_GR773": "NVIDIA* RTX 3000 покоління Ada",
      "tr_GR774": "NVIDIA* RTX 3500 покоління Ada",
      "tr_GR775": "NVIDIA* RTX 4000 покоління Ada",
      "tr_GR776": "NVIDIA* RTX 4000 SFF покоління Ada",
      "tr_GR777": "NVIDIA* RTX 4500 покоління Ada",
      "tr_GR778": "NVIDIA* RTX 5000 покоління Ada",
      "tr_GR779": "NVIDIA* RTX 5880 покоління Ada",
      "tr_GR780": "NVIDIA* Tesla* C2050 / C2070",
      "tr_GR781": "NVIDIA* Tesla* C2070",
      "tr_GR782": "NVIDIA* Tesla* C2075",
      "tr_GR783": "NVIDIA* Tesla* K10",
      "tr_GR784": "NVIDIA* Tesla* K20c",
      "tr_GR785": "NVIDIA* Tesla* K20m",
      "tr_GR786": "NVIDIA* Tesla* K20s",
      "tr_GR787": "NVIDIA* Tesla* K20Xm",
      "tr_GR788": "NVIDIA* Tesla* K40c",
      "tr_GR789": "NVIDIA* Tesla* K40m",
      "tr_GR790": "NVIDIA* Tesla* K40s",
      "tr_GR791": "NVIDIA* Tesla* K40st",
      "tr_GR792": "NVIDIA* Tesla* K40t",
      "tr_GR793": "NVIDIA* Tesla* K8",
      "tr_GR794": "NVIDIA* Tesla* K80",
      "tr_GR795": "NVIDIA* Tesla* M2050",
      "tr_GR796": "NVIDIA* Tesla* M2070",
      "tr_GR797": "NVIDIA* Tesla* M2070-Q",
      "tr_GR798": "NVIDIA* Tesla* M2075",
      "tr_GR799": "NVIDIA* Tesla* M2090",
      "tr_GR800": "NVIDIA* Tesla* S2050",
      "tr_GR801": "NVIDIA* Tesla* T20",
      "tr_GR802": "NVIDIA* Tesla* T4",
      "tr_GR803": "NVIDIA* Tesla* X2070",
      "tr_GR804": "NVIDIA* Tesla* X2090",
      "tr_GR805": "NVIDIA* TITAN RTX",
      "tr_GR806": "NVIDIA* TITAN V",
      "tr_GR807": "NVIDIA* TITAN X",
      "tr_GR808": "NVIDIA* TITAN Xp",
      "tr_GR809": "NVIDIA* GeForce* RTX 4080 SUPER",
      "tr_GR810": "NVIDIA* RTX 500 покоління Ada",
      "tr_GR811": "NVIDIA* RTX 1000 покоління Ada",
      "tr_GR812": "Графіка Intel® Arc™",
      "tr_GR813": "NVIDIA* GeForce* RTX 3050 A",
      "tr_GR814": "NVIDIA RTX* 2000E покоління Ada",
      "tr_GR815": "AMD Radeon* Pro W7900 на два слоти",
      "tr_GR816": "AMD Radeon* RX 7800M",
      "tr_GR817": "Графіка Intel® Arc™ B570",
      "tr_GR818": "Графіка Intel® Arc™ B580",
      "tr_GR819": "Графіка Intel® Arc™ A310E",
      "tr_GR820": "Графіка Intel® Arc™ A350E",
      "tr_GR821": "Графіка Intel® Arc™ A370E",
      "tr_GR822": "Графіка Intel® Arc™ A380E",
      "tr_GR823": "Графіка Intel® Arc™ A580E",
      "tr_GR824": "Графіка Intel® Arc™ A750E",
      "tr_GR825": "Графіка Intel® Iris® X<sup>e</sup> MAX 101",
      "tr_GR826": "UHD-графіка Intel® 750",
      "tr_GR827": "NVIDIA* GeForce* RTX 5080",
      "tr_GR828": "NVIDIA* GeForce* RTX 5090",
      "tr_GR829": "NVIDIA* GeForce* RTX 5090 D",
      "tr_GR830": "AMD Radeon* RX 7650 GRE",
      "tr_GR831": "AMD Radeon* RX 9070",
      "tr_GR832": "AMD Radeon* RX 9070 XT",
      "tr_GR833": "NVIDIA* GeForce* RTX 5070",
      "tr_GR834": "NVIDIA* GeForce* RTX 5070 Ti",
      "tr_GR835": "Графіка Intel®&nbsp;Arc™ B390",
      "tr_GR836": "Графіка Intel® Arc™ Pro B65",
      "tr_GR837": "Графіка Intel® Arc™ Pro B70",
      "tr_GR838": "Графіка Intel®&nbsp;Arc™ B370",
      "tr_GR839": "Intel® Graphics",
      "tr_GR840": "AMD* Radeon* Pro W7900D",
      "tr_GR841": "AMD Radeon* RX 9060 XT LP",
      "tr_GR842": "AMD* Radeon* Pro W7500M"
    },
    "tr_ProcessorDescriptionMapping": {
      "tr_Proc1": "Процесор Intel® Core™ Ultra 5 225",
      "tr_Proc2": "Процесор Intel® Core™ Ultra 5 225F",
      "tr_Proc3": "Процесор Intel® Core™ Ultra 5 225H",
      "tr_Proc4": "Процесор Intel® Core™ Ultra 5 225T",
      "tr_Proc5": "Процесор Intel® Core™ Ultra 5 225U",
      "tr_Proc6": "Процесор Intel® Core™ Ultra 5 235",
      "tr_Proc7": "Процесор Intel® Core™ Ultra 5 235H",
      "tr_Proc8": "Процесор Intel® Core™ Ultra 5 235HX",
      "tr_Proc9": "Процесор Intel® Core™ Ultra 5 235T",
      "tr_Proc10": "Процесор Intel® Core™ Ultra 5 235U",
      "tr_Proc11": "Процесор Intel® Core™ Ultra 5 245",
      "tr_Proc12": "Процесор Intel® Core™ Ultra 5 245HX",
      "tr_Proc13": "Процесор Intel® Core™ Ultra 5 245T",
      "tr_Proc14": "Процесор Intel® Core™ Ultra 7 255H",
      "tr_Proc15": "Процесор Intel® Core™ Ultra 7 255HX",
      "tr_Proc16": "Процесор Intel® Core™ Ultra 7 255U",
      "tr_Proc17": "Процесор Intel® Core™ Ultra 7 265",
      "tr_Proc18": "Процесор Intel® Core™ Ultra 7 265F",
      "tr_Proc19": "Процесор Intel® Core™ Ultra 7 265H",
      "tr_Proc20": "Процесор Intel® Core™ Ultra 7 265HX",
      "tr_Proc21": "Процесор Intel® Core™ Ultra 7 265T",
      "tr_Proc22": "Процесор Intel® Core™ Ultra 7 265U",
      "tr_Proc23": "Процесор Intel® Core™ Ultra 9 275HX",
      "tr_Proc24": "Процесор Intel® Core™ Ultra 9 285",
      "tr_Proc25": "Процесор Intel® Core™ Ultra 9 285H",
      "tr_Proc26": "Процесор Intel® Core™ Ultra 9 285HX",
      "tr_Proc27": "Процесор Intel® Core™ Ultra 9 285T",
      "tr_Proc28": "Процесор Intel® Core™ Ultra 5 245K",
      "tr_Proc29": "Процесор Intel® Core™ Ultra 5 245KF",
      "tr_Proc30": "Процесор Intel® Core™ Ultra 7 265K",
      "tr_Proc31": "Процесор Intel® Core™ Ultra 7 265KF",
      "tr_Proc32": "Процесор Intel® Core™ Ultra 9 285K",
      "tr_Proc33": "Процесор Intel® Core™ Ultra 5 226V",
      "tr_Proc34": "Процесор Intel® Core™ Ultra 5 228V",
      "tr_Proc35": "Процесор Intel® Core™ Ultra 5 236V",
      "tr_Proc36": "Процесор Intel® Core™ Ultra 5 238V",
      "tr_Proc37": "Процесор Intel® Core™ Ultra 7 256V",
      "tr_Proc38": "Процесор Intel® Core™ Ultra 7 258V",
      "tr_Proc39": "Процесор Intel® Core™ Ultra 7 266V",
      "tr_Proc40": "Процесор Intel® Core™ Ultra 7 268V",
      "tr_Proc41": "Процесор Intel® Core™ Ultra 9 288V",
      "tr_Proc42": "Процесор Intel® Core™ Ultra 3 105UL",
      "tr_Proc43": "Процесор Intel® Core™ Ultra 5 125HL",
      "tr_Proc44": "Процесор Intel® Core™ Ultra 5 125UL",
      "tr_Proc45": "Процесор Intel® Core™ Ultra 5 135HL",
      "tr_Proc46": "Процесор Intel® Core™ Ultra 5 135UL",
      "tr_Proc47": "Процесор Intel® Core™ Ultra 7 155HL",
      "tr_Proc48": "Процесор Intel® Core™ Ultra 7 155UL",
      "tr_Proc49": "Процесор Intel® Core™ Ultra 7 165HL",
      "tr_Proc50": "Процесор Intel® Core™ Ultra 7 165UL",
      "tr_Proc51": "Процесор Intel® Core™ Ultra 5 125H",
      "tr_Proc52": "Процесор Intel® Core™ Ultra 5 125U",
      "tr_Proc53": "Процесор Intel® Core™ Ultra 5 134U",
      "tr_Proc54": "Процесор Intel® Core™ Ultra 5 135H",
      "tr_Proc55": "Процесор Intel® Core™ Ultra 5 135U",
      "tr_Proc56": "Процесор Intel® Core™ Ultra 7 155H",
      "tr_Proc57": "Процесор Intel® Core™ Ultra 7 155U",
      "tr_Proc58": "Процесор Intel® Core™ Ultra 7 164U",
      "tr_Proc59": "Процесор Intel® Core™ Ultra 7 165H",
      "tr_Proc60": "Процесор Intel® Core™ Ultra 7 165U",
      "tr_Proc61": "Процесор Intel® Core™ Ultra 9 185H",
      "tr_Proc62": "Процесор Intel® Core™ Ultra 5 250K",
      "tr_Proc63": "Процесор Intel® Core™ Ultra 5 250KF",
      "tr_Proc64": "Процесор Intel® Core™ Ultra 7 270K",
      "tr_Proc65": "Процесор Intel® Core™ Ultra 9 290K",
      "tr_Proc66": "Процесор Intel® Core™ Ultra 5 322",
      "tr_Proc67": "Процесор Intel® Core™ Ultra 5 325",
      "tr_Proc68": "Процесор Intel® Core™ Ultra 5 332",
      "tr_Proc69": "Процесор Intel® Core™ Ultra 5 335",
      "tr_Proc70": "Процесор Intel® Core™ Ultra 5 336H",
      "tr_Proc71": "Процесор Intel® Core™ Ultra 5 338H",
      "tr_Proc72": "Процесор Intel® Core™ Ultra 7 355",
      "tr_Proc73": "Процесор Intel® Core™ Ultra 7 356H",
      "tr_Proc74": "Процесор Intel® Core™ Ultra 7 365",
      "tr_Proc75": "Процесор Intel® Core™ Ultra 7 366H",
      "tr_Proc76": "Процесор Intel® Core™ Ultra 9 386H",
      "tr_Proc77": "Процесор Intel® Core™ Ultra X7 358H",
      "tr_Proc78": "Процесор Intel® Core™ Ultra X7 368H",
      "tr_Proc79": "Процесор Intel® Core™ Ultra X9 388H",
      "tr_Proc80": "Процесор Intel® Core™ Ultra 7 270HX",
      "tr_Proc81": "Процесор Intel® Core™ Ultra 9 290HX",
      "tr_Proc82": "Процесор Intel® Core™ 5 213PE",
      "tr_Proc83": "Процесор Intel® Core™ 5 213PTE",
      "tr_Proc84": "Процесор Intel® Core™ 5 223PE",
      "tr_Proc85": "Процесор Intel® Core™ 5 223PQE",
      "tr_Proc86": "Процесор Intel® Core™ 5 223PTE",
      "tr_Proc87": "Процесор Intel® Core™ 7 253PE",
      "tr_Proc88": "Процесор Intel® Core™ 7 253PQE",
      "tr_Proc89": "Процесор Intel® Core™ 7 253PTE",
      "tr_Proc90": "Процесор Intel® Core™ 9 273PE",
      "tr_Proc91": "Процесор Intel® Core™ 9 273PQE",
      "tr_Proc92": "Процесор Intel® Core™ 9 273PTE",
      "tr_Proc93": "Процесор Intel® Core™ Ultra X9 378H",
      "tr_Proc94": "Процесор Intel® Core™ 3 304",
      "tr_Proc95": "Процесор Intel® Core™ 3 305",
      "tr_Proc96": "Процесор Intel® Core™ 5 315",
      "tr_Proc97": "Процесор Intel® Core™ 5 320",
      "tr_Proc98": "Процесор Intel® Core™ 5 330",
      "tr_Proc99": "Процесор Intel® Core™ 7 350",
      "tr_Proc100": "Процесор Intel® Core™ 7 360",
      "tr_Proc101": "Intel® Arc™ G3 processor",
      "tr_Proc102": "Intel® Arc™ G3 Extreme processor"
    },
    "tr_WifiDescMapping": {
      "tr_Wifi1": "Intel® Centrino® Advanced-N 6200 ABG",
      "tr_Wifi2": "Intel® Centrino® Advanced-N 6200 AGN",
      "tr_Wifi3": "Intel® Centrino® Advanced-N 6200 BG",
      "tr_Wifi4": "Intel® Centrino® Advanced-N 6205",
      "tr_Wifi5": "Intel® Centrino® Advanced-N 6230",
      "tr_Wifi6": "Intel® Centrino® Advanced-N 6235",
      "tr_Wifi7": "Intel® Centrino® Advanced-N 6250 ABG",
      "tr_Wifi8": "Intel® Centrino® Advanced-N 6250 AGN",
      "tr_Wifi9": "Intel® Centrino® Ultimate-N 6300 AGN",
      "tr_Wifi10": "Intel® Centrino® Wireless-N 100",
      "tr_Wifi11": "Intel® Centrino® Wireless-N 1000",
      "tr_Wifi12": "Intel® Centrino® Wireless-N 1030",
      "tr_Wifi13": "Intel® Centrino® Wireless-N 105",
      "tr_Wifi14": "Intel® Centrino® Wireless-N 135",
      "tr_Wifi15": "Intel® Centrino® Wireless-N 2200",
      "tr_Wifi16": "Intel® Centrino® Wireless-N 2230",
      "tr_Wifi17": "Intel® Centrino® Wireless-N WiMAX 6150",
      "tr_Wifi18": "Intel® Dual Band Wireless-AC 3160",
      "tr_Wifi19": "Intel® Dual Band Wireless-AC 3165",
      "tr_Wifi20": "Intel® Dual Band Wireless-AC 7260",
      "tr_Wifi21": "Intel® Dual Band Wireless-AC 7265",
      "tr_Wifi22": "Intel® Dual Band Wireless-N 3160",
      "tr_Wifi23": "Intel® Dual Band Wireless-N 7260",
      "tr_Wifi24": "Intel® Dual Band Wireless-N 7265",
      "tr_Wifi25": "Intel® Tri-Band Wireless-AC 17261",
      "tr_Wifi26": "Intel® Wi-Fi 6 AX101",
      "tr_Wifi27": "Intel® Wi-Fi 6 AX200",
      "tr_Wifi28": "Intel® Wi-Fi 6 AX201",
      "tr_Wifi29": "Intel® Wi-Fi 6 AX203",
      "tr_Wifi30": "Intel® Wi-Fi 6E AX210",
      "tr_Wifi31": "Intel® Wi-Fi 6E AX211",
      "tr_Wifi32": "Intel® Wi-Fi 6E AX411",
      "tr_Wifi33": "Intel® Wi-Fi 7 BE200",
      "tr_Wifi34": "Intel® Wi-Fi 7 BE202",
      "tr_Wifi35": "Intel® Wireless-AC 3165",
      "tr_Wifi36": "Intel® Wireless-AC 3168",
      "tr_Wifi37": "Intel® Wireless-AC 8265",
      "tr_Wifi38": "Intel® Wireless-AC 9260",
      "tr_Wifi39": "Intel® Wireless-AC 9461",
      "tr_Wifi40": "Intel® Wireless-AC 9462",
      "tr_Wifi41": "Intel® Wireless-AC 9560",
      "tr_Wifi42": "Intel® Wireless-N 3160",
      "tr_Wifi43": "Intel® Wireless-N 7260",
      "tr_Wifi44": "Intel® Wireless-N 7265",
      "tr_Wifi45": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi46": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi47": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi48": "Intel® Killer™ Wi-Fi 6 AX1650",
      "tr_Wifi49": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi50": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi51": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi52": "Intel® Killer™ Wi-Fi 6E AX1675",
      "tr_Wifi53": "Intel® Killer™ Wi-Fi 6E AX1690",
      "tr_Wifi54": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi55": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi56": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi57": "Intel® Killer™ Wireless-AC 1550",
      "tr_Wifi58": "Intel® Wi-Fi 7 BE201",
      "tr_Wifi59": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi60": "Intel® Killer™ Wi-Fi 7 BE1750",
      "tr_Wifi61": "Intel® Wi-Fi 7 BE211",
      "tr_Wifi62": "Intel® Wi-Fi 7 BE213",
      "tr_Wifi63": "Intel® Killer™ Wi-Fi 7 BE1730",
      "tr_Wifi64": "Intel® Killer™ Wi-Fi 7 BE1735",
      "tr_Wifi65": "Intel® Killer™ Wi-Fi 7 BE1775",
      "tr_Wifi66": "Intel® Killer™ Wi-Fi 7 BE1775"
    },
    "tr_textBuyNow": "Придбати зараз",
    "tr_textTryagain": "Спробувати знову",
    "tr_textBuynowErr": "Через перебої з підключенням параметр «Придбати зараз» недоступний",
    "tr_chatbotPlaceholder_text": "Запитайте мене про пристрій",
    "tr_chatbotPlaceholder_gaming_text": "Запитайте будь-що про пристрій за допомогою штучного інтелекту",
    "tr_deviceSpecs_text": "Характеристики пристрою",
    "tr_laptop": "Ноутбук",
    "tr_desktop": "Настільний ПК",
    "tr_Allinone": "Моноблок",
    "tr_2in1": "2-в-1",
    "tr_deviceType": "ТИП ПРИСТРОЮ",
    "tr_back": "Назад",
    "tr_HomePageNavigation": {
      "tr_overview": "Огляд",
      "tr_specs": "Характеристики",
      "tr_virtualAssistant": "Віртуальний помічник",
      "tr_promos": "Рекламні акції",
      "tr_compareDevices": "Порівняти пристрої"
    },
    "tr_compareText": "Порівняти цей пристрій",
    "tr_pantherLakeCompareText": "Порівняти пристрої",
    "tr_PTLHomePageText": "Відкрийте в собі швидкість і потужність",
    "tr_PTL12XEHomePageText": "Ультратонкий, високопродуктивний",
    "tr_PTLGamingHomePageText": "Відкрийте для себе ідеальний ігровий досвід.",
    "tr_OnboardingText": {
      "tr_welcome": "Ласкаво просимо",
      "tr_start_text": "З чого б ви хотіли почати?",
      "tr_tabs": [
        {
          "tr_tab_heading": "Огляд",
          "tr_tab_subheading": "Дізнайтеся, що може цей пристрій.",
          "link": "overview"
        },
        {
          "tr_tab_heading": "Характеристики",
          "tr_tab_subheading": "Ознайомтеся з функціями та апаратним забезпеченням.",
          "link": "specs"
        },
        {
          "tr_tab_heading": "Сезонні пропозиції та акції",
          "tr_tab_subheading": "Знайдіть найновіші пропозиції.",
          "link": "promos"
        },
        {
          "tr_tab_heading": "Порівняти",
          "tr_tab_subheading": "Порівняйте пристрої один з одним.",
          "link": "compare"
        },
        {
          "tr_tab_heading": "Віртуальний помічник",
          "tr_tab_subheading": "Отримайте відповіді за допомогою ШІ.",
          "link": "va"
        }
      ],
      "ptl_right_arrow_icon": "assets/images/ptl_right_chevron.svg",
      "ptl_12xe_right_arrow_icon": "assets/images/ptl_12xe_right_chevron.svg",
      "ptl_intel_logo": "assets/images/ptl_intel_logo.svg",
      "ptl_12xe_intel_logo": "assets/images/ptl_12xe_intel_logo.svg"
    },
    "tr_VAHomepageText": {
      "tr_VAHeading": "Ласкаво просимо!",
      "tr_VASubHeading": "Поспілкуйтеся з нашим ШІ-асистентом",
      "tr_VAInputboxQuestion": "Запитайте мене про цей пристрій",
      "ptl_VASearchSendIcon": "assets/images/ptl_va_search_send.png",
      "ptl12xe_VASearchSendIcon": "assets/images/ptl12xe_va_search_send.png",
      "ptl_gaming_VASearchSendIcon": "assets/images/ptl_gaming_va_search_send.png",
      "ptl_homePage_icon": "assets/images/ptl_homepage_icon.gif",
      "ptl_12xe_homePage_icon": "assets/images/ptl12xe_homepage_icon.gif",
      "ptl_gaming_homePage_icon": "assets/images/ptl12xe_homepage_icon.gif"
    },
    "tr_average_fps": "cередня частота кадрів на секунду",
    "tr_fps_setting": "Середні налаштування",
    "tr_fps_resolution": "1080p",
    "tr_comparePdfGenaratedText": "Створено: [XX]",
    "tr_noProc": "Відсутній процесор",
    "tr_noOS": "Відсутня операційна система",
    "tr_noGraphics": "Відсутня графіка",
    "tr_noMemory": "Відсутня пам’ять",
    "tr_noStorage": "Відсутній накопичувач",
    "tr_noDisplay": "Відсутній дисплей",
    "tr_noPrice": "Відсутня ціна",
    "tr_ulthreedGames": [
      {
        "game_demo_name": "Apex Legends (higher cap)",
        "tr_game_demo_name": "Apex Legends (вищий&nbsp;ліміт)",
        "targetUrl": "assets/images/3dmark_gamedemo/Apex_Legends.png"
      },
      {
        "game_demo_name": "Assassin’s Creed Shadows",
        "tr_game_demo_name": "Assasin’s Creed* Shadows",
        "targetUrl": "assets/images/3dmark_gamedemo/Assasin_creed_Shadows.png"
      },
      {
        "game_demo_name": "Baldur's Gate 3",
        "tr_game_demo_name": "Baldur’s Gate 3",
        "targetUrl": "assets/images/3dmark_gamedemo/Baldur_Gate.png"
      },
      {
        "game_demo_name": "Call of Duty: Warzone 2.0",
        "tr_game_demo_name": "Call of Duty: Warzone 2.0",
        "targetUrl": "assets/images/3dmark_gamedemo/Call_of_Duty.png"
      },
      {
        "game_demo_name": "Counter-Strike 2",
        "tr_game_demo_name": "Counter-Strike 2",
        "targetUrl": "assets/images/3dmark_gamedemo/Counter_Strike_2.png"
      },
      {
        "game_demo_name": "Cyberpunk 2077",
        "tr_game_demo_name": "Cyberpunk 2077",
        "targetUrl": "assets/images/3dmark_gamedemo/Cyberpunk_2077.png"
      },
      {
        "game_demo_name": "Diablo IV",
        "tr_game_demo_name": "Diablo IV",
        "targetUrl": "assets/images/3dmark_gamedemo/Diablo_IV.png"
      },
      {
        "game_demo_name": "Diablo IV XeSS",
        "tr_game_demo_name": "Diablo IV X<sup>e</sup>SS",
        "targetUrl": "assets/images/3dmark_gamedemo/Diablo_IV.png"
      },
      {
        "game_demo_name": "DOOM Eternal",
        "tr_game_demo_name": "DOOM Eternal",
        "targetUrl": "assets/images/3dmark_gamedemo/DOOM_Eterna.png"
      },
      {
        "game_demo_name": "Dota 2",
        "tr_game_demo_name": "Dota 2",
        "targetUrl": "assets/images/3dmark_gamedemo/Dota2.png"
      },
      {
        "game_demo_name": "Escape from Tarkov",
        "tr_game_demo_name": "Escape from Tarkov",
        "targetUrl": "assets/images/3dmark_gamedemo/Escape_from_Tarkov.png"
      },
      {
        "game_demo_name": "Fortnite",
        "tr_game_demo_name": "Fortnite",
        "targetUrl": "assets/images/3dmark_gamedemo/Fortnite.png"
      },
      {
        "game_demo_name": "League of Legends",
        "tr_game_demo_name": "League of Legends",
        "targetUrl": "assets/images/3dmark_gamedemo/League_of_Legends.png"
      },
      {
        "game_demo_name": "Minecraft",
        "tr_game_demo_name": "Minecraft",
        "targetUrl": "assets/images/3dmark_gamedemo/Minecraft.png"
      },
      {
        "game_demo_name": "Overwatch 2",
        "tr_game_demo_name": "Overwatch 2",
        "targetUrl": "assets/images/3dmark_gamedemo/Overwatch2.png"
      },
      {
        "game_demo_name": "Playerunknown's Battlegrounds",
        "tr_game_demo_name": "PlayerUnknown’s Battlegrounds",
        "targetUrl": "assets/images/3dmark_gamedemo/Playerunknown_Battlegrounds.png"
      },
      {
        "game_demo_name": "Rainbow Six Siege",
        "tr_game_demo_name": "Rainbow Six Siege",
        "targetUrl": "assets/images/3dmark_gamedemo/Rainbow_Six_Siege.png"
      },
      {
        "game_demo_name": "Rocket League",
        "tr_game_demo_name": "Rocket League",
        "targetUrl": "assets/images/3dmark_gamedemo/Rocket_League.png"
      },
      {
        "game_demo_name": "Star Wars: Outlaws",
        "tr_game_demo_name": "Star Wars Outlaws",
        "targetUrl": "assets/images/3dmark_gamedemo/Star_Wars_Outlaws.png"
      },
      {
        "game_demo_name": "Valorant",
        "tr_game_demo_name": "Valorant",
        "targetUrl": "assets/images/3dmark_gamedemo/Valorant.png"
      },
      {
        "game_demo_name": "World of Warcraft: Dragonflight",
        "tr_game_demo_name": "World of Warcraft: Shadowlands",
        "targetUrl": "assets/images/3dmark_gamedemo/World_of_Warcraft_Dragonflight.png"
      }
    ]
  },
  "backgroundMedia": [
    {
      "uiType": "S11",
      "backgroundURL": "url(../assets/images/11th_gen_background.png)"
    },
    {
      "uiType": "G11",
      "backgroundURL": "url(../assets/images/gaming_background.png)"
    },
    {
      "uiType": "evo",
      "backgroundURL": "url(../assets/images/evo_background.png)"
    },
    {
      "uiType": "athena",
      "backgroundURL": "url(../assets/images/mobile-tiles-athena-background.jpg)"
    },
    {
      "uiType": "NI",
      "backgroundURL": "url(../assets/images/ni_background.png)"
    },
    {
      "uiType": "S10",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S8_9",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S7",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "G12",
      "backgroundURL": "url(../assets/images/12th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "default",
      "backgroundURL": "url(../assets/images/mobile-tiles-10-gen-background.jpg)"
    },
    {
      "uiType": "S12",
      "backgroundURL": "url(../assets/images/12th_gen_bg.svg)"
    },
    {
      "uiType": "G13",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "INTEL_INSIDE",
      "backgroundURL": "url(../assets/images/intel_inside/intel_inside_bg.png)"
    },
    {
      "uiType": "G14",
      "backgroundURL": "url(../assets/images/13th_gen_gaming_background.jpg)"
    },
    {
      "uiType": "S14_AI_IPOS",
      "backgroundURL": "url(../assets/images/standard/std_mtl_background.svg)"
    },
    {
      "uiType": "EVO_AI_IPOS",
      "backgroundURL": "url(../assets/images/evo/evo_mtl_background.svg)"
    },
    {
      "uiType": "GAMING_AI_IPOS",
      "backgroundURL": "url(../assets/images/gaming_ai_ipos_background.svg)"
    }
  ],
  "hybridDetails": [
    {
      "badgeTitle": "I3_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I3_HYBRID.svg",
      "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i3 з&nbsp;технологією Intel® Hybrid"
    },
    {
      "badgeTitle": "I5_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I5_HYBRID.svg",
      "tr_gen_core_title": "Процесор Intel®&nbsp;Core™&nbsp;i5 із&nbsp;технологією Intel® Hybrid"
    },
    {
      "badgeTitle": "I7_HYBRID",
      "badgeURL": "assets/images/processor/INTEL_CORE_I7_HYBRID.svg"
    }
  ],
  "tiles": [
    {
      "tilesType": "GAMING",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Месники Marvel",
              "tileUrlName": "avengers",
              "tileBadgeUrl": "assets/images/gaming/avengers-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Грайте в ігри швидше з Intel®",
                "tr_subtitle": "Пориньте у світ Месників Marvel завдяки оптимізації ПК на базі технологій Intel®.",
                "videoUrl": "assets/lang/[XX]/gaming/videos/avengers_[XX].mp4",
                "videoPosterUrl": "assets/images/gaming/avengers-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Відкрийте для себе Intel® Extreme Masters",
              "tileUrlName": "esl",
              "tileBadgeUrl": "assets/images/gaming/esl-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Де змагаються найкращі геймери світу",
                "tr_subtitle": "Найдовша серія турнірів в історії відеоігор Intel® Extreme Masters встановлює стандарти кіберспорту.",
                "videoUrl": "assets/videos/gaming/esl_video.mp4",
                "videoPosterUrl": "assets/images/gaming/esl-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Грайте як профі",
              "tileUrlName": "influencer",
              "tileBadgeUrl": "assets/images/gaming/influencer-tile-new-content.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Чемпіонами стають завдяки Intel.",
                "tr_subtitle": "Після перемоги в чемпіонаті Rainbow Six Siege* North American League 2021 року, Soniqs розказують свою історію геймінгу, про майбутнє кіберспорту й партнерство з Intel.",
                "tr_pretitle": "За участю Soniqs",
                "videoUrl": "assets/videos/gaming/influencer-new-video.mp4",
                "videoPosterUrl": "assets/images/gaming/influencer-new-vdo-thumbnail.svg",
                "subtitleUrl": "assets/subtitles/gaming/intel_soniq_influencer/Intel_Soniq_Influencer_022822.[XX].vtt"
              }
            },
            {
              "tr_tileTitle": "Сумісність із віртуальною реальністю",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "tr_title": "Віртуальна реальність оживає",
                "tr_subtitle": "Пориньте у вражаючий та реалістичний світ віртуальної реальності за допомогою свого комп’ютера. Найновіші процесори Intel® Core™&nbsp;— це ключ до іншого ігрового виміру, де ви можете бути ким завгодно й де завгодно.",
                "videoUrl": "assets/videos/gaming/vr_video.mp4",
                "videoPosterUrl": "assets/images/gaming/vr-thumbnail.png"
              }
            },
            {
              "tr_tileTitle": "Xbox* Game Pass Ultimate",
              "tileUrlName": "xboxcontent",
              "tileBadgeUrl": "assets/images/gaming/xboxTile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "xbox-content-tile-panel",
                "tr_title": "Xbox* Game Pass Ultimate",
                "tr_subtitle": "Грайте в понад 100&nbsp;високоякісних ігор для консолі, як-от Sea of Thieves* і Psychonauts* 2 на ПК з ОС Windows*, мобільному телефоні та планшеті з допомогою Xbox* Game Pass Ultimate та сумісного контролера.",
                "titleArray": [
                  {
                    "tr_title": "Грайте разом на різних пристроях",
                    "tr_subtitle": "Вливайтеся до спільноти мільйонів гравців Xbox*, які готові та прагнуть грати разом. Спілкуйтеся та грайте з іншими завдяки спільній бібліотеці ігор! Гравці можуть бути як на іншому боці світу, так і сидіти поруч з вами."
                  },
                  {
                    "tr_title": "Ігри для пк з ос Windows*",
                    "tr_subtitle": "Грайте в ігри з хмарного каталогу ігор для приставок у програмі Xbox* для ОС Windows*, використовуючи сумісний контролер."
                  },
                  {
                    "tr_title": "Обирайте та грайте",
                    "tr_subtitle": "Грайте в чудові ігри Xbox* там, де раніше не могли. Грайте в понад 100&nbsp;ігор на ПК, мобільному телефоні та планшеті — вдома доки телевізор зайнятий, у кафе або будь-де, де є високошвидкісне підключення до інтернету."
                  },
                  {
                    "tr_title": "Веселощі навіть без контролера",
                    "tr_subtitle": "Ігри с сенсорним управлінням Xbox* відкривають нові способи насолодитися грою завдяки звичній взаємодії та підтриманню рівня гри, до якого ви звикли на звичайній приставці."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD",
      "tilesDeviceTypes": [
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Корисна інформація",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Понад 100 прикладів застосування штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience.mp4"
                  },
                  {
                    "tr_title": "Керуйте більше, торкайтеся менше",
                    "preTitle": "",
                    "detailPageName": "controlmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/controlmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/controlmore.mp4"
                  },
                  {
                    "tr_title": "Залишайтеся в кадрі в будь-якому оточенні",
                    "preTitle": "",
                    "detailPageName": "stayinframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/stayinframe-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/stayinframe.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Створення контенту",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Корегуйте освітлення на професійному рівні",
                    "preTitle": "",
                    "detailPageName": "lighting",
                    "tileBadgeUrl": "assets/images/standard/redesign/lighting-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/lighting.mp4"
                  },
                  {
                    "tr_title": "З легкістю додавайте неймовірні ефекти",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/effects-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/effects.mp4"
                  },
                  {
                    "tr_title": "Створюйте ремікси пісень за допомогою штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "remix",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивність",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Підвищуйте продуктивність і конфіденційність",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "Проводьте більше часу без розетки",
                    "preTitle": "",
                    "detailPageName": "spentmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spentmore-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/spentmore.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Розваги",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Безперебійний перегляд відео навіть у разі відключення від електромережі",
                    "preTitle": "",
                    "detailPageName": "smoothstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smooth-streaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smooth-streaming.mp4"
                  },
                  {
                    "tr_title": "Швидкі, захопливі ігри",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "MTL_STD_REDESIGN_ULTRA_7_9",
          "tilesDetails": [
            {
              "tr_tileTitle": "Корисна інформація",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/standard/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Понад 100 прикладів застосування штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "aiexperience",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_experience-tile7.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_experience7.mp4"
                  },
                  {
                    "tr_title": "Зробіть улюблені пісні по-справжньому вашими",
                    "preTitle": "",
                    "detailPageName": "favouritesongs",
                    "tileBadgeUrl": "assets/images/standard/redesign/remix-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/remix.mp4"
                  },
                  {
                    "tr_title": "Втілюйте своє бачення в реальному часі",
                    "preTitle": "",
                    "detailPageName": "realtime",
                    "tileBadgeUrl": "assets/images/standard/redesign/real-time-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/realtime.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Створення контенту",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/standard/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Найшвидший шлях до вашого ідеального твору мистецтва",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastestway.mp4"
                  },
                  {
                    "tr_title": "Зробіть кожну фотографію ідеальною",
                    "preTitle": "",
                    "detailPageName": "effects",
                    "tileBadgeUrl": "assets/images/standard/redesign/pictureperfect-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/pictureperfect.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивність",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Підвищуйте продуктивність і конфіденційність",
                    "preTitle": "",
                    "detailPageName": "boostyourproductivity",
                    "tileBadgeUrl": "assets/images/standard/redesign/boost-your-productivity-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/boost-your-productivity.mp4"
                  },
                  {
                    "tr_title": "Більше ефективності. Більше свободи.",
                    "preTitle": "",
                    "detailPageName": "morefreedom",
                    "tileBadgeUrl": "assets/images/standard/redesign/morefreedom-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/morefreedom.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Розваги",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Безперебійний перегляд відео у форматі HD навіть у разі відключення від мережі",
                    "preTitle": "",
                    "detailPageName": "smoothHDstreaming",
                    "tileBadgeUrl": "assets/images/standard/redesign/smoothHDstreaming-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/smoothHDstreaming.mp4"
                  },
                  {
                    "tr_title": "Захопливі ігри де б ви не були",
                    "preTitle": "",
                    "detailPageName": "fastimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/fastimmersive-tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/fastimmersive.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Креативніший",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Редагування фотографій — це просто",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "Створюйте фотографії гідні обрамлення за лічені секунди",
                    "preTitle": "",
                    "detailPageName": "createframe",
                    "tileBadgeUrl": "assets/images/standard/redesign/create_frame_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/create_frame.mp4"
                  },
                  {
                    "tr_title": "Ви набираєте. Штучний інтелект виконує",
                    "preTitle": "",
                    "detailPageName": "youtypeit",
                    "tileBadgeUrl": "assets/images/standard/redesign/you_type_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/you_type.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Потужніший",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Чіт-код для плавнішого ігрового процесу",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "Проводьте більше часу без розетки",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "Повне занурення",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивніший",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Ваш повсякденний помічник на базі штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "Досконалі відеодзвінки",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Надійніший",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Вбудовані засоби захисту, які допоможуть забезпечити безпеку й конфіденційність ваших даних",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "LNL_STD_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "Креативніший",
              "tileUrlName": "creative",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Редагування фотографій — це просто",
                    "preTitle": "",
                    "detailPageName": "photoediting",
                    "tileBadgeUrl": "assets/images/standard/redesign/photo_editing_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/photo_editing.mp4"
                  },
                  {
                    "tr_title": "Штучний інтелект — короткий шлях до фінального монтажу",
                    "preTitle": "",
                    "detailPageName": "aishortcut",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_shortcut_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_shortcut.mp4"
                  },
                  {
                    "tr_title": "Швидко розшифровуйте тексти улюблених пісень",
                    "preTitle": "",
                    "detailPageName": "favouritesong",
                    "tileBadgeUrl": "assets/images/standard/redesign/favourite_song_tile.svg",
                    "tileVideoUrl": "assets/lang/[XX]/redesign/favourite_song.mp4"
                  },
                  {
                    "tr_title": "Витрачайте менше часу на редагування завдяки штучному інтелекту",
                    "preTitle": "",
                    "detailPageName": "savehours",
                    "tileBadgeUrl": "assets/images/standard/redesign/save_hours_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/save_hours.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Потужніший",
              "tileUrlName": "performance",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Чіт-код для плавнішого ігрового процесу",
                    "preTitle": "",
                    "detailPageName": "cheatcode",
                    "tileBadgeUrl": "assets/images/standard/redesign/cheat_code_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/cheat_code.mp4"
                  },
                  {
                    "tr_title": "Проводьте більше часу без розетки",
                    "preTitle": "",
                    "detailPageName": "spendmore",
                    "tileBadgeUrl": "assets/images/standard/redesign/spend_more_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/spend_more.svg"
                  },
                  {
                    "tr_title": "Повне занурення",
                    "preTitle": "",
                    "detailPageName": "ultraimmersive",
                    "tileBadgeUrl": "assets/images/standard/redesign/ultra_immersive_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/ultra_immersive.svg"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивніший",
              "tileUrlName": "productive",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Ваш повсякденний помічник на базі штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "aicompanion",
                    "tileBadgeUrl": "assets/images/standard/redesign/ai_companion_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/ai_companion.mp4"
                  },
                  {
                    "tr_title": "Досконалі відеодзвінки",
                    "preTitle": "",
                    "detailPageName": "videocall",
                    "tileBadgeUrl": "assets/images/standard/redesign/video_call_tile.svg",
                    "tileVideoUrl": "assets/videos/standard/redesign/video_call.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Надійніший",
              "tileUrlName": "secure",
              "tileBadgeUrl": "",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Вбудовані засоби захисту, які допоможуть забезпечити безпеку й конфіденційність ваших даних",
                    "preTitle": "",
                    "detailPageName": "builtinprotection",
                    "tileBadgeUrl": "assets/images/standard/redesign/protection_tile.svg",
                    "tileVideoUrl": "assets/images/standard/redesign/protection.svg"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Будь-які розваги. Один ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Для ПК, який виступає як центр розваг, вам знадобиться достатній обсяг накопичувача для всіх улюблених пісень, відео й ігор, а також правильне поєднання процесора та екрана, щоб створювати захопливі візуальні зображення. У цьому ПК є всі три компоненти.",
                "titleArray": [
                  {
                    "tr_title": "Готовність до графіки наступного покоління",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Ігри й перегляд потокового відео без жодних перешкод",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Підвищуйте свою продуктивність. Будь&#8209;де.",
              "tr_tileTitle1": "Досягайте більшого. Швидко.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонкого й легкого пристрою. До того ж, цей ПК оснащено модулем Wi&#8209;Fi, який забезпечуватиме постійний зв’язок, і відповідним акумулятором для роботи у автономному режимі.",
                "tr_subtitle1": "У цьому ПК ідеально збалансовані потужність і продуктивність, тому ви можете досягати більшого ще швидше. Завдяки поєднанню потужного процесора з достатнім обсягом пам’яті і швидкого Wi-Fi з'єднання ви виконуватимете повсякденні завдання ще ефективніше.",
                "tr_subtitle2": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонких і легких ПК. Крім того, цей ПК оснащено модулем Wi‑Fi, який забезпечуватиме надійний зв’язок, і належним обсягом пам’яті для роботи у режимі багатозадачності.",
                "titleArray": [
                  {
                    "tr_title": "Створено, щоб могти більше",
                    "tr_title1": "Вагома інтелектуальна продуктивність",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Чудові можливості з’єднання",
                    "tr_title1": "Завжди на зв’язку, коли це потрібно",
                    "tr_title2": "Значний прорив у технології Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Працюйте в автономному режимі ще довше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Працюйте з програмами на професійному рівні",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Свобода творчості",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Створення контенту — одне з найвимогливіших завдань для вашого ПК. На щастя, ці компоненти допоможуть спростити творчий процес.",
                "titleArray": [
                  {
                    "tr_title": "Розумніший спосіб творити",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Вдихніть життя у свої зображення",
                    "tr_title1": "Творімо",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Пам’ять для багатозадачності",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Загляньте всередину цього ПК",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Це три основні компоненти, на які слід звернути увагу під час вибору нового ПК. Вирішуючи, як ви будете використовувати свій новий ПК, ви краще зрозумієте свої вимоги до цих трьох основних компонентів. Це:",
                "titleArray": [
                  {
                    "tr_title": "Продуктивність для ігор і трансляцій",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Накопичувачі",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Пам’ять",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "UWP",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/standard/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Будь-які розваги. Один ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Для ПК, який виступає як центр розваг, вам знадобиться достатній обсяг накопичувача для всіх улюблених пісень, відео й ігор, а також правильне поєднання процесора та екрана, щоб створювати захопливі візуальні зображення. У цьому ПК є всі три компоненти.",
                "titleArray": [
                  {
                    "tr_title": "Готовність до графіки наступного покоління",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Ігри й перегляд потокового відео без жодних перешкод",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Пам’ять",
              "tileUrlName": "memory",
              "tileBadgeUrl": "assets/images/standard/memory-tile.svg"
            },
            {
              "tr_tileTitle": "Екран",
              "tileUrlName": "display",
              "tileBadgeUrl": "assets/images/standard/display-tile.svg"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Високошвидкісна багатозадачність",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИСОКОШВИДКІСНА БАГАТОЗАДАЧНІСТЬ",
                "tr_subtitle": "Робіть більше, не&nbsp;сповільнюючись",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для роботи в режимі багатозадачності:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може опрацьовувати декілька програм одночасно."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє перемикатися між програмами без перешкод."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Відеочат",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВІДЕОЧАТ",
                "tr_subtitle": "Безперебійне підключення",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для відеочатів:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може одночасно записувати та обмінюватися зображеннями."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Вебкамера, яка допомагає бачити кришталево чисті зображення."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Сумісність із віртуальною реальністю",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Віртуальна реальність оживає",
                "tr_subtitle": "Що потрібно для створення повністю віртуального світу? На ПК вам знадобиться узгоджена робота процесора, відеокарти й пам’яті.",
                "titleArray": [
                  {
                    "tr_title": "Потужність для віртуальних світів",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальність полягає в деталях",
                    "tr_title1": "Повне занурення",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Редагування відео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАГУВАННЯ ВІДЕО",
                "tr_subtitle": "Творіть магію кіно",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для редагування відео:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може обробляти великі файли."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє швидко й без перешкод редагувати файли мультимедіа."
                  },
                  {
                    "tr_title": "Графіка, яка скорочує час обробки відео."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Високошвидкісна багатозадачність",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИСОКОШВИДКІСНА БАГАТОЗАДАЧНІСТЬ",
                "tr_subtitle": "Робіть більше, не&nbsp;сповільнюючись",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для роботи в режимі багатозадачності:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може опрацьовувати декілька програм одночасно."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє перемикатися між програмами без перешкод."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Сумісність із віртуальною реальністю",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Віртуальна реальність оживає",
                "tr_subtitle": "Що потрібно для створення повністю віртуального світу? На ПК вам знадобиться узгоджена робота процесора, відеокарти й пам’яті.",
                "titleArray": [
                  {
                    "tr_title": "Потужність для віртуальних світів",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальність полягає в деталях",
                    "tr_title1": "Повне занурення",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "Laptop",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "3D-моделювання",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "3D-МОДЕЛЮВАННЯ",
                "tr_subtitle": "Творчість на новому рівні",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для 3D-моделювання:",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може працювати з передовим програмним забезпеченням для творчості."
                  },
                  {
                    "tr_title": "Пам’ять, яка дає змогу швидко обробляти великі файли."
                  },
                  {
                    "tr_title": "Потужна графіка, яка дозволяє створювати та редагувати зображення."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Спільна робота в режимі реального часу",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СПІЛЬНА РОБОТА В РЕЖИМІ РЕАЛЬНОГО ЧАСУ",
                "tr_subtitle": "Працюйте з будь-якого місця",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для співпраці в Інтернеті:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процесор, що підтримує офісне програмне забезпечення."
                  },
                  {
                    "tr_title": "Wi‑Fi, на який можна покластися."
                  },
                  {
                    "tr_title": "Вебкамера, яка записує відео з високою роздільною здатністю."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Сумісність із віртуальною реальністю",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/gaming/vr-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Віртуальна реальність оживає",
                "tr_subtitle": "Що потрібно для створення повністю віртуального світу? На ПК вам знадобиться узгоджена робота процесора, відеокарти й пам’яті.",
                "titleArray": [
                  {
                    "tr_title": "Потужність для віртуальних світів",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальність полягає в деталях",
                    "tr_title1": "Повне занурення",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "EVO",
      "tilesDeviceTypes": [
        {
          "deviceType": "11GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Такі тонкі й легкі ноутбуки не мусили бути настільки потужними",
                "tr_subtitle": "Створені для мобільної продуктивності, ноутбуки Intel® Evo™ мають всю необхідну вам швидкість, графіку й ресурс акумулятора — усе це в неймовірно тонкому й легкому корпусі.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Швидке виконання завдань",
                    "tr_subtitle": "Процесори Intel® Core™ 11&#8209;го&nbsp;покоління забезпечують високоадаптивну продуктивність."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до&nbsp;мережі&nbsp;Intel®&nbsp;Wi‑Fi&nbsp;6&nbsp;(Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Усе, що вам потрібно в тонкому та легкому ноутбуці.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ створено для мобільної продуктивності й оптимальних вражень<sup>2</sup>, незалежно від ваших завдань.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Революційна продуктивність",
                    "tr_subtitle": "Отримайте додаткову потужність там, де вона потрібна найбільше, завдяки інтелектуальній продуктивності процесорів Intel® Core™ 12-го покоління."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до мережі завдяки технології Intel® Wi‑Fi 6E (Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "11GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Такі тонкі й легкі ноутбуки не мусили бути настільки потужними",
                "tr_subtitle": "Створені для мобільної продуктивності, ноутбуки Intel® Evo™ мають всю необхідну вам швидкість, графіку й ресурс акумулятора — усе це в неймовірно тонкому й легкому корпусі.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Швидке виконання завдань",
                    "tr_subtitle": "Процесори Intel® Core™ 11&#8209;го&nbsp;покоління забезпечують високоадаптивну продуктивність."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до&nbsp;мережі&nbsp;Intel®&nbsp;Wi‑Fi&nbsp;6&nbsp;(Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "12GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Усе, що вам потрібно в тонкому та легкому ноутбуці.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ створено для мобільної продуктивності й оптимальних вражень<sup>2</sup>, незалежно від ваших завдань.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Революційна продуктивність",
                    "tr_subtitle": "Отримайте додаткову потужність там, де вона потрібна найбільше, завдяки інтелектуальній продуктивності процесорів Intel® Core™ 12-го покоління."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до мережі завдяки технології Intel® Wi‑Fi 6E (Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO",
          "tilesDetails": [
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Усе, що вам потрібно в тонкому та легкому ноутбуці.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ створено для мобільної продуктивності й оптимальних вражень<sup>2</sup>, незалежно від ваших завдань.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Революційна продуктивність",
                    "tr_subtitle": "Отримайте додаткову потужність там, де вона потрібна найбільше, завдяки інтелектуальній продуктивності процесорів Intel® Core™ 13-го покоління."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до мережі завдяки технології Intel® Wi‑Fi 6E (Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "13GEN_EVO_UWP",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Ноутбуки Intel® Evo™",
              "tileUrlName": "evocontent",
              "tileBadgeUrl": "assets/images/evo/evocontent-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "evo-content-tile-panel",
                "tr_title": "Усе, що вам потрібно в тонкому та легкому ноутбуці.",
                "tr_subtitle": "Ноутбуки Intel® Evo™ створено для мобільної продуктивності й оптимальних вражень<sup>2</sup>, незалежно від ваших завдань.",
                "titleArray": [
                  {
                    "tr_title": "Сьогодні ваш ноутбук важливіший, ніж будь-коли, тож ми зробили його набагато продуктивнішим, ніж раніше.",
                    "tr_subtitle": "Використовуйте сенсорний екран для перегляду, повертання та масштабування."
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Миттєвий вихід з режиму сну",
                    "tr_subtitle": "ПК перемикається з режиму сну в режим роботи за долі секунди."
                  },
                  {
                    "tr_title": "Перегляд з ефектом занурення",
                    "tr_subtitle": "Відображення реалістичних зображень з найчіткішою&nbsp;деталізацією та яскравими кольорами на дисплеї."
                  },
                  {
                    "tr_title": "Революційна продуктивність",
                    "tr_subtitle": "Отримайте додаткову потужність там, де вона потрібна найбільше, завдяки інтелектуальній продуктивності процесорів Intel® Core™ 13-го покоління."
                  },
                  {
                    "tr_title": "Довший час автономної роботи",
                    "tr_subtitle": "Завдяки оптимізації ресурсу акумулятора й швидкому заряджанню ПК ви можете не переривати роботу."
                  },
                  {
                    "tr_title": "Універсальний кабель",
                    "tr_subtitle": "Технологія Thunderbolt™ 4 забезпечує ще швидше й стабільніше підключення до ПК інших пристроїв<sup>10</sup>."
                  },
                  {
                    "tr_title": "Швидке й стабільне підключення",
                    "tr_subtitle": "Стабільне підключення до мережі завдяки технології Intel® Wi‑Fi 6E (Gig+) дає змогу проводити відеоконференції та обмінюватися файлами<sup>1</sup>."
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_5",
          "tilesDetails": [
            {
              "tr_tileTitle": "Корисна інформація",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Що таке версія Intel® Evo™?",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "Чому саме версія&nbsp;Intel®&nbsp;Evo™?",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Створення контенту",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Будьте креативнішими де б ви не були",
                    "preTitle": "",
                    "detailPageName": "morecreative",
                    "tileBadgeUrl": "assets/images/evo/redesign/morecreative-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/morecreative.mp4"
                  },
                  {
                    "tr_title": "Повношвидкісне редагування фотографій",
                    "preTitle": "",
                    "detailPageName": "photoeditng",
                    "tileBadgeUrl": "assets/images/evo/redesign/photoeditng-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/photoeditng.mp4"
                  },
                  {
                    "tr_title": "Творіть мистецтво без жодних вагань",
                    "preTitle": "",
                    "detailPageName": "originalArt",
                    "tileBadgeUrl": "assets/images/evo/redesign/originalArt-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/originalArt.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивність",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Максимальна продуктивність завдяки функції Rewind на основі штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "Штучний інтелект виявляє дипфейки, перш ніж ви поділитеся контентом",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Мобільність",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Зробіть вітальний жест для керування жестами",
                    "preTitle": "gesturecontrol",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/gesturecontrol-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/gesturecontrol.mp4"
                  },
                  {
                    "tr_title": "Ресурс акумулятора, який вас не обмежує",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "Автоматично підтримує з'єднання з мережею",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        },
        {
          "deviceType": "EVO_REDESIGN_ULTRA_7",
          "tilesDetails": [
            {
              "tr_tileTitle": "Корисна інформація",
              "tileUrlName": "spotlight",
              "tileBadgeUrl": "assets/images/evo/redesign/spotlight.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Що таке версія Intel® Evo™?",
                    "preTitle": "",
                    "detailPageName": "whatIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whatIntelEvo-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whatIntelEvo.mp4"
                  },
                  {
                    "tr_title": "Чому саме версія&nbsp;Intel®&nbsp;Evo™?",
                    "preTitle": "",
                    "detailPageName": "whyIntelEvo",
                    "tileBadgeUrl": "assets/images/evo/redesign/whyIntelEvo7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/whyIntelEvo7.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Створення контенту",
              "tileUrlName": "creativity",
              "tileBadgeUrl": "assets/images/evo/redesign/creativity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Швидке та плавне відтворення відео",
                    "preTitle": "",
                    "detailPageName": "videoplayback",
                    "tileBadgeUrl": "assets/images/evo/redesign/videoplayback-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/videoplayback.mp4"
                  },
                  {
                    "tr_title": "Створюйте хіти, використовуючи штучний інтелект",
                    "preTitle": "",
                    "detailPageName": "powerAI",
                    "tileBadgeUrl": "assets/images/evo/redesign/power-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/power-ai.mp4"
                  },
                  {
                    "tr_title": "Найшвидший шлях до вашого ідеального твору мистецтва",
                    "preTitle": "",
                    "detailPageName": "fastestway",
                    "tileBadgeUrl": "assets/images/evo/redesign/fastestway-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/fastestway.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Продуктивність",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/evo/redesign/productivity.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Максимальна продуктивність завдяки функції Rewind на основі штучного інтелекту",
                    "preTitle": "",
                    "detailPageName": "rewind-ai",
                    "tileBadgeUrl": "assets/images/evo/redesign/rewind-ai-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/rewind-ai.mp4"
                  },
                  {
                    "tr_title": "Штучний інтелект виявляє дипфейки, перш ніж ви поділитеся контентом",
                    "preTitle": "",
                    "detailPageName": "deepfakes",
                    "tileBadgeUrl": "assets/images/evo/redesign/deepfakes-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/deepfakes.mp4"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Мобільність",
              "tileUrlName": "mobility",
              "tileBadgeUrl": "assets/images/evo/redesign/entertainment.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "",
                "titleArray": [
                  {
                    "tr_title": "Співпрацюйте, перебуваючи практично будь-де",
                    "preTitle": "",
                    "detailPageName": "virtuallyanywhere",
                    "tileBadgeUrl": "assets/images/evo/redesign/virtuallyanywhere7-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/virtuallyanywhere7.mp4"
                  },
                  {
                    "tr_title": "Ресурс акумулятора, який вас не обмежує",
                    "preTitle": "",
                    "detailPageName": "batteryLife-entertainment",
                    "tileBadgeUrl": "assets/images/evo/redesign/batteryLife-entertainment-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/batteryLife-entertainment.mp4"
                  },
                  {
                    "tr_title": "Автоматично підтримує з'єднання з мережею",
                    "preTitle": "",
                    "detailPageName": "automaticallyConnected",
                    "tileBadgeUrl": "assets/images/evo/redesign/automaticallyConnected-tile.svg",
                    "tileVideoUrl": "assets/videos/evo/redesign/automaticallyConnected.mp4"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_11",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Будь-які розваги. Один ПК.",
              "tileUrlName": "entertainment",
              "tileBadgeUrl": "assets/images/standard/entertainment-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Для ПК, який виступає як центр розваг, вам знадобиться достатній обсяг накопичувача для всіх улюблених пісень, відео й ігор, а також правильне поєднання процесора та екрана, щоб створювати захопливі візуальні зображення. У цьому ПК є всі три компоненти.",
                "titleArray": [
                  {
                    "tr_title": "Вражаючі ігри й трансляція",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ],
                "titleArray1": [
                  {
                    "tr_title": "Ігри й перегляд потокового відео без жодних перешкод",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Створіть власну цифрову бібліотеку",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Вікно у ваш світ розваг",
                    "preTitle": "[display_value]",
                    "detailPageName": "display"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Підвищуйте свою продуктивність. Будь&#8209;де.",
              "tr_tileTitle1": "Досягайте більшого. Швидко.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонкого й легкого пристрою. До того ж, цей ПК оснащено модулем Wi&#8209;Fi, який забезпечуватиме постійний зв’язок, і відповідним акумулятором для роботи у автономному режимі.",
                "tr_subtitle1": "У цьому ПК ідеально збалансовані потужність і продуктивність, тому ви можете досягати більшого ще швидше. Завдяки поєднанню потужного процесора з достатнім обсягом пам’яті і швидкого Wi-Fi з'єднання ви виконуватимете повсякденні завдання ще ефективніше.",
                "tr_subtitle2": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонких і легких ПК. Крім того, цей ПК оснащено модулем Wi‑Fi, який забезпечуватиме надійний зв’язок, і належним обсягом пам’яті для роботи у режимі багатозадачності.",
                "titleArray": [
                  {
                    "tr_title": "Вагома інтелектуальна продуктивність",
                    "tr_title1": "Швидкодія та інтелектуальна продуктивність",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Чудові можливості з’єднання",
                    "tr_title1": "Завжди на зв’язку, коли це потрібно",
                    "tr_title2": "Значний прорив у технології Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Працюйте в автономному режимі ще довше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Працюйте з програмами на професійному рівні",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Свобода творчості",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/standard/content-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Створення контенту — одне з найвимогливіших завдань для вашого ПК. На щастя, ці компоненти допоможуть спростити творчий процес.",
                "titleArray": [
                  {
                    "tr_title": "Прискорений творчий процес",
                    "tr_title1": "Швидке втілення творчих проєктів",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Новий рівень створення контенту",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Пам’ять для багатозадачності",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Загляньте всередину цього ПК",
              "tileUrlName": "lookinside",
              "tileBadgeUrl": "assets/images/standard/lookinside-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Це три основні компоненти, на які слід звернути увагу під час вибору нового ПК. Вирішуючи, як ви будете використовувати свій новий ПК, ви краще зрозумієте свої вимоги до цих трьох основних компонентів. Це:",
                "titleArray": [
                  {
                    "tr_title": "Процесор",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Накопичувачі",
                    "preTitle": "[storage_value]",
                    "detailPageName": "storage"
                  },
                  {
                    "tr_title": "Пам’ять",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "CREATOR_12",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/creator/[processor_badge].svg"
            },
            {
              "tr_tileTitle": "Свобода творчості",
              "tileUrlName": "content",
              "tileBadgeUrl": "assets/images/creator/freedom_new.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "Створення контенту — одне з найвимогливіших завдань для вашого ПК. На щастя, ці компоненти допоможуть спростити творчий процес.",
                "titleArray": [
                  {
                    "tr_title": "Розумніший спосіб творити",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Вдихніть життя у свої зображення",
                    "tr_title1": "Творімо",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  },
                  {
                    "tr_title": "Пам’ять для багатозадачності",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Підвищуйте свою продуктивність. Будь&#8209;де.",
              "tr_tileTitle1": "Досягайте більшого. Швидко.",
              "tileUrlName": "productivity",
              "tileBadgeUrl": "assets/images/standard/productivity-tile.svg",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "",
                "tr_subtitle": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонкого й легкого пристрою. До того ж, цей ПК оснащено модулем Wi&#8209;Fi, який забезпечуватиме постійний зв’язок, і відповідним акумулятором для роботи у автономному режимі.",
                "tr_subtitle1": "У цьому ПК ідеально збалансовані потужність і продуктивність, тому ви можете досягати більшого ще швидше. Завдяки поєднанню потужного процесора з достатнім обсягом пам’яті і швидкого Wi-Fi з'єднання ви виконуватимете повсякденні завдання ще ефективніше.",
                "tr_subtitle2": "У цьому ПК бездоганно поєднано потужність і портативність. Процесор створено спеціально для тонких і легких ПК. Крім того, цей ПК оснащено модулем Wi‑Fi, який забезпечуватиме надійний зв’язок, і належним обсягом пам’яті для роботи у режимі багатозадачності.",
                "titleArray": [
                  {
                    "tr_title": "Створено, щоб могти більше",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Чудові можливості з’єднання",
                    "tr_title1": "Завжди на зв’язку, коли це потрібно",
                    "tr_title2": "Значний прорив у технології Wi‑Fi",
                    "preTitle": "[wifi_value]",
                    "detailPageName": "wifi"
                  },
                  {
                    "tr_title": "Працюйте в автономному режимі ще довше",
                    "preTitle": "[battery_value]",
                    "detailPageName": "battery"
                  },
                  {
                    "tr_title": "Працюйте з програмами на професійному рівні",
                    "preTitle": "[memory_value]",
                    "detailPageName": "memory"
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Сумісність із віртуальною реальністю",
              "tileUrlName": "vr",
              "tileBadgeUrl": "assets/images/creator/new_vr_gen12_creator.png",
              "tileDetails": {
                "panelType1": "gaming-tile-panel",
                "panelType2": "gaming-tile-panel2",
                "tr_title": "Віртуальна реальність оживає",
                "tr_subtitle": "Що потрібно для створення повністю віртуального світу? На ПК вам знадобиться узгоджена робота процесора, відеокарти й пам’яті.",
                "titleArray": [
                  {
                    "tr_title": "Потужність для віртуальних світів",
                    "preTitle": "[processor_value]",
                    "detailPageName": "processor"
                  },
                  {
                    "tr_title": "Реальність полягає в деталях",
                    "tr_title1": "Повне занурення",
                    "preTitle": "[graphics_value]",
                    "detailPageName": "graphics"
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Дізнайтеся потужність Intel&nbsp;Inside®",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/ptl_processor_tile.png"
            },
            {
              "tr_pretitle": "<span class='ptl-aidemos-tile-pretitle'>Демо</span> ШІ",
              "tr_tileTitle": "Перевірте силу штучного інтелекту в дії",
              "tileUrlName": "aidemos",
              "tileBadgeUrl": "assets/images/ptl_ai_demos_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "",
                "tr_subtitle": "",
                "detailBGUrl": ""
              }
            },
            {
              "tr_pretitle": "Демонстрація <span class='ptl-aishowcase-tile-pretitle'>ШІ</span>",
              "tr_tileTitle": "Дізнайтеся про можливості та застосунки на базі ШІ",
              "tileUrlName": "aishowcase",
              "tileBadgeUrl": "assets/images/ptl_ai_showcase_tile.png"
            },
            {
              "tr_pretitle": "Виміряйте <span class='ptl-ulthreedmark-tile-pretitle'>частоту кадрів</span>",
              "tr_tileTitle": "Перевірте, яку частоту кадрів виконують ваші ігри.",
              "tileUrlName": "ulthreedmark",
              "tileBadgeUrl": "assets/images/ptl_fps_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_title": "",
                "tr_subtitle": ""
              }
            },
            {
              "tr_tileTitle": "Безкоштовно — PCmover* Express — найпростіший спосіб перейти на новий ПК!",
              "tileUrlName": "pcmover",
              "tileBadgeUrl": "assets/images/ptl_pc_mover_tile.png"
            },
            {
              "tr_tileTitle": "Пакет програмного забезпечення для творчості для ПК із підтримкою ШІ",
              "tileUrlName": "ai-pc-bundle",
              "tileBadgeUrl": "assets/images/ptl-ai-pc-bundle_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE_12XE",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Дізнайтеся потужність Intel&nbsp;Inside®",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/ptl_XE_processor_tile.png"
            },
            {
              "tr_tileTitle": "Отримайте доступ<br/>до Battlefield* 6, Everwind* та пропозиції від Adobe*",
              "tileUrlName": "ptl-softwarebundle",
              "tileBadgeUrl": "assets/images/ptl_XE_software_bundle_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "ptl-tile1-panel",
                "tr_title": "Творіть удень,<br/>грайте вночі",
                "tr_title1": "<span class='processor_bold'>Процесор Intel® Core™ Ultra [XX] </span>із вбудованою <span class='processor_bold'>графікою Intel® Arc™</span>",
                "tr_subtitle": "Отримайте доступ до Battlefield* 6, Everwind* та пропозиції від Adobe*, придбавши відповідні пристрої на базі процесора Intel® Core™ Ultra [XX].",
                "detailBGUrl": "assets/images/software_bundle_ptl12xe_bg.png",
                "badgeUrl1": "assets/images/arc-badge.svg",
                "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                "tr_subtitle1": "Оберіть одну 6-місячну підписку:",
                "titleArray": [
                  {
                    "tr_title": "План для фотографів Adobe Creative Cloud",
                    "imgUrl": "assets/images/ptl_adobe_cloud.svg"
                  },
                  {
                    "tr_title": "Adobe Premiere Pro",
                    "imgUrl": "assets/images/ptl_adobe_premiere.svg"
                  }
                ],
                "tr_subtitle2": "© 2025 Electronic Arts Inc. Battlefield — торгова марка Electronic Arts Inc. © 2025 BOHEMIA INTERACTIVE a.s. © 2025 Adobe. Усі права захищені. ©Intel® Corporation. Скористайтеся до 15 липня 2026 року. Застосовуються умови."
              }
            },
            {
              "tr_pretitle": "<span class='ptl12xe-aidemos-tile-pretitle'>Демо</span> ШІ",
              "tr_tileTitle": "Перевірте силу штучного інтелекту в дії",
              "tileUrlName": "aidemos",
              "tileBadgeUrl": "assets/images/ptl_ai_demos_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "",
                "tr_subtitle": "",
                "detailBGUrl": ""
              }
            },
            {
              "tr_pretitle": "Виміряйте <span class='ptl12xe-ulthreedmark-tile-pretitle'>частоту кадрів</span>",
              "tr_tileTitle": "Перевірте, яку частоту кадрів виконують ваші ігри.",
              "tileUrlName": "ulthreedmark",
              "tileBadgeUrl": "assets/images/ptl_XE_fps_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "",
                "tr_subtitle": "",
                "detailBGUrl": ""
              }
            },
            {
              "tr_pretitle": "Демонстрація <span class='ptl12xe-aishowcase-tile-pretitle'>ШІ</span>",
              "tr_tileTitle": "Дізнайтеся про можливості та застосунки на базі ШІ",
              "tileUrlName": "aishowcase",
              "tileBadgeUrl": "assets/images/ptl_XE_ai_showcase_tile.png"
            },
            {
              "tr_tileTitle": "Безкоштовно — PCmover* Express — найпростіший спосіб перейти на новий ПК!",
              "tileUrlName": "pcmover",
              "tileBadgeUrl": "assets/images/ptl_XE_pc_mover_tile.png"
            },
            {
              "tr_tileTitle": "Пакет програмного забезпечення для творчості для ПК із підтримкою ШІ",
              "tileUrlName": "ai-pc-bundle",
              "tileBadgeUrl": "assets/images/ptl-ai-pc-bundle_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "PANTHER_LAKE_GAMING",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_pretitle": "Серйозні ігри. Нуль зайвого об’єму.",
              "tr_tileTitle": "Оптимізована продуктивність для підтримки ваших улюблених застосунків, ігор тощо.",
              "tileUrlName": "processor",
              "tileBadgeUrl": "assets/images/ptl_gaming_processor_tile.png"
            },
            {
              "tr_pretitle": "Виміряйте <span class='ptl-ulthreedmark-tile-pretitle'>частоту кадрів</span>",
              "tr_tileTitle": "Перевірте, яку частоту кадрів виконують ваші ігри.",
              "tileUrlName": "ulthreedmark",
              "tileBadgeUrl": "assets/images/ptl_gaming_fps_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_title": "",
                "tr_subtitle": ""
              }
            },
            {
              "tr_tileTitle": "ШІ, який дійсно стане в нагоді",
              "tileUrlName": "ptl-battlefield6",
              "tileBadgeUrl": "assets/images/ptl_gaming_battlefield6_tile.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "tr_title": "ШІ-масштабування зображення",
                "tr_subtitle": "Насолоджуйтесь ультраплавною грою з високою частотою кадрів завдяки інтелектуальному масштабуванню та генерації кадрів на основі ШІ з підтримкою <span class='ptl-battlefield6-font'>Intel® X<sup>e</sup> Super Sampling 3</span> (X<sup>e</sup>SS 3) — щоб ігри виглядали приголомшливо навіть у режимі роботи від батареї.",
                "detailBGUrl": "assets/videos/gaming/ptl-battlefield6.mp4",
                "adlobimgUrl": "assets/images/gaming/ptl-genaralAdlob.png"
              }
            },
            {
              "tr_pretitle": "Демонстрація <span class='ptl-aishowcase-tile-pretitle'>ШІ</span>",
              "tr_tileTitle": "Дізнайтеся про можливості та застосунки на базі ШІ",
              "tileUrlName": "aishowcase",
              "tileBadgeUrl": "assets/images/ptl_gaming_ai_showcase_tile.png"
            },
            {
              "tr_tileTitle": "Грайте як профі",
              "tileUrlName": "playlikepro",
              "tileBadgeUrl": "assets/images/ptl_gaming_play_like_pro_tile.png"
            },
            {
              "tr_tileTitle": "Пакет програмного забезпечення для творчості для ПК із підтримкою ШІ",
              "tileUrlName": "ai-pc-bundle",
              "tileBadgeUrl": "assets/images/ptl-ai-pc-bundle_tile.png"
            }
          ]
        }
      ]
    },
    {
      "tilesType": "WILDCAT_LAKE_STANDARD",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_pretitle": "Повнофункціональні застосунки без проблем із сумісністю.",
              "tr_tileTitle": "Зробіть правильний вибір і забудьте про сумніви.",
              "tileUrlName": "gaming",
              "tileBadgeUrl": "assets/images/wcl/wcl-gaming-tile-bg.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/videos/wcl/wcl-gaming-detail-bg.mp4",
                "videoPosterUrl": "assets/images/wcl/wcl_gaming_poster.png",
                "tr_title": "Повноцінні версії всього — особливо ігор.",
                "tr_subtitle": "Не обмежуйтеся ноутбуком, який по суті є великим смартфоном. Оскільки це повноцінна ПК-платформа, вона одразу запускає звичне для вас програмне забезпечення і ваші улюблені ігри — зокрема багато застосунків та ігор, що не підтримуються в системах ARM або macOS."
              }
            },
            {
              "tr_pretitle": "Розумний вибір на довгі роки.",
              "tr_tileTitle": "Створено з розрахунком на майбутнє, на відміну від старіших систем.",
              "tileUrlName": "ai-experience",
              "tileBadgeUrl": "assets/images/wcl/wcl-ai-experience-tile-bg.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/videos/wcl/wcl-ai-experience-detail-bg.mp4",
                "videoPosterUrl": "assets/images/wcl/wcl_ai_poster.png",
                "tr_title": "Створено з розрахунком на майбутнє, на відміну від старіших систем.",
                "tr_subtitle": "Це найсучасніше покоління наших повсякденних ноутбуків зі штучним інтелектом. Він уже сьогодні непомітно покращує виконання повсякденних завдань та гарантує, що пристрій буде готовий, коли ще більше програм почнуть використовувати ШІ, продовжуючи термін його актуальності порівняно зі старішими системами."
              }
            },
            {
              "tr_pretitle": "Тривалий ресурс акумулятора та застосунки, які просто працюють.",
              "tr_tileTitle": "Транслюйте улюблений контент довше без підзаряджання.",
              "tileUrlName": "battery",
              "tileBadgeUrl": "assets/images/wcl/wcl-battery-tile-bg.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/lang/[XX]/wcl/wcl-battery-detail-bg.mp4",
                "videoPosterUrl": "assets/lang/[XX]/wcl/wcl_battery_poster.png",
                "tr_title": "Створено для роботи від акумулятора протягом <span class='wcl-ddp-highlight'>усього дня</span><sup>67</sup>.",
                "tr_subtitle": "Інтелектуальне енергоспоживання подовжує час роботи вашого ноутбука — так само, як у смартфонів, — у застосунках, якими ви користуєтеся найчастіше. Отримайте до:",
                "titleArray1": [
                  {
                    "tr_title": "<span class='wcl-ddp-highlight'>18,5 години</span> ресурсу акумулятора для перегляду відео на Netflix*<sup>70</sup>."
                  },
                  {
                    "tr_title": "<span class='wcl-ddp-highlight'>12,5 години</span> ресурсу акумулятора під час користування офісними застосунками<sup>70</sup>."
                  }
                ]
              }
            },
            {
              "tr_pretitle": "Створено для реального життя.",
              "tr_tileTitle": "Розумніша продуктивність, а не просто більше ядер.",
              "tileUrlName": "performance",
              "tileBadgeUrl": "assets/images/wcl/wcl-performance-tile-bg.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "assets/videos/wcl/wcl-performance-detail-bg.mp4",
                "videoPosterUrl": "assets/images/wcl/wcl_performance_poster.png",
                "tr_title": "Створено для реального життя.",
                "tr_subtitle": "Від Zoom* та Microsoft* Office до застосунків Google* та хмарних інструментів — процесори Intel® Core™ серії 3 оптимізовані для програмного забезпечення, яким ви користуєтеся щодня. Забезпечують до:",
                "titleArray1": [
                  {
                    "tr_title": "<span class='wcl-ddp-highlight'>60% кращу</span> продуктивність під час роботи з офісними застосунками порівняно<br/>з конкуруючими системами дворічної давності<sup>68</sup>."
                  }
                ]
              }
            },
            {
              "tr_pretitle": "Купуйте один раз і купуйте правильно.",
              "tr_tileTitle": "Тренди минають, надійність залишається.",
              "tileUrlName": "reliability",
              "tileBadgeUrl": "assets/images/wcl/wcl-reliability-tile-bg.png",
              "tileDetails": {
                "panelType1": "ptl-tile-panel",
                "panelType2": "",
                "detailBGUrl": "",
                "tr_title": "",
                "tr_subtitle": "",
                "badgeIcons": [
                  {
                    "badgeUrl": "assets/images/wcl/wcl-reliability-icon1.svg"
                  },
                  {
                    "badgeUrl": "assets/images/wcl/wcl-reliability-icon2.svg"
                  },
                  {
                    "badgeUrl": "assets/images/wcl/wcl-reliability-icon3.svg"
                  }
                ],
                "titleArray": [
                  {
                    "imgUrl": "assets/videos/wcl/wcl-reliability-detail-bg1.mp4",
                    "videoPosterUrl": "assets/images/wcl/wcl_reliability_poster1.png",
                    "tr_title": "Вебсторінки працюють помітно швидше.",
                    "tr_subtitle": "До 45% вища продуктивність під час перегляду вебсторінок<sup>69</sup> порівняно зі старішою системою."
                  },
                  {
                    "imgUrl": "assets/videos/wcl/wcl-reliability-detail-bg2.mp4",
                    "videoPosterUrl": "assets/images/wcl/wcl_reliability_poster2.png",
                    "tr_title": "Робота у Word*, Excel*, PowerPoint* та Outlook* стає швидшою та комфортнішою",
                    "tr_subtitle": "Загальна продуктивність в офісних застосунках до <span class='wcl-ddp-highlight'>39% вища</span><sup>69</sup>, ніж у старішого ноутбука.​"
                  },
                  {
                    "imgUrl": "assets/videos/wcl/wcl-reliability-detail-bg3.mp4",
                    "videoPosterUrl": "assets/images/wcl/wcl_reliability_poster3.png",
                    "tr_title": "Intel® Wi-Fi 7 та Intel® Bluetooth® Core 6.0 із розширеним радіусом дії",
                    "tr_subtitle": "<span class='wcl-ddp-highlight'>Наше найшвидше та найнадійніше</span> підключення для повсякденних ноутбуків. ​"
                  }
                ]
              }
            },
            {
              "tr_pretitle": "Перевірте силу штучного інтелекту в дії",
              "tr_tileTitle": "<span class='wcl-aidemos-text'>Демо</span> ШІ",
              "tileUrlName": "ai-demos",
              "tileBadgeUrl": "assets/images/wcl/wcl-ai-demos-tile-bg.png"
            },
            {
              "tr_pretitle": "Пакет програмного забезпечення для творчості для ПК із підтримкою ШІ",
              "tr_tileTitle": "",
              "tileUrlName": "ai-pc-bundle",
              "tileBadgeUrl": "assets/images/wcl/wcl-ai-pc-bundle-tile-bg.png"
            }
          ]
        }
      ]
    }
  ],
  "samsungOled": [
    {
      "panelType": "oled_first_panel",
      "badgeUrl": "assets/images/oled/OLED_logo.svg"
    },
    {
      "panelType": "oled_second_panel",
      "tr_header": "Samsung OLED:<br/>насправді милує око",
      "tr_sub_header": "Синє світло може викликати зоровий дискомфорт і порушити цикл сну. OLED-дисплеї Samsung із сертифікацією Eye Care від SGS, не змінюють кольори, а навпаки, зменшують довжину хвилі потенційно шкідливого синього світла, забезпечуючи комфорт для очей і знижуючи їхню втому.",
      "badgeUrl": "assets/images/oled/oled-graph.svg",
      "tr_title1": "Менш шкідливе синє світло"
    },
    {
      "panelType": "oled_third_panel",
      "tr_header": "Ультра з усіх боків",
      "tr_sub_header": "Ультралегкий та ультратонкий дизайн OLED-дисплеїв забезпечує максимальну якість зображення за мінімальної ваги."
    },
    {
      "panelType": "oled_fourth_panel",
      "tr_header": "Справжній чорний",
      "tr_sub_header": "0,0005 ніт"
    },
    {
      "panelType": "oled_fifth_panel",
      "tr_header": "74%<br/><span class='conventional_text'>Звичайний</span>",
      "tr_sub_header": "120%<br/><span class='samsungoled_text'>OLED-дисплей Samsung</span>"
    }
  ],
  "rebuildUsageModel": [
    {
      "tilesType": "STANDARD_REBUILD_I3",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Трансляція",
              "tileUrlName": "streaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/streaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_streaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ТРАНСЛЯЦІЯ",
                "tr_subtitle": "Неймовірні можливості для розваг",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для трансляцій:",
                "tileBG": "#794584",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може транслювати відео у форматі HD."
                  },
                  {
                    "tr_title": "Дисплей, що відтворює яскраві зображення."
                  },
                  {
                    "tr_title": "Wi‑Fi, який забезпечує менший час буферизації та завантаження."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Перегляд вебсторінок",
              "tileUrlName": "webbrowsing",
              "tileBadgeUrl": "assets/images/standard/rebuild/webbrowsing.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_webbrowsing.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ПЕРЕГЛЯД ВЕБСТОРІНОК",
                "tr_subtitle": "Інтернет — це просто",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для перегляду вебсторінок:",
                "tileBG": "#87A944",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може швидко завантажувати мультимедійні сторінки."
                  },
                  {
                    "tr_title": "Швидкий і надійний Wi‑Fi."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Відеочат",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВІДЕОЧАТ",
                "tr_subtitle": "Безперебійне підключення",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для відеочатів:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може одночасно записувати та обмінюватися зображеннями."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Вебкамера, яка допомагає бачити кришталево чисті зображення."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I5",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Високошвидкісна багатозадачність",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИСОКОШВИДКІСНА БАГАТОЗАДАЧНІСТЬ",
                "tr_subtitle": "Робіть більше, не&nbsp;сповільнюючись",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для роботи в режимі багатозадачності:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може опрацьовувати декілька програм одночасно."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє перемикатися між програмами без перешкод."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Відеочат",
              "tileUrlName": "videochatting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videochatting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videochatting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВІДЕОЧАТ",
                "tr_subtitle": "Безперебійне підключення",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для відеочатів:",
                "tileBG": "#E96115",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може одночасно записувати та обмінюватися зображеннями."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Вебкамера, яка допомагає бачити кришталево чисті зображення."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Казуальні ігри",
              "tileUrlName": "casualgaming",
              "tileBadgeUrl": "assets/images/standard/rebuild/casualgaming.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_casualgaming.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "КАЗУАЛЬНІ ІГРИ",
                "tr_subtitle": "Час грати",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для простих ігор:",
                "tileBG": "#000000",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який забезпечує безперебійний ігровий процес."
                  },
                  {
                    "tr_title": "Пам’ять, яка одночасно підтримує голосовий чат і трансляцію."
                  },
                  {
                    "tr_title": "Графіка, що створює дивовижні зображення."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Редагування фото",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАГУВАННЯ ФОТО",
                "tr_subtitle": "Ідеальні фотографії до останнього пікселя",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для редагування фотографій:",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "Процесор, здатний редагувати великі групи зображень."
                  },
                  {
                    "tr_title": "Пам’ять, яка прискорює роботу ПЗ для редагування."
                  },
                  {
                    "tr_title": "Технологія Thunderbolt™&nbsp;4 дозволяє швидко передавати файли."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I7",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "Високошвидкісна багатозадачність",
              "tileUrlName": "highspeed",
              "tileBadgeUrl": "assets/images/standard/rebuild/highspeed.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_highspeed.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "ВИСОКОШВИДКІСНА БАГАТОЗАДАЧНІСТЬ",
                "tr_subtitle": "Робіть більше, не&nbsp;сповільнюючись",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для роботи в режимі багатозадачності:",
                "tileBG": "#0093C7",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може опрацьовувати декілька програм одночасно."
                  },
                  {
                    "tr_title": "Швидкий та надійний зв'язок, потужний сигнал Wi‑Fi."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє перемикатися між програмами без перешкод."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Спільна робота в режимі реального часу",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СПІЛЬНА РОБОТА В РЕЖИМІ РЕАЛЬНОГО ЧАСУ",
                "tr_subtitle": "Працюйте з будь-якого місця",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для співпраці в Інтернеті:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процесор, що підтримує офісне програмне забезпечення."
                  },
                  {
                    "tr_title": "Wi‑Fi, на який можна покластися."
                  },
                  {
                    "tr_title": "Вебкамера, яка записує відео з високою роздільною здатністю."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Редагування відео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАГУВАННЯ ВІДЕО",
                "tr_subtitle": "Творіть магію кіно",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для редагування відео:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може обробляти великі файли."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє швидко й без перешкод редагувати файли мультимедіа."
                  },
                  {
                    "tr_title": "Графіка, яка скорочує час обробки відео."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Редагування фото",
              "tileUrlName": "photoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/photoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_photoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАГУВАННЯ ФОТО",
                "tr_subtitle": "Ідеальні фотографії до останнього пікселя",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для редагування фотографій:",
                "tileBG": "#659FBA",
                "titleArray": [
                  {
                    "tr_title": "Процесор, здатний редагувати великі групи зображень."
                  },
                  {
                    "tr_title": "Пам’ять, яка прискорює роботу ПЗ для редагування."
                  },
                  {
                    "tr_title": "Технологія Thunderbolt™&nbsp;4 дозволяє швидко передавати файли."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    {
      "tilesType": "STANDARD_REBUILD_I9",
      "tilesDeviceTypes": [
        {
          "deviceType": "DEFAULT",
          "tilesDetails": [
            {
              "tr_tileTitle": "[processor_value]",
              "tileUrlName": "processor",
              "tileBadgeUrl": "[processor_badge]"
            },
            {
              "tr_tileTitle": "Редагування відео",
              "tileUrlName": "videoediting",
              "tileBadgeUrl": "assets/images/standard/rebuild/videoediting.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_videoediting.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "РЕДАГУВАННЯ ВІДЕО",
                "tr_subtitle": "Творіть магію кіно",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для редагування відео:",
                "tileBG": "#00376D",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може обробляти великі файли."
                  },
                  {
                    "tr_title": "Пам’ять, яка дозволяє швидко й без перешкод редагувати файли мультимедіа."
                  },
                  {
                    "tr_title": "Графіка, яка скорочує час обробки відео."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "3D-моделювання",
              "tileUrlName": "threedmodeling",
              "tileBadgeUrl": "assets/images/standard/rebuild/threedmodeling.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_threedmodeling.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "3D-МОДЕЛЮВАННЯ",
                "tr_subtitle": "Творчість на новому рівні",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для 3D-моделювання:",
                "tileBG": "#00285A",
                "titleArray": [
                  {
                    "tr_title": "Процесор, який може працювати з передовим програмним забезпеченням для творчості."
                  },
                  {
                    "tr_title": "Пам’ять, яка дає змогу швидко обробляти великі файли."
                  },
                  {
                    "tr_title": "Потужна графіка, яка дозволяє створювати та редагувати зображення."
                  }
                ]
              }
            },
            {
              "tr_tileTitle": "Спільна робота в режимі реального часу",
              "tileUrlName": "realtime",
              "tileBadgeUrl": "assets/images/standard/rebuild/realtime.svg",
              "tileBadgeUrl1": "assets/images/standard/rebuild/detailpage_realtime.svg",
              "tileDetails": {
                "panelType1": "rebuild-usage-panel",
                "tr_title": "СПІЛЬНА РОБОТА В РЕЖИМІ РЕАЛЬНОГО ЧАСУ",
                "tr_subtitle": "Працюйте з будь-якого місця",
                "tr_subtitle1": "Ось що робить цей ПК ідеальним для співпраці в Інтернеті:",
                "tileBG": "#D42931",
                "titleArray": [
                  {
                    "tr_title": "Процесор, що підтримує офісне програмне забезпечення."
                  },
                  {
                    "tr_title": "Wi‑Fi, на який можна покластися."
                  },
                  {
                    "tr_title": "Вебкамера, яка записує відео з високою роздільною здатністю."
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  ],
  "unison": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "unison-panel",
    "tr_tileTitle": "Застосунок Intel® Unison™",
    "tr_title": "Відкрийте цілий світ підключень",
    "tr_subtitle": "Легко передавайте файли й фотографії, одночасно керуючи телефонними сповіщеннями, відповідаючи на дзвінки та текстові повідомлення зі свого ПК<sup>18</sup>.",
    "detailBGUrl": "assets/images/unison/unison_panel1_img.png",
    "tileBG": "assets/images/unison/unison_hometile_img.png",
    "titleArray": [
      {
        "tr_title": "ПЕРЕДАВАЙТЕ ФАЙЛИ Й ФОТОГРАФІЇ",
        "imgUrl": "assets/images/unison/unison_img1.png"
      },
      {
        "tr_title": "ТЕЛЕФОНУЙТЕ ТА ПРИЙМАЙТЕ ДЗВІНКИ",
        "imgUrl": "assets/images/unison/unison_img2.png"
      },
      {
        "tr_title": "НАДСИЛАЙТЕ Й ОТРИМУЙТЕ ТЕКСТОВІ ПОВІДОМЛЕННЯ",
        "imgUrl": "assets/images/unison/unison_img3.png"
      },
      {
        "tr_title": "КЕРУЙТЕ ТЕЛЕФОННИМИ СПОВІЩЕННЯМИ",
        "imgUrl": "assets/images/unison/unison_img4.png"
      },
      {
        "tr_title": "ВІДКРИЙТЕ ЦІЛИЙ СВІТ ПІДКЛЮЧЕНЬ",
        "imgUrl": "assets/images/unison/unison_img5.png"
      }
    ]
  },
  "copilot": {
    "panelType1": "gaming-tile-panel",
    "panelType2": "copilot-panel",
    "tr_tileTitle": "Робіть більше з Copilot+",
    "tr_title": "<strong><span class ='copilot_highlight'>Отримуйте більше</span> від ПК з Copilot+</strong> завдяки процесору [cpu_display] [cpuModel]",
    "badgeUrl": "assets/images/copilot_badge.png",
    "tileBG": "assets/images/copilot_hometile_img.png",
    "videoUrl": "assets/lang/[XX]/redesign/copilot_panel4.mp4",
    "detailBGUrl": "",
    "tr_pretitle": "Copilot+",
    "badgeIcons": [
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_5_9.svg",
        "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;5 (Cерія&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_7_9.svg",
        "tr_badgeIconTile": "Процесор Intel®&nbsp;Core™ Ultra&nbsp;7 (Серія&nbsp;2)",
        "tr_badgeSubTitle": ""
      },
      {
        "imgUrl": "assets/images/processor/INTEL_CORE_ULTRA_9_9.svg",
        "tr_badgeIconTile": "Процесор Intel® Core™ Ultra 9 (Серія 2)",
        "tr_badgeSubTitle": ""
      }
    ],
    "titleArray": [
      {
        "tr_title": "Динамічні субтитри",
        "tr_subtitle": "Перекладайте 44 мови англійською. <span class ='copilot_subhighlight'>Простіше.</span>",
        "imgUrl": "assets/images/copilot_panel1.png"
      },
      {
        "tr_title": "Cocreator",
        "tr_subtitle": "Ви малюєте, штучний інтелект вдосконалює. <span class ='copilot_subhighlight'>Швидше.</span>",
        "imgUrl": "assets/images/copilot_panel2.png"
      },
      {
        "tr_title": "Windows* Studio Effects",
        "tr_subtitle": "Покажіть себе з найкращого боку. <span class ='copilot_subhighlight'>Без зусиль.</span>",
        "imgUrl": "assets/images/copilot_panel3.png"
      }
    ]
  },
  "deviceReview": {
    "panelType1": "evo-mtl-video-panel",
    "tr_tileTitle": "Подивитися огляд [XX]",
    "tileBG": "assets/images/device_review_hometile.svg",
    "videoUrl": "assets/lang/[XX]/redesign/device_review_video.mp4"
  },
  "fps": [
    {
      "contentType": "PANTHER_LAKE",
      "iposTypes": [
        {
          "iposType": "GAMING",
          "deviceTypes": [
            {
              "deviceType": "Default",
              "details": {
                "tr_TileTitle": "Побачте різницю в улюблених іграх",
                "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                "detailBGUrl": "assets/images/badges/ul_3dMark.svg",
                "tr_subtitle": "Процесор <span class='processor_bold'>Intel® Core™ Ultra [XX] Серії 3 </span>може забезпечити вищу частоту кадрів на секунду та плавніший ігровий процес.",
                "tr_description": "Результати тестів враховують сукупну продуктивність виділеної графічної карти й процесора цього пристрою.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Intel® Core™ Ultra [XX] Серія 3",
                "badgeUrl1": "assets/images/badges/ul_3dMark_gaming.svg",
                "tr_legalName": "Правова інформація",
                "tr_tabName": "Юридична інформація та застереження",
                "tr_notes": "Не кожна система та конфігурація тестуватимуться безпосередньо. Представлені оцінки та дані надано UL, і вони є мірою очікуваної продуктивності на основі кількох тестових запусків кожної гри й середнього значення приблизної частоти кадрів у грі. UL тестує все обладнання в контрольованих умовах. Результати тестування можуть відрізнятися для деяких систем, але мають точність із похибкою в 3%. Зміни в програмному забезпеченні, як-от оновлення системи, оновлення драйверів або зміни в грі, можуть вплинути на продуктивність. В окремих випадках пристрій має властивість не забезпечувати стабільну продуктивність.<br/>Intel не контролює та не перевіряє дані третіх сторін. Слід звернутися до інших джерел, щоб оцінити точність."
              }
            }
          ]
        },
        {
          "iposType": "STANDARD",
          "deviceTypes": [
            {
              "deviceType": "Default",
              "details": {
                "tr_TileTitle": "Побачте різницю в улюблених іграх",
                "badgeUrl": "assets/images/badges/intel_core_ultra_series3.svg",
                "detailBGUrl": "",
                "tr_subtitle": "Процесор <span class='processor_bold'>Intel® Core™ Ultra [XX] Серії 3 </span>може забезпечити вищу частоту кадрів на секунду та плавніший ігровий процес.",
                "tr_description": "Результати тестів враховують сукупну продуктивність виділеної графічної карти й процесора цього пристрою.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "Intel® Core™ Ultra [XX] Серія 3",
                "badgeUrl1": "assets/images/badges/ul_3dMark_std.svg",
                "tr_tabName": "Юридична інформація та застереження",
                "tr_legalName": "Правова інформація",
                "tr_notes": "Не кожна система та конфігурація тестуватимуться безпосередньо. Представлені оцінки та дані надано UL, і вони є мірою очікуваної продуктивності на основі кількох тестових запусків кожної гри й середнього значення приблизної частоти кадрів у грі. UL тестує все обладнання в контрольованих умовах. Результати тестування можуть відрізнятися для деяких систем, але мають точність із похибкою в 3%. Зміни в програмному забезпеченні, як-от оновлення системи, оновлення драйверів або зміни в грі, можуть вплинути на продуктивність. В окремих випадках пристрій має властивість не забезпечувати стабільну продуктивність.<br/>Intel не контролює та не перевіряє дані третіх сторін. Слід звернутися до інших джерел, щоб оцінити точність."
              }
            }
          ]
        },
        {
          "iposType": "12XE",
          "deviceTypes": [
            {
              "deviceType": "Default",
              "details": {
                "tr_TileTitle": "Побачте різницю в улюблених іграх",
                "badgeUrl": "assets/images/badges/intel_core_ultra_[XX].svg",
                "detailBGUrl": "",
                "tr_subtitle": "Процесор <span class='processor_bold'>Intel® Core™ Ultra [XX] із вбудованою графікою Intel® Arc™</span> забезпечує вищу частоту кадрів та більш плавний ігровий процес.",
                "tr_description": "Результати тестів враховують сукупну продуктивність виділеної графічної карти й процесора цього пристрою.",
                "panelType1": "header-IconTop",
                "panelType2": "",
                "tr_title": "<span class='processor_bold'>Процесор Intel® Core™ Ultra [XX] </span>із вбудованою <span class='processor_bold'>графікою Intel® Arc™</span>",
                "badgeUrl1": "assets/images/badges/ul_3dMark_12Xe.svg",
                "tr_legalName": "Правова інформація",
                "tr_tabName": "Юридична інформація та застереження",
                "tr_notes": "Не кожна система та конфігурація тестуватимуться безпосередньо. Представлені оцінки та дані надано UL, і вони є мірою очікуваної продуктивності на основі кількох тестових запусків кожної гри й середнього значення приблизної частоти кадрів у грі. UL тестує все обладнання в контрольованих умовах. Результати тестування можуть відрізнятися для деяких систем, але мають точність із похибкою в 3%. Зміни в програмному забезпеченні, як-от оновлення системи, оновлення драйверів або зміни в грі, можуть вплинути на продуктивність. В окремих випадках пристрій має властивість не забезпечувати стабільну продуктивність.<br/>Intel не контролює та не перевіряє дані третіх сторін. Слід звернутися до інших джерел, щоб оцінити точність."
              }
            }
          ]
        }
      ]
    }
  ],
  "aiDemos": [
    {
      "processorType": "PANTHER_LAKE",
      "tr_title": "Оцініть можливості штучного інтелекту з процесором Intel® Core™ Ultra",
      "tr_subtitle": "Дізнайтеся про різноманітні сценарії використання",
      "tr_notes": "Ці демоверсії коротко надають  уявлення про можливості ШІ, які може запропонувати цей ПК",
      "badgeUrl": "assets/images/modal_close_icon.svg",
      "tileBadgeUrl": "assets/images/filter_close_icon.svg",
      "aiDemoCategory": [
        {
          "category": "creativity",
          "tr_tile": "Створення контенту",
          "titleArray": [
            {
              "title": "davinci-resolve-studio-demo",
              "tr_title": "Демоверсія DaVinci Resolve Studio",
              "imgUrl": "assets/images/davinci_studio_bg.png",
              "tileBadgeUrl": "assets/images/davinci_studio_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/davinci_studio_demo.mp4"
            },
            {
              "title": "adobe-photoshop-emo",
              "tr_title": "Демоверсія Adobe Photoshop",
              "imgUrl": "assets/images/adobe_photoshop_bg.png",
              "tileBadgeUrl": "assets/images/adobe_photoshop_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/adobe_photoshop_demo.mp4"
            }
          ]
        },
        {
          "category": "productivity",
          "tr_tile": "Продуктивність",
          "titleArray": [
            {
              "title": "microsoft-copilot-plus",
              "tr_title": "ПК з Microsoft* Copilot+",
              "imgUrl": "assets/images/copilot_plus_bg.png",
              "tileBadgeUrl": "assets/images/copilot_plus_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/copilot_plus_demo.mp4"
            },
            {
              "title": "collaboration-effects",
              "tr_title": "Ефективна співпраця",
              "imgUrl": "assets/images/collaboration_bg.png",
              "tileBadgeUrl": "assets/images/collaboration_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/collaboration_demo.mp4"
            }
          ]
        },
        {
          "category": "security",
          "tr_tile": "Безпека",
          "titleArray": [
            {
              "title": "norton-demo",
              "tr_title": "Демоверсія Norton",
              "imgUrl": "assets/images/norton_bg.png",
              "tileBadgeUrl": "assets/images/norton_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/norton_demo.mp4"
            }
          ]
        },
        {
          "category": "gaming-and-entertainment",
          "tr_tile": "Ігри та розваги",
          "titleArray": [
            {
              "title": "image-upscaling",
              "tr_title": "Масштабування зображення",
              "imgUrl": "assets/images/image_upscaling_bg.png",
              "tileBadgeUrl": "assets/images/image_upscaling_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/image_upscaling_demo.mp4"
            }
          ]
        }
      ]
    },
    {
      "processorType": "WILDCAT_LAKE",
      "tr_title": "Оцініть можливості штучного інтелекту з процесором Intel® Core™",
      "tr_subtitle": "Дізнайтеся про різноманітні сценарії використання",
      "tr_notes": "Ці демоверсії коротко надають  уявлення про можливості ШІ, які може запропонувати цей ПК",
      "badgeUrl": "assets/images/modal_close_icon.svg",
      "tileBadgeUrl": "assets/images/filter_close_icon.svg",
      "aiDemoCategory": [
        {
          "category": "creativity",
          "tr_tile": "Створення контенту",
          "titleArray": [
            {
              "title": "photoshop-elements",
              "tr_title": "Photoshop Elements",
              "imgUrl": "assets/images/wcl/ai-demo/photoshop_elements_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/adobe_badge.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/photoshop_elemets_demo.mp4"
            },
            {
              "title": "adobe-express",
              "tr_title": "Adobe Express",
              "imgUrl": "assets/images/wcl/ai-demo/adobe_express_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/adobe_badge.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/adobe_express_demo.mp4"
            },
            {
              "title": "luminar-neo",
              "tr_title": "Luminar Neo",
              "imgUrl": "assets/images/wcl/ai-demo/luminar_neo_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/luminar_neo_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/luminar_neo_demo.mp4"
            },
            {
              "title": "disctinc-ai",
              "tr_title": "Distinct AI",
              "imgUrl": "assets/images/wcl/ai-demo/disctinc_ai_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/disctinc_ai_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/disctinc_ai_demo.mp4"
            },
            {
              "title": "power-director",
              "tr_title": "Power Director",
              "imgUrl": "assets/images/wcl/ai-demo/power_director_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/power_director_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/power_director_demo.mp4"
            }
          ]
        },
        {
          "category": "productivity",
          "tr_tile": "Продуктивність",
          "titleArray": [
            {
              "title": "zoom-demo",
              "tr_title": "Демонстрація Zoom",
              "imgUrl": "assets/images/wcl/ai-demo/zoom_demo_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/zoom_demo_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/zoom_demo.mp4"
            }
          ]
        },
        {
          "category": "security",
          "tr_tile": "Безпека",
          "titleArray": [
            {
              "title": "scam-detector",
              "tr_title": "Детектор шахрайства",
              "imgUrl": "assets/images/wcl/ai-demo/scam_detector_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/scam_detector_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/wcl-ai-videos/scam_detector_demo.mp4"
            },
            {
              "title": "norton-demo",
              "tr_title": "Демоверсія Norton",
              "imgUrl": "assets/images/wcl/ai-demo/norton_bg.png",
              "tileBadgeUrl": "assets/images/wcl/ai-demo/norton_logo.png",
              "arrowUrl": "assets/images/explore_arrow.svg",
              "tileVideoUrl": "assets/lang/[XX]/videos/norton_demo.mp4"
            }
          ]
        }
      ]
    }
  ]
}